(function(){
'use strict';
/* ---------- core ---------- */
const root = document.documentElement;
root.classList.add('js');
const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
const lerp = (a, b, t) => a + (b - a) * t;
const damp = (a, b, k, dt) => a + (b - a) * (1 - Math.exp(-k * dt));
const seg = (v, a, b) => clamp((v - a) / (b - a), 0, 1);
const ease = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
const easeOut = t => 1 - Math.pow(1 - t, 3);
const backOut = t => { const c = 1.9; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); };
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches || /[?&]rm\b/.test(location.search);
const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
const money = n => '$' + n.toFixed(2);
const num = n => Math.round(n).toLocaleString('en-AU');
if (RM) root.classList.add('rm');

const BLENDS = [
  { id: 'pe', name: 'People Everyday', line: '(tastes like Coco Pops and vanilla milkshakes)', w: '#8CCDE3', ink: '#111A37', ghost: 'rgba(17,26,55,.09)', edge: '#111A37', dark: false,
    art: 'People Everyday label art: palm trees, a rolling wave and people out on the beach path',
    taste: 'A People Everyday bag in front of a stack of ice cream scoops running with caramel, under a neon sign that says Life is Sweet' },
  { id: 'nsb', name: 'No Sleep Till Brooklyn', line: '(like dipping Jaffa cakes into a dark chocolate thickshake)', w: '#F27B20', ink: '#111A37', ghost: 'rgba(17,26,55,.1)', edge: '#111A37', dark: false,
    art: 'No Sleep Till Brooklyn label art: Brooklyn street signs over a wall of boomboxes',
    taste: 'A No Sleep Till Brooklyn bag on a graffiti wall in a splash of paint, dark chocolate and orange' },
  { id: 'hyd', name: 'Hyperdrive', line: '(deep-space chocolate, with malt and honey)', w: '#111A37', ink: '#F0F0EA', ghost: 'rgba(200,136,248,.16)', edge: '#C888F8', dark: true,
    art: 'Hyperdrive label art: a spaceship firing green lasers past flying saucers over a purple canyon',
    taste: 'A Hyperdrive bag flying through a purple galaxy with chocolate malt balls' }
];
const PRICE = { '250g': 20, '1kg': 65 };
const SUB_RATE = 0.8;

/* the store. Every cart line is a real Shopify line: a variant for the size and grind (in GRINDS order) and, on a
   subscription, the Recharge selling plan for how often it is delivered. The numbers below are the store as it stood when
   this was written; inside the theme they are replaced by the store's own product data (see liveStore) */
const GRINDS = ['Wholebean', 'Ground for Espresso', 'Ground for Plunger', 'Ground for AeroPress'];
const FREQ = [1, 2, 3, 4, 5].map(n => ({ k: n + '-week', n: n, unit: 'week' }));
const weekPlans = ids => { const o = {}; ids.forEach((id, i) => { o[(i + 1) + '-week'] = id; }); return o; };
const SHOP = {
  pe: { handle: 'everyday',
    v: { '250g': [39302166773849, 42473882779737, 42473882845273, 42473882812505], '1kg': [39302166511705, 42473882681433, 42473882746969, 42473882714201] },
    plans: weekPlans([1722351705, 1722384473, 1722417241, 1722450009, 1722482777]) },
  nsb: { handle: 'no-sleep-till-brooklyn',
    v: { '250g': [39302164545625, 42474177429593, 42474177462361, 42474177495129], '1kg': [39302164283481, 42474177331289, 42474177364057, 42474177396825] },
    plans: weekPlans([1722712153, 1722744921, 1722777689, 1722810457, 1722843225]) },
  hyd: { handle: 'hyperdrive',
    v: { '250g': [39302147735641, 43142943244377, 43142943277145, 43142943309913], '1kg': [39302147473497, 43142943146073, 43142943178841, 43142943211609] },
    plans: weekPlans([1722548313, 1722581081, 1722613849, 1722646617, 1722679385]) }
};
Object.keys(SHOP).forEach(k => { SHOP[k].price = {}; SHOP[k].sub = {}; SHOP[k].out = {}; });
let SUB_PCT = 20, STORE_LIVE = false;
/* inside the theme the layout prints the three products as the store has them right now (#cflStore): variants, prices,
   what is in stock, and the Recharge plans with the price each one gives. That replaces the table above, so a price or a
   plan changed in Shopify or Recharge shows up here without touching this file */
(function liveStore() {
  const el = document.getElementById('cflStore');
  if (!el) return;
  let data; try { data = JSON.parse(el.textContent); } catch (err) { return; }
  const DAYS = { day: 1, week: 7, month: 30, year: 365 }, freq = [];
  let pct = null;
  Object.keys(SHOP).forEach(key => {
    const p = SHOP[key], d = data && data[p.handle];
    if (!d || !d.variants || !d.variants.length) return;
    d.variants.forEach(x => {
      const o = (x.o || []).map(t => String(t).toLowerCase().trim());
      const size = Object.keys(p.v).find(t => o.indexOf(t.toLowerCase()) > -1);
      const gi = GRINDS.findIndex(g => o.indexOf(g.toLowerCase()) > -1);
      if (!size || gi < 0 || !x.id) return;
      p.v[size][gi] = x.id;
      p.price[x.id] = x.price / 100;
      p.out[x.id] = x.ok === false;
      p.sub[x.id] = {};
      (x.plans || []).forEach(a => { p.sub[x.id][a.id] = a.price / 100; if (pct === null && x.price > 0) pct = Math.round((1 - a.price / x.price) * 100); });
    });
    const plans = {};
    (d.plans || []).forEach(sp => {
      let m = null;
      (sp.opts || []).forEach(t => { m = m || /^(\d+)[\s-]*(day|week|month|year)s?$/i.exec(String(t).trim()); });
      m = m || /every\s+(\d+)\s*(day|week|month|year)/i.exec(sp.name || '');
      if (!m || !sp.id) return;
      const unit = m[2].toLowerCase(), k = +m[1] + '-' + unit;
      if (!plans[k]) plans[k] = sp.id;
      if (!freq.some(f => f.k === k)) freq.push({ k: k, n: +m[1], unit: unit });
    });
    p.plans = plans; p.live = true; STORE_LIVE = true;
  });
  if (!STORE_LIVE) return;
  freq.sort((x, y) => x.n * DAYS[x.unit] - y.n * DAYS[y.unit]);
  FREQ.length = 0; freq.forEach(f => FREQ.push(f));
  if (pct !== null && pct > 0) SUB_PCT = pct;
})();
const shopOf = b => SHOP[BLENDS[b].id];
/* bundle and save (8 Oct, Jos): One for a mate takes 10% off two or more one-off 250g bags, and Pick and mix makes every third
   one-off 250g bag half price. Both are automatic discounts in the store, set not to stack, so the cart takes whichever saves
   more. Everything goes in the cart as our normal bags ("so we see the existing skus") */
const MATE = 0.1, PICK = 0.5, PICK_PAGE = 'pages/pick-and-mix';
/* the better of the two on a list of one-off 250g bag prices */
function bndBest(units) {
  const q = units.length; if (q < 2) return { amt: 0, kind: '' };
  const mate = MATE * units.reduce((a, b) => a + b, 0), s = units.slice().sort((a, b) => a - b);
  let pick = 0; for (let i = 0; i < Math.floor(q / 3); i++) pick += PICK * s[i];
  return pick > mate + 1e-9 ? { amt: pick, kind: 'pick' } : { amt: mate, kind: 'mate' };
}
let bndSo = null;
const variantOf = (b, size, grind) => shopOf(b).v[size][Math.max(0, GRINDS.indexOf(grind))];
const planOf = (b, k) => { const pl = shopOf(b).plans; return pl[k] || pl[Object.keys(pl)[0]] || 0; };
/* what one bag costs: the store's own figure when we have it, otherwise the list price less the subscription saving */
function priceOf(b, size, grind, plan, k) {
  const p = shopOf(b), id = variantOf(b, size, grind), base = p.price[id] != null ? p.price[id] : PRICE[size];
  if (plan !== 'sub') return base;
  const live = p.sub[id] && p.sub[id][planOf(b, k)];
  return live != null ? live : base * SUB_RATE;
}
const freqOf = k => FREQ.find(f => f.k === k) || FREQ[0] || { k: '', n: 0, unit: 'week' };
const everyText = k => { const f = freqOf(k); return 'every ' + (f.n === 1 ? f.unit : f.n + ' ' + f.unit + 's'); };
const freqLabel = f => (f.n === 1 ? f.unit.charAt(0).toUpperCase() + f.unit.slice(1) : f.n + ' ' + f.unit + 's');
/* 8 Oct: in a theme preview Shopify's own bar sits along the bottom of the screen (customers never get it), so the cart
   gives its last lines room to clear it */
try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') document.documentElement.classList.add('pvbar'); } catch (e) {}
/* where the pictures and songs live. A Shopify theme keeps its files in one flat folder, so the theme sets window.CFL
   before this runs: { img: '<assets url>/cfl-', aud: '<files url>/cfl-', shop: '/' }. shop switches the real checkout on */
const CFG = window.CFL || {};
const IMG = CFG.img || 'i/', AUD = CFG.aud || 'a/';
/* a picture's address. Anything already on the page keeps the exact address the page gave it (a theme adds a version to
   each one), so a picture fetched ahead of time and the same picture in the markup are one download, not two */
const PICS = {};
(function () {
  const pre = IMG.split('/').pop();
  $$('img[src], img[data-src], [data-box]').forEach(el => {
    [el.getAttribute('src'), el.getAttribute('data-src'), el.getAttribute('data-box')].forEach(u => {
      const m = u && /([\w-]+)\.webp(?:[?#]|$)/.exec(u);
      if (!m) return;
      const n = pre && m[1].indexOf(pre) === 0 ? m[1].slice(pre.length) : m[1];
      if (!PICS[n]) PICS[n] = u;
    });
  });
})();
const pic = n => PICS[n] || IMG + n + '.webp';
const REVIEWS = [
  ['It feels like a hug in a cup!', 'Kara, brewing espresso with People Everyday'],
  ['Hyper Drive isn’t just coffee, it’s fuel.', 'Jade, plunging Hyperdrive to win her day'],
  ['If coffee were a soulmate, this would be mine.', 'Abi, brewing People Everyday on her Breville'],
  ['No sleep til Brooklyn is my absolute favourite coffee beans out of all the ones i\'ve tried! So freshly roasted and smooth! 10/10 would recommend!', 'Gemma G, brewing espresso\'s with No Sleep Till Brooklyn'],
  ['PED is the ultimate all-rounder.', 'Travis, brewing People Everyday with his Moccamaster'],
  ['Honestly, it’s the kind of coffee that makes you look forward to getting out of bed.', 'John S, brewing People Everyday on his Breville'],
  ['People everyday is my absolute go-to coffee. It\'s the only beans that I\'ll have at home for the coffee machine - If it\'s not BOM.. I\'m not drinking it!', 'Amanda F, brewing espresso\'s with People Everyday'],
  ['BOM coffee is by far the best. We love that we can buy the fresh roasted beans and have them delivered to our house to enjoy at home. You won’t be disappointed!', 'Heather, brewing espresso with No Sleep Till Brooklyn'],
  ['This blend has honestly been a fan favourite since i came across it in a gift box. I would be happy to only ever buy them for the rest of my life!', 'Chloe, sipping espresso with People Everyday'],
  ['Consistently good coffee that never fails to bring a smile to my face from the first sip to the last. Anyone who has one of our (your) coffees always comments on the taste and comes back time and again.', 'Greg, trusts People Everyday for his business'],
  ['Verryyyy yummy coffee, so smooth & creamy! Have been preferring and craving coffees from home rather than buying out since we have had our People Everyday beans.', 'Ash, brewing People Everyday on her Breville'],
  ['This blend is easy to drink and tastes amazing. Doesn\'t matter how it\'s drank either espresso, long black or cold brew it\'s retains the same flavour and satisfaction.', 'Steven, brewing Hyperdrive on his Breville']
];

/* shared state, written by the scroll loop and read by everything else */
const S = {
  entered: false,
  vw: innerWidth, vh: innerHeight,
  y: 0, vel: 0,
  blend: 0,
  px: 0, py: 0,        // pointer in -1..1
  mx: -999, my: -999,  // pointer in px
  overlay: null,
  mobile: innerWidth <= 700,
  stacked: innerWidth <= 980   // blend panels flow down the page instead of stacking
};

/* toast */
const toastEl = $('#toast');
let toastT = 0;
function toast(msg) {
  toastEl.textContent = msg;
  toastEl.classList.add('show');
  clearTimeout(toastT);
  toastT = setTimeout(() => toastEl.classList.remove('show'), 2600);
}
/* always open at the top, never where the browser remembers you were */
try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (err) {}
window.scrollTo(0, 0);

/* ---------- recipes: our own, as they stand on the store's blend pages today. B is the numbers, STEPS the method, G the timed
   stages, TIPS and TROUBLE the advice. Single origins and decaf have no recipe of their own, so they run on People Everyday's ---------- */
const RECIPES = {"G":{"pe":{"plg":[[0,"POUR ALL WATER","","1000G AT 94°C"],[30,"STIR ONCE","purple","WET ALL GROUNDS"],[60,"PUT LID ON","","DON'T PLUNGE YET"],[240,"PLUNGE SLOWLY","pink","ALL THE WAY DOWN"],[270,"LET IT SETTLE","gold","2-3 MINUTES"],[420,"POUR GENTLY","g","DON'T TIP TO THE END"],[430,"DONE ✓","g","ENJOY"]],"v60":[[0,"BLOOM 30G","","WET ALL GROUNDS"],[10,"SWIRL V60","purple","MIX EVENLY"],[45,"POUR TO 150G","pink","SLOW CIRCLES"],[75,"POUR TO 250G","gold","KEEP V60 FULL"],[105,"STIR + SWIRL","purple","FLAT BED"],[150,"DRAW DOWN","gold","NEARLY THERE"],[180,"DONE ✓","g","ENJOY"]],"aero":[[0,"POUR + STIR 3X","","200G AT 93°C"],[10,"STEEP","purple","WAIT"],[90,"CAP + FLIP","pink","CAREFUL"],[100,"PRESS SLOWLY","gold","30 SECONDS"],[120,"DONE ✓","g","ADD 50-80G WATER FOR AMERICANO"]]},"nsb":{"plg":[[0,"POUR ALL WATER","","1000G AT 92°C"],[30,"STIR ONCE","purple","WET ALL GROUNDS"],[60,"PUT LID ON","","DON'T PLUNGE YET"],[240,"PLUNGE SLOWLY","pink","ALL THE WAY DOWN"],[270,"LET IT SETTLE","gold","2-3 MINUTES"],[420,"POUR GENTLY","g","DON'T TIP TO THE END"],[430,"DONE ✓","g","ENJOY"]],"v60":[[0,"BLOOM 30G","","WET ALL GROUNDS"],[10,"SWIRL V60","purple","MIX EVENLY"],[45,"POUR TO 150G","pink","SLOW CIRCLES"],[75,"POUR TO 240G","gold","KEEP V60 FULL"],[105,"STIR + SWIRL","purple","FLAT BED"],[130,"DRAW DOWN","gold","NEARLY THERE"],[150,"DONE ✓","g","ENJOY"]],"aero":[[0,"POUR + STIR 3X","","190G AT 91°C"],[10,"STEEP","purple","WAIT"],[60,"CAP + FLIP","pink","CAREFUL"],[70,"PRESS SLOWLY","gold","30 SECONDS"],[90,"DONE ✓","g","ADD 50-80G WATER FOR AMERICANO"]]},"hyd":{"plg":[[0,"POUR ALL WATER","","1000G AT 90°C"],[30,"STIR ONCE","purple","WET ALL GROUNDS"],[60,"PUT LID ON","","DON'T PLUNGE YET"],[210,"PLUNGE SLOWLY","pink","ALL THE WAY DOWN"],[240,"LET IT SETTLE","gold","2-3 MINUTES"],[390,"POUR GENTLY","g","DON'T TIP TO THE END"],[400,"DONE ✓","g","ENJOY"]],"v60":[[0,"BLOOM 40G","","WET ALL GROUNDS"],[10,"SWIRL V60","purple","MIX EVENLY"],[45,"POUR TO 150G","pink","SLOW CIRCLES"],[75,"POUR TO 250G","gold","KEEP V60 FULL"],[105,"STIR + SWIRL","purple","FLAT BED"],[130,"DRAW DOWN","gold","NEARLY THERE"],[150,"DONE ✓","g","ENJOY"]],"aero":[[0,"POUR + STIR 3X","","180G AT 88°C"],[10,"STEEP","purple","WAIT"],[60,"CAP + FLIP","pink","CAREFUL"],[70,"PRESS SLOWLY","gold","30 SECONDS"],[90,"DONE ✓","g","ADD 50-80G WATER FOR AMERICANO"]]}},"B":{"pe":{"esp":{"dose":20,"yield":40,"yl":"YIELD","time":"27-30","temp":93,"ratio":2,"grind":"FINE","ds":0.5,"ys":1,"rs":0.1,"tMin":27,"tMax":30,"hasCups":false},"plg":{"dose":15,"yield":250,"yl":"WATER","time":"7:00","temp":94,"ratio":16.67,"grind":"COARSE","ds":5,"ys":50,"rs":1,"tMin":390,"tMax":450,"hasCups":true},"v60":{"dose":15,"yield":250,"yl":"WATER","time":"3:00","temp":94,"ratio":16.67,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":165,"tMax":210,"hasCups":true},"aero":{"dose":15,"yield":200,"yl":"WATER","time":"2:00","temp":93,"ratio":13.33,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":110,"tMax":130,"hasCups":false}},"nsb":{"esp":{"dose":19.5,"yield":37,"yl":"YIELD","time":"27-30","temp":92,"ratio":1.9,"grind":"FINE","ds":0.5,"ys":1,"rs":0.1,"tMin":27,"tMax":30,"hasCups":false},"plg":{"dose":15,"yield":250,"yl":"WATER","time":"7:00","temp":92,"ratio":16.67,"grind":"COARSE","ds":5,"ys":50,"rs":1,"tMin":390,"tMax":450,"hasCups":true},"v60":{"dose":15,"yield":240,"yl":"WATER","time":"2:30","temp":92,"ratio":16,"grind":"MED-COARSE","ds":0.5,"ys":10,"rs":1,"tMin":140,"tMax":165,"hasCups":true},"aero":{"dose":15,"yield":190,"yl":"WATER","time":"1:30","temp":91,"ratio":12.67,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":80,"tMax":100,"hasCups":false}},"hyd":{"esp":{"dose":19,"yield":34,"yl":"YIELD","time":"27-30","temp":90,"ratio":1.8,"grind":"FINE","ds":0.5,"ys":1,"rs":0.1,"tMin":27,"tMax":30,"hasCups":false},"plg":{"dose":16,"yield":250,"yl":"WATER","time":"6:30","temp":90,"ratio":15.63,"grind":"COARSE","ds":5,"ys":50,"rs":1,"tMin":360,"tMax":420,"hasCups":true},"v60":{"dose":18,"yield":250,"yl":"WATER","time":"2:30","temp":90,"ratio":13.89,"grind":"MED-COARSE","ds":0.5,"ys":10,"rs":1,"tMin":140,"tMax":165,"hasCups":true},"aero":{"dose":15,"yield":180,"yl":"WATER","time":"1:30","temp":88,"ratio":12,"grind":"MEDIUM","ds":0.5,"ys":10,"rs":1,"tMin":80,"tMax":100,"hasCups":false}}},"STEPS":{"pe":{"esp":["DOSE <span class=\"h\">%Dg</span> INTO PORTAFILTER","DISTRIBUTE + TAMP FLAT","FLUSH GROUP HEAD 2S","EXTRACT <span class=\"h\">%Yg</span> IN <span class=\"h\">27-30S</span>","HONEY FLOW ✓ | GUSH = FINER | DRIP = COARSER"],"plg":["BOIL. SIT TO <span class=\"h\">94°C</span>","ADD <span class=\"h\">%Dg</span> COARSE. POUR <span class=\"h\">%Yg</span>","STIR ONCE. LID ON. WAIT <span class=\"h\">4M:00S</span>","PLUNGE SLOWLY ALL THE WAY DOWN","LET IT SETTLE <span class=\"h\">2-3 MINUTES</span>","POUR GENTLY. DON'T TIP TO THE END"],"v60":["RINSE FILTER. ADD <span class=\"h\">%Dg</span>","BLOOM <span class=\"h\">30g</span> — SWIRL TO MIX","AT 0M:45S POUR TO <span class=\"h\">150g</span>","AT 1M:15S POUR TO <span class=\"h\">%Yg</span>","STIR 1X EACH WAY. SWIRL FOR FLAT BED","DRAW DOWN BY <span class=\"h\">3M:00S</span>"],"aero":["INVERTED. ADD <span class=\"h\">%Dg</span>","POUR <span class=\"h\">%Yg</span> AT <span class=\"h\">93°C</span>. STIR 3X","CAP + FLIP AT <span class=\"h\">1M:30S</span>","PRESS SLOWLY 30S"]},"nsb":{"esp":["DOSE <span class=\"h\">%Dg</span> INTO PORTAFILTER","DISTRIBUTE + TAMP FLAT","FLUSH GROUP HEAD 2S","EXTRACT <span class=\"h\">%Yg</span> IN <span class=\"h\">27-30S</span>","DARK HONEY FLOW | ASHY = DROP TEMP"],"plg":["BOIL. SIT TO <span class=\"h\">92°C</span>","ADD <span class=\"h\">%Dg</span> COARSE. POUR <span class=\"h\">%Yg</span>","STIR ONCE. LID ON. WAIT <span class=\"h\">4M:00S</span>","PLUNGE SLOWLY ALL THE WAY DOWN","LET IT SETTLE <span class=\"h\">2-3 MINUTES</span>","POUR GENTLY. DON'T TIP TO THE END"],"v60":["RINSE FILTER. ADD <span class=\"h\">%Dg</span> MED-COARSE","BLOOM <span class=\"h\">30g</span> — SWIRL TO MIX","AT 0M:45S POUR TO <span class=\"h\">150g</span>","AT 1M:15S POUR TO <span class=\"h\">%Yg</span>","STIR 1X EACH WAY. SWIRL FOR FLAT BED","DRAW DOWN BY <span class=\"h\">2M:30S</span>"],"aero":["INVERTED. ADD <span class=\"h\">%Dg</span>","POUR <span class=\"h\">%Yg</span> AT <span class=\"h\">91°C</span>. STIR 3X","CAP + FLIP AT <span class=\"h\">1M:00S</span>","PRESS SLOWLY 30S"]},"hyd":{"esp":["DOSE <span class=\"h\">%Dg</span> INTO PORTAFILTER","DISTRIBUTE + TAMP FLAT","FLUSH GROUP HEAD 2S","EXTRACT <span class=\"h\">%Yg</span> IN <span class=\"h\">27-30S</span> SHORT + TIGHT","THICK FLOW | SYRUPY | BITTER = 89°C"],"plg":["BOIL. SIT TO <span class=\"h\">90°C</span>","ADD <span class=\"h\">%Dg</span> COARSE. POUR <span class=\"h\">%Yg</span>","STIR ONCE. LID ON. WAIT <span class=\"h\">3M:30S</span>","PLUNGE SLOWLY ALL THE WAY DOWN","LET IT SETTLE <span class=\"h\">2-3 MINUTES</span>","POUR GENTLY. DON'T TIP TO THE END"],"v60":["RINSE FILTER. ADD <span class=\"h\">%Dg</span> MED-COARSE","BLOOM <span class=\"h\">40g</span> — SWIRL TO MIX","AT 0M:45S POUR TO <span class=\"h\">150g</span>","AT 1M:15S POUR TO <span class=\"h\">%Yg</span>","STIR 1X EACH WAY. SWIRL FOR FLAT BED","DRAW DOWN BY <span class=\"h\">2M:30S</span>"],"aero":["INVERTED. ADD <span class=\"h\">%Dg</span>","POUR <span class=\"h\">%Yg</span> AT <span class=\"h\">88°C</span>. STIR 3X","CAP + FLIP AT <span class=\"h\">1M:00S</span>","PRESS SLOWLY 30S"]}},"TIPS":{"pe":{"esp":"FORGIVING BLEND. CHOCOLATE + VANILLA AT 1:2. FOR BLACK, PULL 2-3G LONGER.","plg":"CHOCOLATE SWEETNESS SHINES. DON'T RUSH — LET IT SETTLE.","v60":"SLOW CIRCLES. SWIRL AFTER LAST POUR FOR A FLAT BED.","aero":"VANILLA MILKSHAKE VIBES. ADD 50-80G HOT WATER FOR AMERICANO."},"nsb":{"esp":"DON'T OVER-EXTRACT. JAFFA AT SHORTER PULL. FOR BLACK, PULL 2-3G LONGER.","plg":"SHORTER STEEP. DARK CHOC + ORANGE COME THROUGH CLEAN.","v60":"COARSER THAN PE. JAFFA NOTES SHINE ON POUR OVER.","aero":"DARK CHOC + ORANGE POP. ADD 50-80G HOT WATER FOR AMERICANO."},"hyd":{"esp":"BURNS EASY. 89-91°C MAX. MALTESERS AT SHORT PULL. FOR BLACK, PULL 2-3G LONGER.","plg":"COOLER WATER KEY. MALTESERS SWEETNESS AT 90°C.","v60":"FAST POUR. KEEP IT MOVING. DARK ROAST V60 IS INCREDIBLE.","aero":"88°C. PURE CHOCOLATE BOMB. ADD 50-80G HOT WATER FOR AMERICANO."}},"TROUBLE":{"esp":"SOUR = GRIND FINER | BITTER = GRIND COARSER | WATERY = MORE DOSE","plg":"WEAK = MORE COFFEE | BITTER = COOLER WATER OR SHORTER BREW | SILTY = LET IT SETTLE LONGER","v60":"SOUR = GRIND FINER | BITTER = GRIND COARSER | SLOW DRAIN = COARSER GRIND","aero":"SOUR = GRIND FINER OR STEEP LONGER | BITTER = COARSER OR COOLER WATER"}};
/* what's in the cup: a picture and a name for each tasting note */
const CUP_NOTES = {
  pe: [['el-pe-cereal', 'Coco Pops'], ['el-pe-shake', 'Vanilla milkshake'], ['el-pe-popcorn', 'Popcorn']],
  nsb: [['el-nsb-jaffa', 'Jaffa cakes'], ['el-nsb-shake', 'Dark chocolate thickshake'], ['el-nsb-orange', 'Marmalade']],
  hyd: [['el-hyd-choc', 'Dark chocolate'], ['el-hyd-malt', 'Malt'], ['el-hyd-honey', 'Honey']],
  peru: [['el-hyd-choc', 'Chocolate'], ['fl-panela', 'Panela'], ['fl-driedfruit', 'Dried fruit']],
  colombia: [['fl-milkchoc', 'Milk chocolate'], ['fl-toffeeapple', 'Toffee apple']],
  brazil: [['fl-milkchoc', 'Milk chocolate'], ['fl-hazelnut', 'Hazelnut'], ['fl-toffees', 'Nan\'s toffees']],
  decaf: [['el-hyd-choc', 'Chocolate'], ['fl-driedfruit', 'Dried fruit'], ['fl-trailmix', 'Trail mix']],
  /* 9 Oct, Jos: "add the PNG and the Ethiopian". The notes are the ones printed on each bag */
  png: [['fl-cocoa', 'Cocoa nib'], ['fl-maple', 'Maple'], ['fl-plumjam', 'Plum jam']],
  ethiopia: [['fl-fruity', 'Fruity'], ['fl-floral', 'Floral'], ['fl-peachtea', 'Peach iced tea']],
  /* 9 Oct, Jos: "can we do the mexico". The notes from our Mexico listing */
  mexico: [['el-hyd-choc', 'Dark chocolate'], ['el-nsb-orange', 'Citrus'], ['fl-nutbutter', 'Nut butter']]
};
/* a single origin or the decaf borrows the People Everyday numbers, but not what that recipe says about the blend and its
   flavours. These are the parts of our own tips that hold for any coffee */
const SINGLE_TIPS = { esp: 'FOR BLACK, PULL 2-3G LONGER.', plg: 'DON\'T RUSH — LET IT SETTLE.', v60: 'SLOW CIRCLES. SWIRL AFTER LAST POUR FOR A FLAT BED.', aero: 'ADD 50-80G HOT WATER FOR AMERICANO.' };
const BREW_METHOD = { esp: 'Espresso', plg: 'Plunger', v60: 'V60', aero: 'AeroPress' };
const GRIND_FOR = { esp: 'Ground for Espresso', plg: 'Ground for Plunger', aero: 'Ground for AeroPress' };
/* how to brew each method, in a few lines: the words are the brew guide page's own. {t} is the time the clock calls that step
   for this coffee, {g} the grams of the first pour, so the how-to never argues with the plays */
const HOWTO = {
  esp: { line: 'The foundation. Get this right and everything else follows. Pressure, precision, 27 seconds of focus.', grind: 'fine, like caster sugar',
    need: ['Espresso machine', 'Grinder', 'Scale', 'Tamper'],
    steps: [['Dose and tamp', 'Dose into your portafilter. Distribute evenly and tamp flat and level.'], ['Flush the group', 'Flush the group head for 2 seconds before locking in.'], ['Extract', 'Start extracting. You\'re looking for a steady, honey-coloured flow.'], ['Weigh your yield', 'Stop at your target yield. Weigh it, don\'t guess it.']],
    fix: 'Gushing fast and tasting sour? Grind finer. Dripping slow and tasting bitter? Grind coarser. Tastes both sour and bitter? That\'s channelling. Fix your puck prep, not your grind.' },
  plg: { line: 'The easiest great coffee you\'ll ever make. Full-bodied, forgiving, and feeds a crowd. Just don\'t skip the settle.', grind: 'coarse, like raw sugar',
    need: ['Plunger', 'Grinder', 'Scale', 'Kettle'],
    steps: [['Boil and rest', 'Boil your kettle. Let it sit for 30 seconds.'], ['Add coffee and water', 'Add coffee (coarse grind). Pour all the water in with a bit of force to wet everything.'], ['Stir and steep', 'Stir once. Put the lid on. Don\'t push the plunger down yet. Wait until {t} on the clock.'], ['Plunge', 'At {t}, plunge slowly and steadily all the way down.'], ['Let it settle', 'Don\'t pour yet. Let it settle for 2-3 minutes. This is the single biggest upgrade you can make. The fine particles drop to the bottom and your cup comes out noticeably cleaner.'], ['Pour', 'Pour gently. Don\'t tip the plunger right to the end.']],
    fix: 'Weak? Use more coffee. Bitter? Use cooler water or brew for less time. Silty? Let it settle longer before pouring.' },
  v60: { line: 'Clean, bright, and reveals every nuance. The ritual brewer. Slow circles, steady pour, total control.', grind: 'medium, like sand',
    need: ['V60 dripper', 'Filters', 'Grinder', 'Gooseneck kettle', 'Scale'],
    steps: [['Rinse the filter', 'Rinse the paper filter with hot water. This removes paper taste and preheats the brewer. Discard the water.'], ['Bloom', 'Add coffee. Pour just enough water to wet all the grounds (about {g}g). This is the bloom. The bubbling means your beans are fresh.'], ['Swirl', 'Swirl the V60 gently to mix evenly.'], ['Pour in circles', 'Pour the rest of the water in slow, steady circles from the centre outward. Avoid pouring on the filter walls.'], ['Stir and draw down', 'Once all water is in, give it one stir and a gentle swirl for a flat bed. Let it draw down.']],
    fix: 'Draining too fast? Grind finer. Too slow? Grind coarser. Coffee bed should be flat at the end.' },
  aero: { line: 'The most forgiving brewer out there. Compact, fast, and near impossible to make a bad cup. Travel essential.', grind: 'medium',
    need: ['AeroPress', 'Filters', 'Grinder', 'Kettle', 'Scale'],
    steps: [['Set up inverted', 'Inverted method. Insert the plunger about 2cm into the chamber. Flip it upside down.'], ['Add and stir', 'Add coffee. Pour water. Stir 3 times.'], ['Cap it', 'Place the filter cap with a rinsed paper filter on top.'], ['Flip and press', 'At {t}, carefully flip onto your cup. Press gently and steadily for 30 seconds. Stop when you hear the hiss.'], ['Dilute (optional)', 'Want it longer? Add 50-80g of hot water for an Americano-style cup.']],
    fix: 'Too strong? Add water after. Sour? Steep longer or grind finer. Bitter? Coarser grind or cooler water.' }
};
/* the store keeps its recipes in capitals with a few shorthand marks; here they read as sentences */
function nice(t) {
  t = String(t).replace(/\s*—\s*/g, '. ').replace(/\s*✓/g, '').replace(/\s*\|\s*/g, '. ').replace(/ = /g, ': ').toLowerCase();
  t = t.replace(/(\d+)m:(\d+)s/g, '$1:$2').replace(/\b1x\b/g, 'once').replace(/\b(\d+)x\b/g, '$1 times').replace(/\bmed-coarse\b/g, 'medium coarse').replace(/\bchoc\b/g, 'chocolate').replace(/\bpe\b/g, 'People Everyday');
  t = t.replace(/(^|[.!?]\s+)([a-z])/g, (m, a, c) => a + c.toUpperCase());
  return t.replace(/°c/g, '°C').replace(/\bv60\b/gi, 'V60').replace(/\baeropress\b/gi, 'AeroPress').replace(/\bmaltesers\b/gi, 'Maltesers').replace(/\bjaffa\b/gi, 'Jaffa');
}
const mmss = sec => Math.floor(sec / 60) + ':' + String(Math.floor(sec % 60)).padStart(2, '0');

/* ---------- sound: everything is synthesised, no audio files ---------- */
const SFX = (() => {
  let ctx = null, master, bus, comp, revSend, analyser, noiseBuf, ambBus, musicIn, musicAn;
  let on = false, lastTick = 0, lastSlide = 0;
  let scene = null, want = 'none', air = null, ducked = false, musicOn = false;
  let ambOn = true, ambVol = 0.42, fxOn = true, hushed = false;   /* the three things BOM Radio can switch */
  /* which switch a sound answers to (6 Oct): 'fx' the Clicks switch (the page's own controls), 'amb' the Sound switch (the
     scene and everything in it), 'clock' the shot clock's own Beeps switch */
  let lane = 'fx', clockOn = true;
  const laneOn = () => (lane === 'amb' ? ambOn : lane === 'clock' ? clockOn : fxOn);
  function inLane(l, f, args) { const was = lane; lane = l; try { return f.apply(null, args || []); } finally { lane = was; } }
  const LEVEL = 0.85, AMB = 1.45;   /* scene sound sits under the song, a bit above where it started */
  const BEAT = 60 / 86;

  function init() {
    if (ctx) return true;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    try { ctx = new AC(); } catch (e) { ctx = null; return false; }
    master = ctx.createGain(); master.gain.value = 0;
    comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -14; comp.knee.value = 10; comp.ratio.value = 5;
    comp.attack.value = 0.003; comp.release.value = 0.18;
    bus = ctx.createGain();
    analyser = ctx.createAnalyser(); analyser.fftSize = 2048;
    bus.connect(comp); comp.connect(master); master.connect(analyser); analyser.connect(ctx.destination);

    noiseBuf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
    const d = noiseBuf.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;

    const len = Math.floor(ctx.sampleRate * 2.4);
    const ir = ctx.createBuffer(2, len, ctx.sampleRate);
    for (let c = 0; c < 2; c++) {
      const ch = ir.getChannelData(c);
      for (let i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.8);
    }
    const conv = ctx.createConvolver(); conv.buffer = ir;
    const revLP = ctx.createBiquadFilter(); revLP.type = 'lowpass'; revLP.frequency.value = 5200;
    const revOut = ctx.createGain(); revOut.gain.value = 0.5;
    revSend = ctx.createGain();
    revSend.connect(conv); conv.connect(revLP); revLP.connect(revOut); revOut.connect(bus);
    ambBus = ctx.createGain(); ambBus.gain.value = hushed ? 0 : AMB * ambVol; ambBus.connect(bus);
    /* music goes round the master so muting the site sounds never mutes a song */
    musicIn = ctx.createGain(); musicIn.gain.value = 0.9;
    musicAn = ctx.createAnalyser(); musicAn.fftSize = 256; musicAn.smoothingTimeConstant = 0.75;
    musicIn.connect(musicAn); musicAn.connect(ctx.destination);
    return true;
  }
  const live = () => !!ctx && on;
  const when = o => (o.at != null ? o.at : ctx.currentTime + (o.t || 0));

  function shape(g, t, a, d, peak) {
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(Math.max(peak, 0.0002), t + a);
    g.gain.exponentialRampToValueAtTime(0.0001, t + a + d);
  }
  function route(g, o) {
    g.connect(o.dest || bus);
    if (o.rev) { const s = ctx.createGain(); s.gain.value = o.rev; g.connect(s); s.connect(revSend); }
  }
  function tone(o) {
    if (!live() || (!o.dest && !laneOn())) return;
    const t = when(o), a = o.a || 0.004;
    const osc = ctx.createOscillator(), g = ctx.createGain();
    osc.type = o.type || 'sine';
    osc.frequency.setValueAtTime(o.f, t);
    if (o.f2) osc.frequency.exponentialRampToValueAtTime(o.f2, t + a + o.d);
    shape(g, t, a, o.d, o.g);
    osc.connect(g); route(g, o);
    osc.start(t); osc.stop(t + a + o.d + 0.05);
  }
  function noise(o) {
    if (!live() || (!o.dest && !laneOn())) return;
    const t = when(o), a = o.a || 0.002;
    const src = ctx.createBufferSource(); src.buffer = noiseBuf; src.loop = true;
    const f = ctx.createBiquadFilter(); f.type = o.type || 'bandpass';
    f.frequency.setValueAtTime(o.f, t);
    if (o.f2) f.frequency.exponentialRampToValueAtTime(o.f2, t + a + o.d);
    f.Q.value = o.q || 0.8;
    const g = ctx.createGain();
    shape(g, t, a, o.d, o.g);
    src.connect(f); f.connect(g); route(g, o);
    src.start(t, Math.random() * 1.5); src.stop(t + a + o.d + 0.05);
  }

  /* ---- scene ambience: one bed per place, crossfaded as you move through the site ---- */
  const rnd = (a, b) => a + Math.random() * (b - a);
  function bed(out, type, f, q, g) {            /* looping filtered noise */
    const n = ctx.createBufferSource(); n.buffer = noiseBuf; n.loop = true;
    const fl = ctx.createBiquadFilter(); fl.type = type; fl.frequency.value = f; fl.Q.value = q;
    const gn = ctx.createGain(); gn.gain.value = g;
    n.connect(fl); fl.connect(gn); gn.connect(out); n.start(0, Math.random() * 1.5);
    return { n: n, f: fl, g: gn };
  }
  function lfo(rate, depth, param) {
    const o = ctx.createOscillator(); o.frequency.value = rate;
    const g = ctx.createGain(); g.gain.value = depth;
    o.connect(g); g.connect(param); o.start();
    return o;
  }
  function pan(out, v) {
    if (!ctx.createStereoPanner) return out;
    const p = ctx.createStereoPanner(); p.pan.value = v; p.connect(out);
    return p;
  }
  /* a voice with its own pitch and loudness curve: pts = [[time, freq, gain], ...] */
  function voice(out, type, pts, o) {
    if (!ctx || (out === bus && (!on || !laneOn()))) return;   /* the beds pass their own bus and are faded there */
    o = o || {};
    const t0 = ctx.currentTime + (o.t || 0);
    const osc = ctx.createOscillator(); osc.type = type;
    const g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t0);
    osc.frequency.setValueAtTime(pts[0][1], t0);
    if (o.vib) { const l = ctx.createOscillator(), lg = ctx.createGain(); l.frequency.value = o.vib[0]; lg.gain.value = o.vib[1]; l.connect(lg); lg.connect(osc.frequency); l.start(t0); l.stop(t0 + pts[pts.length - 1][0] + 0.1); }
    pts.forEach(p => { osc.frequency.linearRampToValueAtTime(p[1], t0 + p[0]); g.gain.linearRampToValueAtTime(Math.max(p[2], 0.0001), t0 + p[0]); });
    let last = osc;
    if (o.bp) { const f = ctx.createBiquadFilter(); f.type = o.ft || 'bandpass'; f.frequency.value = o.bp; f.Q.value = o.q || 1; osc.connect(f); last = f; }
    last.connect(g);
    const dest = o.pan != null ? pan(out, o.pan) : out;
    g.connect(dest);
    if (o.rev) { const s = ctx.createGain(); s.gain.value = o.rev; g.connect(s); s.connect(revSend); }
    const end = pts[pts.length - 1][0];
    osc.start(t0); osc.stop(t0 + end + 0.08);
  }
  function gullCry(out, far, p) {
    const n = 2 + ((Math.random() * 4) | 0), base = rnd(1500, 2100);
    for (let k = 0; k < n; k++) {
      const f = base * (1 - k * 0.035), t = k * rnd(0.3, 0.38);
      voice(out, 'sawtooth', [[0, f * 0.82, 0], [0.05, f * 1.22, 0.05 * far], [0.12, f * 1.12, 0.045 * far], [0.3, f * 0.7, 0]], { t: t, bp: f * 1.5, q: 3.5, pan: p, rev: 0.5 });
    }
  }
  const SCENES = {
    /* People Everyday: surf rolling in, gulls overhead */
    beach(out, every) {
      const low = bed(out, 'lowpass', 420, 0.3, 0.1), mid = bed(out, 'bandpass', 900, 0.4, 0.03);
      const keep = [low, mid, lfo(0.09, 120, low.f.frequency)];
      function wave() {
        if (!live()) return;
        const t = ctx.currentTime, len = rnd(5.5, 8);
        low.g.gain.cancelScheduledValues(t); low.g.gain.setValueAtTime(low.g.gain.value, t);
        low.g.gain.linearRampToValueAtTime(0.3, t + len * 0.42); low.g.gain.linearRampToValueAtTime(0.09, t + len);
        mid.g.gain.cancelScheduledValues(t); mid.g.gain.setValueAtTime(mid.g.gain.value, t);
        mid.g.gain.linearRampToValueAtTime(0.1, t + len * 0.45); mid.g.gain.linearRampToValueAtTime(0.02, t + len);
        noise({ t: len * 0.36, a: len * 0.14, d: len * 0.5, g: 0.085, type: 'highpass', f: 1700, f2: 900, dest: out, rev: 0.12 });
      }
      function gull() { if (live() && !document.hidden) gullCry(out, rnd(0.35, 1), rnd(-0.8, 0.8)); }
      wave();
      every(wave, 6500, 9500); every(gull, 5000, 12000); setTimeout(gull, 1800);
      return keep;
    },
    /* No Sleep Till Brooklyn: traffic, horns, a siren somewhere, a boombox going past */
    street(out, every) {
      const rum = bed(out, 'lowpass', 170, 0.3, 0.26), air = bed(out, 'bandpass', 1100, 0.4, 0.022);
      const keep = [rum, air, lfo(0.13, 45, rum.f.frequency)];
      function car() {
        if (!live() || document.hidden) return;
        const dir = Math.random() < 0.5 ? -1 : 1, len = rnd(2.6, 4.2), t = ctx.currentTime;
        const n = ctx.createBufferSource(); n.buffer = noiseBuf; n.loop = true;
        const f = ctx.createBiquadFilter(); f.type = 'bandpass'; f.Q.value = 0.7;
        f.frequency.setValueAtTime(260, t); f.frequency.linearRampToValueAtTime(rnd(700, 1000), t + len * 0.5); f.frequency.linearRampToValueAtTime(220, t + len);
        const g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(rnd(0.07, 0.13), t + len * 0.5); g.gain.linearRampToValueAtTime(0.0001, t + len);
        let dest = out;
        if (ctx.createStereoPanner) { const p = ctx.createStereoPanner(); p.pan.setValueAtTime(-dir, t); p.pan.linearRampToValueAtTime(dir, t + len); p.connect(out); dest = p; }
        n.connect(f); f.connect(g); g.connect(dest); n.start(t, Math.random()); n.stop(t + len + 0.1);
      }
      function horn() {
        if (!live() || document.hidden) return;
        const p = rnd(-0.9, 0.9), base = [392, 415, 440, 466][(Math.random() * 4) | 0], far = rnd(0.4, 1);
        const beeps = Math.random() < 0.4 ? 2 : 1;
        for (let k = 0; k < beeps; k++) {
          const t = k * 0.3, d = k === beeps - 1 ? rnd(0.25, 0.6) : 0.14;
          [1, 1.26].forEach(m => voice(out, 'square', [[0, base * m, 0], [0.02, base * m, 0.022 * far], [d, base * m, 0.02 * far], [d + 0.05, base * m, 0]], { t: t, bp: 1500, ft: 'lowpass', q: 0.6, pan: p, rev: 0.6 }));
        }
      }
      function siren() {
        if (!live() || document.hidden) return;
        const pts = [[0, 640, 0]], p = rnd(-0.7, 0.7);
        for (let k = 0; k < 5; k++) { pts.push([k * 1.5 + 0.75, 960, 0.012]); pts.push([k * 1.5 + 1.5, 640, k === 4 ? 0 : 0.012]); }
        voice(out, 'triangle', pts, { bp: 1300, ft: 'lowpass', q: 0.5, pan: p, rev: 0.8 });
      }
      function boombox() {           /* someone walks past with the stereo up */
        if (!live() || document.hidden) return;
        const t0 = ctx.currentTime + 0.1, g = ctx.createGain(), lp = ctx.createBiquadFilter();
        lp.type = 'lowpass'; lp.frequency.value = 420;
        g.gain.setValueAtTime(0.0001, t0); g.gain.linearRampToValueAtTime(0.5, t0 + BEAT * 4); g.gain.linearRampToValueAtTime(0.0001, t0 + BEAT * 8);
        lp.connect(g); g.connect(out);
        [0, 1.75, 2.5, 4, 5.75, 6.5].forEach(b => tone({ at: t0 + b * BEAT, f: 130, f2: 44, d: 0.24, g: 0.5, dest: lp }));
        [1, 3, 5, 7].forEach(b => noise({ at: t0 + b * BEAT, d: 0.12, g: 0.3, type: 'bandpass', f: 900, q: 0.8, dest: lp }));
        setTimeout(() => { try { g.disconnect(); } catch (e) {} }, BEAT * 9000);
      }
      every(car, 2800, 6500); every(horn, 7000, 17000); every(siren, 38000, 70000); every(boombox, 26000, 44000);
      setTimeout(car, 400); setTimeout(horn, 3200); setTimeout(boombox, 9000);
      return keep;
    },
    /* Hyperdrive: engine drone, solar wind, pings and bleeps */
    space(out, every) {
      const lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 230;
      const dg = ctx.createGain(); dg.gain.value = 0.05; lp.connect(dg); dg.connect(out);
      const keep = [lfo(0.05, 90, lp.frequency)];
      [[55, 'sawtooth'], [55.35, 'sawtooth'], [82.4, 'sine'], [110.3, 'sine'], [36.7, 'sine']].forEach(v => {
        const o = ctx.createOscillator(); o.type = v[1]; o.frequency.value = v[0]; o.connect(lp); o.start(); keep.push(o);
      });
      const wind = bed(out, 'bandpass', 2600, 5, 0.02);
      keep.push(wind, lfo(0.045, 1500, wind.f.frequency), lfo(0.11, 0.012, wind.g.gain));
      function ping() {
        if (!live() || document.hidden) return;
        const f = [660, 880, 990, 1320][(Math.random() * 4) | 0];
        tone({ f: f, d: 1.9, g: 0.03, a: 0.006, dest: out, rev: 1 });
        tone({ t: 0.42, f: f, d: 1.2, g: 0.008, a: 0.006, dest: out, rev: 1 });
      }
      function bleeps() {
        if (!live() || document.hidden) return;
        const n = 4 + ((Math.random() * 5) | 0);
        for (let k = 0; k < n; k++) tone({ t: k * 0.075, f: rnd(1100, 2600), d: 0.045, g: 0.012, type: 'square', dest: out, rev: 0.4 });
      }
      function sweep() {
        if (!live() || document.hidden) return;
        noise({ a: 1.6, d: 2.2, g: 0.03, type: 'bandpass', f: 300, f2: 3400, q: 3, dest: out, rev: 0.5 });
      }
      every(ping, 5500, 10000); every(bleeps, 8000, 15000); every(sweep, 16000, 28000);
      setTimeout(ping, 1200);
      return keep;
    },
    /* the roastery: Betty's drum turning, beans cracking, the burner */
    roast(out, every) {
      const drum = bed(out, 'lowpass', 150, 0.4, 0.2), hiss = bed(out, 'highpass', 5200, 0.3, 0.008), tumble = bed(out, 'bandpass', 2300, 0.9, 0.012);
      const keep = [drum, hiss, tumble, lfo(0.85, 0.07, drum.g.gain), lfo(1.7, 0.006, tumble.g.gain)];
      function crack() {
        if (!live() || document.hidden || Math.random() > 0.5) return;
        noise({ t: Math.random() * 0.12, d: rnd(0.005, 0.016), g: rnd(0.012, 0.045), type: 'highpass', f: rnd(1800, 5000), dest: out });
      }
      function clank() {
        if (!live() || document.hidden) return;
        const f = rnd(520, 760);
        tone({ f: f, d: 0.16, g: 0.016, type: 'triangle', dest: out, rev: 0.7 });
        tone({ f: f * 1.51, d: 0.1, g: 0.01, type: 'triangle', dest: out, rev: 0.7 });
      }
      every(crack, 120, 160); every(clank, 9000, 19000);
      return keep;
    },
    /* a cafe in service: the room, cups, the steam wand, the grinder */
    cafe(out, every) {
      const room = bed(out, 'lowpass', 380, 0.3, 0.07);
      const keep = [room];
      for (let k = 0; k < 6; k++) {          /* a murmur of voices: narrow bands of noise that swell at talking speed */
        const v = bed(out, 'bandpass', rnd(280, 1300), 4, 0.0);
        keep.push(v, lfo(rnd(2.2, 5), 0.02, v.g.gain), lfo(rnd(0.15, 0.4), 0.014, v.g.gain));
        v.g.gain.value = 0.02;
      }
      function clink() {
        if (!live() || document.hidden) return;
        const f = rnd(2300, 4200), p = rnd(-0.8, 0.8), n = Math.random() < 0.4 ? 2 : 1;
        for (let k = 0; k < n; k++) voice(out, 'sine', [[0, f * (1 + k * 0.06), 0], [0.004, f * (1 + k * 0.06), 0.02], [0.12, f * (1 + k * 0.06), 0]], { t: k * 0.09, pan: p, rev: 0.6 });
      }
      function steam() {
        if (!live() || document.hidden) return;
        noise({ a: 0.25, d: rnd(1.6, 2.6), g: 0.035, type: 'highpass', f: 3600, dest: out, rev: 0.25 });
        noise({ t: 0.2, a: 0.2, d: 1.6, g: 0.016, type: 'bandpass', f: 700, f2: 1500, q: 2.5, dest: out });
      }
      function grind() {
        if (!live() || document.hidden) return;
        noise({ a: 0.08, d: rnd(1.2, 1.9), g: 0.028, type: 'bandpass', f: 1100, q: 1.3, dest: out, rev: 0.2 });
        tone({ f: 118, d: 1.5, g: 0.012, type: 'sawtooth', a: 0.06, dest: out });
      }
      every(clink, 3500, 9000); every(steam, 14000, 26000); every(grind, 24000, 40000);
      setTimeout(clink, 900); setTimeout(steam, 5000);
      return keep;
    }
  };
  function stopScene(sc, fade) {
    sc.timers.forEach(t => clearTimeout(t)); sc.timers.length = 0; sc.dead = true;
    const t = ctx.currentTime;
    try { sc.out.gain.cancelScheduledValues(t); sc.out.gain.setValueAtTime(sc.out.gain.value, t); sc.out.gain.linearRampToValueAtTime(0, t + fade); } catch (e) {}
    setTimeout(() => {
      sc.keep.forEach(k => { try { (k.n || k).stop(); } catch (e) {} });
      try { sc.out.disconnect(); } catch (e) {}
    }, fade * 1000 + 200);
  }
  function setScene(name) {
    want = SCENES[name] ? name : 'none';
    if (!ctx || !on) return;
    if (scene && scene.name === want) return;
    if (scene) { stopScene(scene, 1.4); scene = null; }
    if (want === 'none') return;
    const out = ctx.createGain(); out.gain.value = 0.0001; out.connect(ambBus);
    out.gain.linearRampToValueAtTime(1, ctx.currentTime + 1.6);
    const sc = { name: want, out: out, timers: [], dead: false, keep: [] };
    const every = (fn, a, b) => {           /* call fn again and again, a..b ms apart, until the scene ends */
      const loop = () => { if (sc.dead) return; fn(); sc.timers.push(setTimeout(loop, rnd(a, b))); };
      sc.timers.push(setTimeout(loop, rnd(a, b)));
    };
    sc.keep = SCENES[want](out, every) || [];
    scene = sc;
  }
  function duck() {
    if (!ctx) return;
    const t = ctx.currentTime;
    ambBus.gain.cancelScheduledValues(t); ambBus.gain.setValueAtTime(ambBus.gain.value, t);
    ambBus.gain.linearRampToValueAtTime(ambOn && !hushed && !musicOn ? AMB * ambVol : 0, t + (musicOn ? 0.9 : 0.6));   /* 8 Oct (Jos): the scene rests while our music plays */
  }

  /* phones: tell the system this is playback, so the ring switch on silent doesn't mute the scene and button sounds while the music plays on */
  function session(v) {
    try { if (navigator.audioSession) navigator.audioSession.type = v ? 'playback' : 'auto'; } catch (e) {}
  }
  function setOn(v) {
    if (v && !init()) return false;
    on = !!v;
    if (!ctx) return false;
    const t = ctx.currentTime;
    master.gain.cancelScheduledValues(t);
    master.gain.setValueAtTime(master.gain.value, t);
    session(on);
    if (on) {
      if (ctx.state !== 'running' && ctx.resume) ctx.resume();
      master.gain.linearRampToValueAtTime(LEVEL, t + 0.4);
      setScene(want);
      setTimeout(() => { if (on) warm(['scratch', 'scratch2', 'station', 'station2']); }, 2500);
      setTimeout(() => { if (on) warm(['betty']); }, 9000);
    } else {
      if (scene) { stopScene(scene, 0.3); scene = null; }
      master.gain.linearRampToValueAtTime(0, t + 0.3);
      setTimeout(() => { if (!on && !musicOn && ctx.suspend) ctx.suspend(); }, 600);
    }
    return on;
  }

  /* ---- recorded sounds: the few things a synth can't fake (a crowd, a real scratch). Each kind has one or more takes;
     a kind with no take recorded yet falls back to the synth. Files sit beside the songs as sfx-<take>.mp3 ---- */
  const TAKES = { applause: ['applause'], betty: ['betty'], scratch: ['scratch'], scratch2: ['scratch2'], station: ['station'], station2: ['station2'] };
  const takes = {}, turn = {}, going = {};
  function loadTake(name) {
    if (name in takes) return;
    takes[name] = null;
    fetch(AUD + 'sfx-' + name + '.mp3').then(r => { if (!r.ok) throw new Error('missing'); return r.arrayBuffer(); })
      .then(b => new Promise((ok, no) => ctx.decodeAudioData(b, ok, no)))
      .then(buf => { takes[name] = buf; }).catch(() => { takes[name] = false; });
  }
  function warm(kinds) { if (ctx) (kinds || Object.keys(TAKES)).forEach(k => TAKES[k].forEach(loadTake)); }
  /* plays the next take of a kind and says how long it runs; 0 means nothing recorded is ready */
  function sample(kind, o) {
    if (!live() || !ambOn) return 0;   /* every recorded take is part of the scene: Betty, the records, the crowd, the station */
    const list = TAKES[kind] || [];
    if (!list.length) return 0;
    list.forEach(loadTake);
    const ready = list.filter(n => takes[n]);
    if (!ready.length) return 0;
    turn[kind] = ((turn[kind] || 0) + 1) % ready.length;
    const buf = takes[ready[turn[kind]]], src = ctx.createBufferSource(), g = ctx.createGain(), t = ctx.currentTime;
    if (going[kind]) {   /* poked again before the last one finished: the old one ducks out so they never pile up */
      const was = going[kind];
      try { was.g.gain.cancelScheduledValues(t); was.g.gain.setValueAtTime(was.g.gain.value, t); was.g.gain.linearRampToValueAtTime(0, t + 0.05); was.src.stop(t + 0.06); } catch (e) {}
    }
    src.buffer = buf; g.gain.value = (o && o.g) || 0.8;
    src.connect(g); route(g, o || {});
    src.start(t + 0.01);
    going[kind] = { src: src, g: g };
    src.onended = () => { if (going[kind] && going[kind].src === src) going[kind] = null; };
    return buf.duration;
  }
  /* fades out whatever take of a kind is playing */
  function stopTake(kind, fade) {
    const was = going[kind];
    if (!was || !ctx) return;
    const t = ctx.currentTime, d = fade || 0.35;
    try { was.g.gain.cancelScheduledValues(t); was.g.gain.setValueAtTime(was.g.gain.value, t); was.g.gain.linearRampToValueAtTime(0, t + d); was.src.stop(t + d + 0.03); } catch (e) {}
    going[kind] = null;
  }
  let bettyWait = 0;

  /* ---- one-shots ---- */
  const api = {
    init, setOn,
    isOn: () => on,
    scene: setScene,
    sceneName: () => (scene ? scene.name : 'none'),
    setAmb(v) { ambOn = !!v; duck(); return ambOn; },
    ambOn: () => ambOn,
    ambGain: () => (ambBus ? ambBus.gain.value : 0),   /* read only, for the tests */
    /* a tool that needs to be heard (the shot clock) quietens the scene while it is open */
    hush(v) { hushed = !!v; duck(); return hushed; },
    ambLevel(v) { if (v != null) { ambVol = clamp(v, 0, 1); duck(); } return ambVol; },
    setFx(v) { fxOn = !!v; return fxOn; },
    fxOn: () => fxOn,
    /* the music player borrows the audio context so songs get a level meter */
    musicNode(el) {
      if (!init()) return null;
      try { const src = ctx.createMediaElementSource(el); src.connect(musicIn); return src; } catch (e) { return null; }
    },
    musicState(playing) {
      musicOn = !!playing;
      if (!ctx) return;
      if (musicOn && ctx.state !== 'running' && ctx.resume) ctx.resume();
      if (!musicOn && !on && ctx.suspend) setTimeout(() => { if (!on && !musicOn) ctx.suspend(); }, 600);
      duck();
    },
    musicLevel() {
      if (!musicAn || !musicOn) return 0;
      const b = new Uint8Array(musicAn.frequencyBinCount);
      musicAn.getByteFrequencyData(b);
      let s = 0; for (let i = 1; i < 24; i++) s += b[i];
      return s / (23 * 255);
    },
    /* poke a character and it answers back */
    critter(kind) {
      if (!live() || !laneOn()) return;
      if (kind === 'gull') gullCry(bus, 1.6, 0);
      else if (kind === 'pigeon') [0, 0.4].forEach(t => voice(bus, 'sine', [[0, 300, 0], [0.06, 430, 0.12], [0.2, 385, 0.1], [0.34, 300, 0]], { t: t, bp: 800, ft: 'lowpass', q: 0.7, rev: 0.25, vib: [24, 28] }));
      else if (kind === 'alien') {
        for (let k = 0; k < 5; k++) tone({ t: k * 0.07, f: rnd(900, 2400), d: 0.05, g: 0.05, type: 'square', rev: 0.3 });
        voice(bus, 'sine', [[0, 500, 0], [0.05, 700, 0.07], [0.4, 1500, 0.06], [0.58, 900, 0]], { t: 0.38, vib: [9, 40], rev: 0.5 });
      } else if (kind === 'ufo') voice(bus, 'sine', [[0, 420, 0], [0.08, 520, 0.08], [0.5, 980, 0.08], [0.9, 520, 0.06], [1.1, 420, 0]], { vib: [6.5, 30], rev: 0.6 });
      else if (kind === 'boombox') {
        [0, 0.17, 0.52].forEach(t => { tone({ t: t, f: 150, f2: 42, d: 0.2, g: 0.5 }); });
        [0.35, 0.7].forEach(t => { noise({ t: t, d: 0.14, g: 0.2, type: 'bandpass', f: 1900, q: 0.7, rev: 0.18 }); tone({ t: t, f: 210, f2: 150, d: 0.08, g: 0.1, type: 'triangle' }); });
        [0, 0.17, 0.35, 0.52, 0.7].forEach(t => noise({ t: t, d: 0.03, g: 0.03, type: 'highpass', f: 7500 }));
      } else if (kind === 'horn') [0, 0.16].forEach(t => [520, 655].forEach(f => voice(bus, 'square', [[0, f, 0], [0.015, f, 0.035], [0.1, f, 0.03], [0.13, f, 0]], { t: t, bp: 1700, ft: 'lowpass', q: 0.6, rev: 0.2 })));
      else if (kind === 'rocket') { noise({ a: 0.05, d: 0.9, g: 0.14, type: 'bandpass', f: 300, f2: 2600, q: 1.2, rev: 0.3 }); tone({ f: 70, f2: 240, d: 0.8, g: 0.12, type: 'sawtooth' }); }
      else if (kind === 'splash') { noise({ a: 0.02, d: 0.5, g: 0.16, type: 'bandpass', f: 2600, f2: 700, q: 0.8, rev: 0.3 }); }
      else if (kind === 'scratch' || kind === 'scratch2') {   /* scratch: the b-boy; scratch2: the records */
        if (!sample(kind, { g: 0.38, rev: 0.08 })) { noise({ a: 0.01, d: 0.12, g: 0.14, type: 'bandpass', f: 900, f2: 2600, q: 3 }); noise({ t: 0.14, a: 0.01, d: 0.14, g: 0.14, type: 'bandpass', f: 2600, f2: 700, q: 3 }); }
      } else if (kind === 'sat' || kind === 'sat2') {   /* two calls: one from the landing scene, one from Hyperdrive's own page */
        if (!sample(kind === 'sat2' ? 'station2' : 'station', { g: 0.85, rev: 0.2 })) {
          /* three pings home, a burst of telemetry, a breath of radio and the hum of the thing itself */
          [0, 0.13, 0.26].forEach(t => tone({ t: t, f: 1245, d: 0.07, g: 0.14, type: 'sine', a: 0.004, rev: 0.45 }));
          const set = [1568, 1760, 2093, 2349, 2637, 3136];
          for (let k = 0; k < 12; k++) tone({ t: 0.42 + k * 0.032, f: set[Math.floor(Math.random() * set.length)], d: 0.026, g: 0.06, type: 'square', rev: 0.3 });
          noise({ t: 0.82, a: 0.02, d: 0.3, g: 0.07, type: 'bandpass', f: 2600, f2: 1500, q: 2.2, rev: 0.5 });
          tone({ t: 0.4, f: 92, f2: 61, d: 0.85, g: 0.11, type: 'sine', a: 0.08 });
          tone({ t: 1.12, f: 1976, d: 0.22, g: 0.06, type: 'sine', a: 0.004, rev: 0.7 });
        }
      }
      else { tone({ f: 620, f2: 880, d: 0.09, g: 0.09, type: 'triangle' }); tone({ t: 0.09, f: 880, f2: 1240, d: 0.12, g: 0.08, type: 'triangle', rev: 0.3 }); }
    },
    beep(hi) { tone({ f: hi ? 1320 : 880, d: 0.12, g: 0.16, type: 'square' }); },
    count() { tone({ f: 660, d: 0.06, g: 0.11, type: 'square' }); },   /* one tick of the shot clock's three, two, one */
    /* something with wheels goes past and says so. van: two friendly beeps. cab: a short honk and a longer one. bike: a bell,
       twice. rover: two blips. x is where it is across the screen, -1 to 1, so the sound sits where the thing is */
    honk(kind, x) {
      if (!live() || !laneOn()) return;
      const p = clamp(x || 0, -0.7, 0.7);
      if (kind === 'tram') {
        /* ding ding: a struck gong, twice, then the weight of the thing rolling through on its joints */
        [0, 0.3].forEach(t => {
          [[1396, 0.15], [2793, 0.065], [4180, 0.036], [5870, 0.016]].forEach((h, i) => voice(bus, 'sine', [[0, h[0], 0], [0.003, h[0], h[1]], [0.09, h[0], h[1] * 0.5], [0.9 - i * 0.15, h[0], 0]], { t: t, pan: p, rev: 0.35 }));
          noise({ t: t, d: 0.012, g: 0.1, type: 'highpass', f: 4200 });
        });
        noise({ t: 0.1, a: 0.9, d: 1.9, g: 0.34, type: 'lowpass', f: 190, f2: 130, q: 0.6 });
        [0.75, 0.87, 1.35, 1.47, 1.95, 2.07].forEach(t => tone({ t: t, f: 96, f2: 52, d: 0.08, g: 0.2 }));
      } else if (kind === 'bike') {
        [0, 0.24].forEach(t => {
          [[2093, 0.075], [3136, 0.04], [4699, 0.018]].forEach(h => voice(bus, 'sine', [[0, h[0], 0], [0.004, h[0], h[1]], [0.06, h[0], h[1] * 0.45], [0.55, h[0], 0]], { t: t, pan: p, rev: 0.4 }));
          noise({ t: t, d: 0.014, g: 0.05, type: 'highpass', f: 5200 });   /* the striker */
        });
      } else if (kind === 'rover') {
        voice(bus, 'square', [[0, 880, 0], [0.01, 880, 0.045], [0.09, 1320, 0.04], [0.12, 1320, 0]], { bp: 2600, ft: 'lowpass', pan: p, rev: 0.5 });
        voice(bus, 'square', [[0, 1320, 0], [0.01, 1320, 0.045], [0.1, 990, 0.04], [0.14, 990, 0]], { t: 0.19, bp: 2600, ft: 'lowpass', pan: p, rev: 0.5 });
      } else {
        const cab = kind === 'cab', notes = cab ? [392, 494] : [440, 554], g = cab ? 0.05 : 0.055;
        (cab ? [[0, 0.1], [0.2, 0.34]] : [[0, 0.13], [0.23, 0.16]]).forEach(b => {
          notes.forEach(f => {
            voice(bus, 'sawtooth', [[0, f, 0], [0.012, f, g], [b[1], f, g * 0.92], [b[1] + 0.035, f, 0]], { t: b[0], bp: cab ? 1700 : 2100, ft: 'lowpass', q: 0.9, pan: p, rev: 0.2 });
            voice(bus, 'square', [[0, f, 0], [0.012, f, g * 0.5], [b[1], f, g * 0.45], [b[1] + 0.035, f, 0]], { t: b[0], bp: 1200, ft: 'lowpass', q: 0.7, pan: p });
          });
        });
      }
    },
    whistle() { voice(bus, 'sine', [[0, 2300, 0], [0.03, 2500, 0.16], [0.34, 2450, 0.15], [0.42, 2300, 0]], { vib: [38, 90], rev: 0.25 }); },
    buzzer(len) {   /* the arena horn: a fat, raspy held note */
      if (!live() || !laneOn()) return;
      const t = ctx.currentTime, dur = len || 0.9;
      const g = ctx.createGain(), lp = ctx.createBiquadFilter(), vca = ctx.createGain();
      lp.type = 'lowpass'; lp.frequency.value = 2400; lp.Q.value = 0.8;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.27, t + 0.014);
      g.gain.setValueAtTime(0.27, t + dur - 0.07);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      [[233.1, 'sawtooth', 0.4], [236.6, 'square', 0.26], [466.9, 'sawtooth', 0.14], [116.4, 'square', 0.2]].forEach(v => {
        const o = ctx.createOscillator(), og = ctx.createGain();
        o.type = v[1]; o.frequency.value = v[0]; og.gain.value = v[2];
        o.connect(og); og.connect(lp); o.start(t); o.stop(t + dur + 0.05);
      });
      const am = ctx.createOscillator(), amg = ctx.createGain();
      am.type = 'square'; am.frequency.value = 58; amg.gain.value = 0.22; vca.gain.value = 0.78;
      am.connect(amg); amg.connect(vca.gain); am.start(t); am.stop(t + dur + 0.05);
      lp.connect(vca); vca.connect(g); g.connect(bus);
      const sd = ctx.createGain(); sd.gain.value = 0.2; g.connect(sd); sd.connect(revSend);
    },
    bounce(v) {   /* a ball on the boards */
      const n = performance.now();
      if (n - lastTick < 60) return; lastTick = n;
      const g = clamp(v, 0.15, 1);
      tone({ f: 210, f2: 82, d: 0.12, g: 0.5 * g });
      noise({ d: 0.03, g: 0.14 * g, type: 'bandpass', f: 1500, q: 0.8 });
    },
    /* arena stings for a three: our own short organ riffs, an air horn and a drum roll, each with the crowd behind it */
    three(i, at) {
      if (!live() || !laneOn()) return;
      const T = at || 0;
      const organ = (f, t, d, g) => {
        tone({ t: T + t, f: f, d: d, g: g, type: 'square', a: 0.012, rev: 0.25 });
        tone({ t: T + t, f: f * 2, d: d, g: g * 0.45, type: 'sine', a: 0.012 });
        tone({ t: T + t, f: f / 2, d: d, g: g * 0.5, type: 'triangle', a: 0.012 });
      };
      const clap = t => { noise({ t: T + t, d: 0.09, g: 0.32, type: 'bandpass', f: 1500, q: 0.9, rev: 0.25 }); noise({ t: T + t + 0.012, d: 0.07, g: 0.14, type: 'bandpass', f: 2300, q: 1.2 }); };
      const crowd = (t, g) => {
        noise({ t: T + t, a: 0.3, d: 1.9, g: 0.22 * (g || 1), type: 'bandpass', f: 900, f2: 1500, q: 0.45, rev: 0.4 });
        noise({ t: T + t + 0.05, a: 0.35, d: 1.5, g: 0.09 * (g || 1), type: 'highpass', f: 3200, rev: 0.3 });
        for (let k = 0; k < 5; k++) tone({ t: T + t + 0.15 + k * 0.13, f: rnd(700, 1300), f2: rnd(900, 1700), d: 0.28, g: 0.012, type: 'sawtooth', rev: 0.5 });   /* whistles and whoops */
      };
      const C = 261.63, n = st => C * Math.pow(2, st / 12);
      i = ((i | 0) % 4 + 4) % 4;
      if (i === 0) {          /* the run up the keys */
        [0, 4, 7, 12, 16].forEach((st, k) => organ(n(st), k * 0.1, 0.1, 0.12));
        [12, 16, 19].forEach(st => organ(n(st), 0.52, 0.62, 0.1));
        crowd(0.5);
      } else if (i === 1) {   /* three blasts on the air horn */
        [0, 0.2, 0.4].forEach((t, k) => [440, 554.4, 659.3].forEach(f => tone({ t: T + t, f: f * 1.03, f2: f * 0.97, d: k === 2 ? 0.62 : 0.13, g: 0.1, type: 'sawtooth', a: 0.008, rev: 0.3 })));
        crowd(0.45, 1.1);
      } else if (i === 2) {   /* organ and handclaps */
        [[7, 0], [7, 0.2], [9, 0.4], [11, 0.6]].forEach(v => organ(n(v[0]), v[1], 0.15, 0.12));
        [12, 16, 19].forEach(st => organ(n(st), 0.8, 0.6, 0.095));
        [0.1, 0.3, 0.5, 0.6, 0.7].forEach(clap);
        crowd(0.8);
      } else {                /* drum roll and a crash */
        for (let k = 0; k < 14; k++) noise({ t: T + k * 0.045, d: 0.04, g: 0.07 + k * 0.012, type: 'bandpass', f: 1900, q: 0.8 });
        tone({ t: T + 0.66, f: 120, f2: 48, d: 0.3, g: 0.45 });
        noise({ t: T + 0.66, d: 1.3, a: 0.004, g: 0.16, type: 'highpass', f: 5200, rev: 0.4 });
        [12, 16, 19, 24].forEach(st => organ(n(st), 0.68, 0.7, 0.08));
        crowd(0.7, 1.15);
      }
    },
    /* a room on its feet. A recording, because a synth crowd never sounds like people. If the file hasn't landed yet it
       plays the moment it does, and either way the caller hears how long to hold the song back. */
    applause() {
      if (!live() || !laneOn()) return 0;
      const secs = sample('applause', { g: 0.4, rev: 0.1 });
      if (secs) return secs;
      let n = 0;
      const wait = setInterval(() => { if (sample('applause', { g: 0.4, rev: 0.1 }) || ++n > 40) clearInterval(wait); }, 120);
      return 5.5;
    },
    /* Betty's song: a short tune of her own for when her picture comes out. A clip, not one of the radio's songs.
       Says how long it runs so the radio can step right back, and stops when her picture is put away */
    betty() {
      if (!live() || !laneOn()) return 0;
      clearInterval(bettyWait);
      if (going.betty) return 0;                       /* already playing: the second picture doesn't start it again */
      const secs = sample('betty', { g: 0.55 });
      if (secs) return secs;
      let n = 0;
      bettyWait = setInterval(() => { if (sample('betty', { g: 0.55 }) || ++n > 40) clearInterval(bettyWait); }, 120);
      return 15;
    },
    bettyStop() { clearInterval(bettyWait); stopTake('betty'); },
    swish() {
      noise({ d: 0.26, a: 0.012, g: 0.26, type: 'bandpass', f: 4200, f2: 1300, q: 0.9, rev: 0.18 });
    },
    rim() {
      tone({ f: 640, f2: 560, d: 0.2, g: 0.17, type: 'triangle', rev: 0.2 });
      noise({ d: 0.03, g: 0.13, type: 'highpass', f: 3200 });
    },
    stretch(v) {   /* rubber creak as the band tightens */
      const now = performance.now();
      if (now - lastSlide < 90) return;
      lastSlide = now;
      tone({ f: 150 + v * 260, f2: 170 + v * 300, d: 0.07, g: 0.07, type: 'sawtooth' });
    },
    twang() {
      tone({ f: 190, f2: 70, d: 0.3, g: 0.28, type: 'triangle' });
      noise({ d: 0.34, a: 0.04, g: 0.2, type: 'bandpass', f: 400, f2: 2400, q: 1 });
    },
    slap() {
      noise({ d: 0.05, g: 0.22, type: 'lowpass', f: 2200 });
      tone({ f: 150, f2: 62, d: 0.09, g: 0.3 });
    },
    pop() {
      tone({ f: 520, f2: 1250, d: 0.07, g: 0.09, type: 'triangle' });
      noise({ d: 0.03, g: 0.05, type: 'highpass', f: 5000 });
    },
    tick() {
      const n = performance.now();
      if (n - lastTick < 55) return; lastTick = n;
      tone({ f: 2100 + Math.random() * 500, f2: 1500, d: 0.03, g: 0.046 });
    },
    click() {
      tone({ f: 190, f2: 68, d: 0.09, g: 0.2 });
      noise({ d: 0.02, g: 0.07, type: 'bandpass', f: 3200, q: 1.2 });
    },
    toggle() {
      tone({ f: 660, d: 0.07, g: 0.07, type: 'triangle' });
      tone({ t: 0.06, f: 990, d: 0.1, g: 0.07, type: 'triangle', rev: 0.2 });
    },
    close() {
      tone({ f: 880, d: 0.07, g: 0.06, type: 'triangle' });
      tone({ t: 0.06, f: 587, d: 0.11, g: 0.06, type: 'triangle', rev: 0.2 });
    },
    detent() {
      noise({ d: 0.012, g: 0.13, type: 'highpass', f: 2600 });
      tone({ f: 1250, d: 0.02, g: 0.05, type: 'square' });
      tone({ f: 150, f2: 80, d: 0.05, g: 0.14 });
    },
    slide(v) {
      const n = performance.now();
      if (n - lastSlide < 45) return; lastSlide = n;
      tone({ f: 420 + v * 900, d: 0.03, g: 0.045, type: 'triangle' });
    },
    whoosh(up) {
      noise({ d: 0.5, a: 0.12, g: 0.11, type: 'bandpass', f: up === false ? 2400 : 320, f2: up === false ? 300 : 2600, q: 0.9, rev: 0.25 });
    },
    pass() {
      noise({ d: 0.36, a: 0.1, g: 0.035, type: 'bandpass', f: 700, f2: 1500, q: 0.8, rev: 0.3 });
      tone({ f: 330, d: 0.3, g: 0.018, a: 0.04, rev: 0.6 });
    },
    air(v) {
      if (!live()) return;
      if (!laneOn()) { if (air) air.g.gain.setTargetAtTime(0, ctx.currentTime, 0.1); return; }
      if (!air) {
        const n = ctx.createBufferSource(); n.buffer = noiseBuf; n.loop = true;
        const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 220; f.Q.value = 0.3;   /* 9 Oct (Jos): a soft low air, not a hiss */
        const g = ctx.createGain(); g.gain.value = 0;
        n.connect(f); f.connect(g); g.connect(bus); n.start();
        air = { f: f, g: g };
      }
      const t = ctx.currentTime, k = clamp((v - 0.25) / 0.75, 0, 1);   /* quiet until the page really moves */
      air.g.gain.setTargetAtTime(k * k * 0.02, t, 0.2);
      air.f.frequency.setTargetAtTime(180 + k * 340, t, 0.25);
    },
    spin(v) {
      const g = clamp(Math.abs(v) * 0.5, 0.02, 0.1);
      noise({ d: 0.32, a: 0.05, g: g, type: 'bandpass', f: 500, f2: 1900, q: 1.4 });
    },
    paper() {
      noise({ d: 0.05, g: 0.1, type: 'highpass', f: 3000 });
      noise({ t: 0.03, d: 0.14, g: 0.06, type: 'bandpass', f: 900, q: 0.6, rev: 0.2 });
    },
    boom() {
      tone({ f: 92, f2: 34, d: 1.5, g: 0.5, a: 0.006 });
      noise({ d: 1.3, a: 0.02, g: 0.16, type: 'lowpass', f: 2600, f2: 120, rev: 0.5 });
      [220, 329.63, 440, 554.37].forEach((f, k) => tone({ t: 0.12 + k * 0.07, f: f, d: 2.2, g: 0.04, type: 'triangle', a: 0.03, rev: 0.7 }));
    },
    add() {
      [523.25, 659.25, 783.99, 1046.5].forEach((f, k) => tone({ t: k * 0.07, f: f, d: 0.32, g: 0.085, type: 'triangle', rev: 0.35 }));
      tone({ f: 130.8, f2: 98, d: 0.2, g: 0.16 });
    },
    success() {
      [392, 493.88, 587.33, 783.99].forEach((f, k) => tone({ t: k * 0.09, f: f, d: 1.1, g: 0.07, type: 'triangle', a: 0.01, rev: 0.6 }));
    },
    error() {
      tone({ f: 160, d: 0.12, g: 0.12, type: 'square' });
      tone({ t: 0.13, f: 120, d: 0.16, g: 0.12, type: 'square' });
    },
    sting(i) {
      if (i === 0) {
        [440, 554.37, 659.25, 830.61].forEach((f, k) => tone({ t: k * 0.06, f: f, d: 0.5, g: 0.06, type: 'triangle', rev: 0.5 }));
      } else if (i === 1) {
        tone({ f: 150, f2: 44, d: 0.24, g: 0.42 });
        noise({ t: 0.17, d: 0.15, g: 0.16, type: 'bandpass', f: 1900, q: 0.7, rev: 0.25 });
        tone({ t: 0.17, f: 73.4, d: 0.4, g: 0.2, type: 'triangle' });
      } else {
        noise({ d: 0.42, a: 0.36, g: 0.12, type: 'bandpass', f: 300, f2: 4200, q: 2.2, rev: 0.3 });
        tone({ t: 0.42, f: 110, f2: 30, d: 0.7, g: 0.45 });
        tone({ t: 0.42, f: 1320, f2: 220, d: 0.3, g: 0.04, type: 'sawtooth', rev: 0.4 });
      }
    },
    _peak() {
      if (!analyser) return 0;
      const b = new Float32Array(analyser.fftSize);
      analyser.getFloatTimeDomainData(b);
      let m = 0; for (let i = 0; i < b.length; i++) { const a = Math.abs(b[i]); if (a > m) m = a; }
      return m;
    },
    _state: () => (ctx ? ctx.state : 'none')
  };
  /* the scene's own sounds answer to the Sound switch, unless something (the shot clock) has claimed them first */
  ['critter', 'honk', 'three', 'buzzer', 'whistle', 'bounce', 'rim', 'swish', 'stretch', 'twang', 'sting', 'air', 'applause', 'betty', 'beep'].forEach(k => {
    const f = api[k];
    if (f) api[k] = function () { return inLane(lane === 'fx' ? 'amb' : lane, f, arguments); };
  });
  /* 8 Oct (Jos): while our music plays, the scene's automatic sounds rest too (horns as vehicles pass, the scroll wind).
     Taps, stings and clicks still sound */
  ['honk', 'air'].forEach(k => { const f = api[k]; if (f) api[k] = function () { return musicOn ? 0 : f.apply(this, arguments); }; });
  api.world = f => inLane('amb', f);
  api.clock = f => inLane('clock', f);
  api.setClock = v => { clockOn = !!v; return clockOn; };
  api.clockOn = () => clockOn;
  return api;
})();

/* ---------- product pages: one page per coffee, built for buying. No welcome screen, no music player, sound off until asked ---------- */
const topEl = $('#top'), navEl = $('#nav');

/* each product page. The blends keep the world they have on the site; single origins and decaf share one page that fills
   itself from the product (in the theme these lines come from the product in Shopify, not from this file) */
/* reviews from the customer survey (Sept and Oct 2025): first names only, nothing about the cafe. See tools/reviews.py */
const RV_PRODUCT = {
  pe: [
    ["If coffee were a soulmate, this would be mine. I'm officially a coffee snob now all thanks to you guys! Whether it's from my barista machine, or old school stove style, I can't start my day without it.", "Abi", "pe", "on a Breville", 5],
    ["I love People Everyday because life is too short for a bad coffee! The brew has a rich inviting deep brown colour, inviting aroma and a medium bodied, lush, silky, quietly complex (think caramel, chocolate and citrus) mouthfeel.", "Deepa", "pe", "in a plunger", 5],
    ["PED is the ultimate all-rounder. Brewed black, it delivers layers of nuanced tasting notes; and with milk, it has enough punchy chocolate notes to cut through and satisfy those who seek rich creamy textures in their cup.", "Travis", "pe", "on espresso", 5]
  ],
  nsb: [
    ["No Sleep til Brooklyn is my absolute favourite coffee beans out of all the ones I've tried! So freshly roasted and smooth! 10/10 would recommend!", "Gemma", "nsb", "on espresso", 5],
    ["These beans put all other beans to shame. Perfectly roasted and balanced, espresso or with added milk, whatever the coffee order, these beans will take your brew to the next level.", "Matt", "nsb", "on a Breville", 5],
    ["The aroma of this coffee always entices me for another cup! Tastes amazing and the quality of the roast means it still makes decent coffee even after the beans have been open a few weeks!", "Kiara", "nsb", "on a Breville", 5]
  ],
  hyd: [
    ["Hyper Drive isn't just coffee, it's fuel. There's only one way to drink it in my opinion: black and hot. That's when you can appreciate the blend best, with the dark chocolate hits first, followed by subtle malt and a touch of honey.", "Jade", "hyd", "in a plunger", 5],
    ["This is my daily coffee. Hits nicely with a deep, malted, chocolatey velvet vibe, especially when done as a long black or iced long black. I find it particularly nice on those rough early morning starts, or late-night gaming or working on projects.", "Nate", "hyd", "as pour over", 5],
    ["Wow this coffee blows your socks off, keeps you going all day, and it tastes absolutely amazing. I made a cup for my mum when she came over and she said that's the best cup of coffee she has ever had.", "Karen", "hyd", "on a De'Longhi", 5]
  ],
  peru: [
    ["Full body flavour. No bitterness. Just great tasting coffee.", "Lorraine", "peru", "on a De'Longhi", 5]
  ],
  decaf: [
    ["It is delicious and I order it from BOM WA as NSW coffee is terrible. I have been in NSW for 3 years and searched for a coffee to match with no luck.", "Toni", "decaf", "on espresso", 5]
  ]
};
const RV_STATS = {"pe": [4.8, 43], "nsb": [4.9, 17], "hyd": [5.0, 11]};
const PP = {
  pe: { kind: 'blend', b: 0, amb: 'beach', shout: 'Good vibes, good people, good coffee', roast: 60, milk: 50,
    facts: [['Origin', 'Brazil, Colombia, Ethiopia'], ['Brew ratio', 'Espresso 1:2, filter 1:16'], ['Good for', 'Espresso, plunger, stovetop, AeroPress and everyone']],
    reviews: RV_PRODUCT.pe },
  nsb: { kind: 'blend', b: 1, amb: 'street', shout: 'Straight from the west side', roast: 75, milk: 60,
    facts: [['Origin', 'Brazil, Peru'], ['Brew ratio', 'Espresso 1:2, filter 1:16'], ['Good for', 'Espresso, plunger, AeroPress and late nights']],
    reviews: RV_PRODUCT.nsb },
  hyd: { kind: 'blend', b: 2, amb: 'space', shout: 'Full throttle. Zero regrets.', roast: 90, milk: 60,
    facts: [['Origin', 'Peru, Brazil'], ['Brew ratio', 'Espresso 1:1.8, filter 1:14'], ['Good for', 'Espresso, plunger, AeroPress and all nighters']],
    reviews: RV_PRODUCT.hyd },
  peru: { kind: 'single', reviews: RV_PRODUCT.peru, name: 'Peru', vid: 39302168936537, price: 25, img: 'so-peru-front', back: 'so-peru-back', col: 'peru', tag: 'Single origin. Washed.', country: 'Peru', region: 'San Ignacio', strip: 'so-strip-peru', mover: 'so-llama', flyer: 'so-condor', toot: ['', ''],
    desc: 'You have probably already tasted this one. Peru is the backbone of No Sleep Till Brooklyn and Hyperdrive, and it is what gives both of them that deep chocolate weight. On its own, from San Ignacio in the north, washed and roasted for espresso, it is smooth and sweet: chocolate, panela and dried fruit, with almost none of the sharpness people expect from a single origin. If you have been put off single origins before because they tasted thin or sour, start here.',
    roast: 4, varietal: 'Bourbon, Caturra', process: 'Washed', elev: '1500 masl' },
  colombia: { kind: 'single', name: 'Colombia', vid: 39302134825049, price: 25, img: 'so-colombia-front', back: 'so-colombia-back', col: 'colombia', tag: 'Single origin. Washed.', desc: '', country: 'Colombia', region: 'Popayán, Cauca', strip: 'so-strip-colombia', mover: 'so-jeep', flyer: 'so-macaw', toot: ['van', 'beep beep'],
    roast: 3, varietal: 'Variedad Colombia, Castillo, Caturra, Catimor, Typica', process: 'Washed', elev: '1500 to 2070 masl' },
  brazil: { kind: 'single', name: 'Brazil', vid: 41422892695641, price: 25, img: 'so-brazil-front', back: 'so-brazil-back', col: 'brazil', tag: 'Single origin. Natural.', desc: '', country: 'Brazil', region: 'Mogiana', strip: 'so-strip-brazil', mover: 'so-train', flyer: 'so-toucan', toot: ['cab', 'choo choo'],
    roast: 3, varietal: 'Catuai, Mundo Novo', process: 'Natural', elev: '800 to 1350 masl' },
  decaf: { kind: 'single', reviews: RV_PRODUCT.decaf, name: 'Colombia Decaf', short: 'Decaf', vid: 39302136856665, price: 28, img: 'so-decaf-front', back: 'so-decaf-back', col: 'decaf', tag: 'Single origin. Decaf.', desc: '', country: 'Colombia', region: 'Popayán, Cauca', strip: 'so-strip-decaf', mover: 'so-jeep', flyer: 'so-owl', toot: ['van', 'beep beep'],
    roast: 5, varietal: 'Caturra, Castillo, Variedad Colombia', process: 'Decaf', elev: '1500 to 1900 masl' },
  /* 9 Oct, Jos: Papua New Guinea (Okapa, medium) and Ethiopia (Yirgacheffe, medium light). Each has its own land, flag,
     stamp and animals like the four above; their colours are in SO_CSS below, so the style sheet needs nothing new */
  png: { kind: 'single', name: 'Papua New Guinea', short: 'PNG', vid: 39302152749145, price: 25, img: 'so-png-front', back: 'so-png-back', col: 'png', tag: 'Single origin. Washed.', country: 'Papua New Guinea', region: 'Okapa', strip: 'so-strip-png', mover: 'so-cassowary', flyer: 'so-paradise', toot: ['', ''],
    desc: 'Grown high in the Eastern Highlands around Okapa, at 2000 metres and up. Washed, and roasted medium for espresso, it is rich and sweet: cocoa first, then maple and a little plum jam on the way out. If you like your coffee chocolatey but want more going on in the cup, start here.',
    roast: 3, varietal: 'Bourbon, Typica', process: 'Washed', elev: '2000 to 2200 masl' },
  ethiopia: { kind: 'single', name: 'Ethiopia', vid: 42648629706841, price: 25, img: 'so-ethiopia-front', back: 'so-ethiopia-back', col: 'ethiopia', tag: 'Single origin. Natural.', country: 'Ethiopia', region: 'Yirgacheffe', strip: 'so-strip-ethiopia', mover: 'so-donkey', flyer: 'so-bee-eater', toot: ['', ''],
    desc: 'Yirgacheffe is where a lot of people first taste fruit in their coffee. This one is a natural, so the cherries dry whole in the sun, and that is where the fruit comes from. We roast it medium light to keep it bright: fruity and floral, with peach iced tea at the finish. Try it black before you add milk.',
    roast: 2, varietal: 'Heirloom', process: 'Natural', elev: '2000 to 2200 masl' },
  /* 9 Oct, Jos: Mexico (Chiapas, medium, $26). The wolf is the one on the bag; no back photo in Shopify, so no flip */
  mexico: { kind: 'single', name: 'Mexico', vid: 39302156583001, price: 26, img: 'so-mexico-front', back: '', col: 'mexico', tag: 'Single origin. Washed.', country: 'Mexico', region: 'Chiapas', strip: 'so-strip-mexico', mover: 'so-wolf', flyer: 'so-quetzal', toot: ['', ''],
    desc: 'From the highlands of Chiapas in Mexico\'s far south, where coffee grows under the shade of the cloud forest. Washed, and roasted medium for espresso, it is the comfortable one: dark chocolate up front, a squeeze of citrus to keep it lively, and nut butter at the finish. An easy coffee to drink every day, black or with milk.',
    roast: 3, varietal: 'Mundo Novo, Caturra, Bourbon', process: 'Washed', elev: '900 to 1400 masl' }
};
const SO_CSS = '.p-so[data-col="png"]{--pc:var(--orange);--burst:var(--cream);--f1:#CE1126;--f2:#111111;--f3:#FCD116}.p-so[data-col="ethiopia"]{--pc:var(--sky);--burst:var(--white);--f1:#078930;--f2:#FCDD09;--f3:#DA121A}.p-so[data-col="png"] .so-flag{background:linear-gradient(to bottom left,var(--f1) 0 50%,var(--f2) 50% 100%)}.p-so[data-col="png"] .so-flag b{display:none}.p-so[data-col="png"] .so-flag::before{content:\'\';position:absolute;right:15%;top:17%;width:24%;aspect-ratio:1;border-radius:50%;background:var(--f3)}.p-so[data-col="png"] .so-flag::after{content:\'\';position:absolute;left:24%;bottom:36%;width:3px;height:3px;border-radius:50%;background:#fff;box-shadow:5px 4px 0 #fff,-3px 5px 0 #fff,3px -5px 0 #fff}.p-so[data-col="ethiopia"] .so-flag{flex-direction:column}.p-so[data-col="ethiopia"] .so-flag::after{content:\'\';position:absolute;left:50%;top:50%;width:36%;aspect-ratio:1;translate:-50% -50%;border-radius:50%;background:#0F47AF}.p-so[data-col="png"] .so-band{background:repeating-linear-gradient(135deg,#CE1126 0 8px,#111A37 8px 16px,#FCD116 16px 24px)}.p-so[data-col="ethiopia"] .so-band{background:repeating-linear-gradient(90deg,#078930 0 10px,#FCDD09 10px 20px,#DA121A 20px 30px)}.p-so[data-col="png"] .pp-truck,.p-so[data-col="ethiopia"] .pp-truck{width:min(17vh,11.5vw);bottom:calc(var(--sawh) * .5)}.p-so[data-col="png"] .pp-truck img,.p-so[data-col="ethiopia"] .pp-truck img{animation-duration:.42s}@media(max-width:980px){.p-so[data-col="png"] .pp-truck,.p-so[data-col="ethiopia"] .pp-truck{width:25vw}}@media(min-width:981px){.p-so .p-tabs.many img{display:none}.p-so .p-tabs.many button{min-height:36px;padding:3px 11px}}@media(min-width:981px) and (max-width:1180px){.p-so .p-tabs.many{gap:5px}.p-so .p-tabs.many button{min-height:32px;padding:2px 6px;font-size:12px}}.tm[data-c="png"]{--tb:var(--orange);--tburst:rgba(255,255,255,.26)}.tm[data-c="ethiopia"]{--tb:var(--sky);--tburst:rgba(255,255,255,.4)}.p-so[data-col="mexico"]{--pc:var(--purple);--burst:var(--white);--f1:#006847;--f2:#FFFFFF;--f3:#CE1126}.p-so[data-col="mexico"] .so-flag::after{content:\'\';position:absolute;left:50%;top:50%;width:24%;aspect-ratio:1;translate:-50% -50%;border-radius:50%;background:#8B5A2B;box-shadow:inset 0 0 0 2px #5E3A1B}.p-so[data-col="mexico"] .so-band{background:repeating-linear-gradient(90deg,#006847 0 10px,#F0F0EA 10px 20px,#CE1126 20px 30px)}.p-so[data-col="mexico"] .pp-truck{width:min(17vh,11.5vw);bottom:calc(var(--sawh) * .5)}.p-so[data-col="mexico"] .pp-truck img{animation-duration:.42s}@media(max-width:980px){.p-so[data-col="mexico"] .pp-truck{width:25vw}}.tm[data-c="mexico"]{--tb:var(--purple);--tburst:rgba(255,255,255,.3)}.tm-chips-so:has(.tm-chip:nth-child(5)),.tm[data-step="pick"] .tm-chips-so:has(.tm-chip:nth-child(5)){grid-template-columns:repeat(3,minmax(0,1fr))}';
(function soColours() { const st = document.createElement('style'); st.textContent = SO_CSS; document.head.appendChild(st); })();
Object.keys(PP).forEach(k => { PP[k].notes = CUP_NOTES[k] || []; });
/* in the theme each of these is a real product page. The layout hands over the product being shown (CFL.product) and what
   the store says about the single origins today (#cflSingles): variant, price, stock */
const LIVE_PP = typeof CFG.shop === 'string', STORE_PP = LIVE_PP ? CFG.shop.replace(/\/*$/, '/') : '';
const HANDLE = { pe: 'everyday', nsb: 'no-sleep-till-brooklyn', hyd: 'hyperdrive', peru: 'peru-chanchamayo-washed', colombia: 'colombia-popayan-reserve-washed', brazil: 'brazil-mogiana-natural-espresso-250g', decaf: 'colombia-popayan-decaf', png: 'papua-new-guinea-okapa-washed', ethiopia: 'ethiopia-yirgacheffe-natural-espresso', mexico: 'mexico-chiapas-washed' };
Object.keys(HANDLE).forEach(k => { PP[k].handle = HANDLE[k]; });
(function liveSingles() {
  const el = document.getElementById('cflSingles');
  let d = null;
  try { d = el && JSON.parse(el.textContent); } catch (err) {}
  const cp = CFG.product;
  /* 9 Oct: a single origin the store is not selling right now (not there, a draft, archived) is marked gone: no tab, no
     chip, no place on the shot clock. The page being looked at always counts, from the product itself */
  if (d) Object.keys(PP).forEach(k => {
    const p = PP[k]; if (p.kind !== 'single') return;
    const x = d[p.handle] && d[p.handle].id ? d[p.handle] : (cp && cp.handle === p.handle && cp.id ? cp : null);
    if (!x) { p.gone = LIVE_PP; return; }
    p.vid = x.id; p.price = x.price / 100; p.out = x.ok === false;
  });
  /* a coffee this file has never heard of still gets a page: its name, picture, price and words come from the product */
  if (cp && cp.handle && !Object.keys(HANDLE).some(k => HANDLE[k] === cp.handle)) {
    PP.other = { kind: 'single', handle: cp.handle, name: String(cp.title || '').replace(/\s*250g.*$/i, '').replace(/\s*\|.*$/, '') || 'Single origin', vid: cp.id, price: (cp.price || 0) / 100, out: cp.ok === false,
      img: '', imgUrl: cp.image || '', back: '', col: 'peru', tag: 'Single origin.', desc: cp.text || '', country: '', region: '', strip: 'so-farm', mover: 'so-truck', flyer: 'so-plane', toot: ['van', 'beep beep'],
      roast: 0, varietal: '', process: '', elev: '', notes: [] };
  }
})();
const pageUrl = k => STORE_PP + 'products/' + PP[k].handle + (PP[k].kind === 'single' && CFG.view ? '?view=' + CFG.view : '');
/* 9 Oct: the newer single origins get their tab and their chip here, before the decaf, so the page's markup needs no
   change for them; and a single origin that is gone loses both */
(function singlesNav() {
  const tabs = $('.p-so .p-tabs'), chips = $('#soChips');
  ['png', 'ethiopia', 'mexico'].forEach(k => {
    const p = PP[k]; if (!p || p.gone) return;
    const mk = cls => { const b = document.createElement('button'); b.type = 'button'; if (cls) b.className = cls; b.dataset.view = k; const im = document.createElement('img'); im.alt = ''; im.width = 752; im.height = 1100; b.appendChild(im); return b; };
    if (tabs && !$('[data-view="' + k + '"]', tabs)) { const b = mk(''); b.firstChild.dataset.src = pic(p.img + '-s'); b.appendChild(document.createTextNode(p.short || p.name)); tabs.insertBefore(b, $('[data-view="decaf"]', tabs)); }
    if (chips && !$('[data-view="' + k + '"]', chips)) { const b = mk('so-chip'); b.firstChild.src = pic(p.img + '-s'); b.firstChild.loading = 'lazy'; const n = document.createElement('b'); n.textContent = p.short || p.name; const s = document.createElement('small'); s.textContent = '$' + p.price.toFixed(2); b.append(n, s); chips.insertBefore(b, $('[data-view="decaf"]', chips)); }
  });
  $$('.p-so .p-tabs button[data-view], #soChips .so-chip').forEach(b => { const o = PP[b.dataset.view]; if (o && o.gone) b.remove(); });
  /* more than four tabs: names only on a laptop, so they stay on one line (the little bags stay on phones, where the row slides) */
  if (tabs && $$('button', tabs).length > 4) tabs.classList.add('many');
})();
const KEYS = ['pe', 'nsb', 'hyd'];
const ROASTS = ['', 'Light', 'Medium light', 'Medium', 'Medium dark', 'Dark'];
let view = 'pe';
const P = () => PP[view];

/* ---------- small pieces ---------- */
function burst(x, y, n) {
  if (RM || !document.body.animate) return;
  for (let i = 0; i < (n || 7); i++) {
    const b = document.createElement('i'); b.className = 'bit';
    b.style.left = x + 'px'; b.style.top = y + 'px'; b.style.background = ['#FF69AE', '#D2F55C', '#C888F8', '#8CCDE3'][i % 4];
    document.body.appendChild(b);
    const a = Math.random() * Math.PI * 2, d = 40 + Math.random() * 60;
    b.animate([{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 }, { transform: 'translate(' + (Math.cos(a) * d - 5) + 'px,' + (Math.sin(a) * d - 5) + 'px) scale(.2) rotate(180deg)', opacity: 0 }], { duration: 520 + Math.random() * 260, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => b.remove();
  }
}
function makeSeg(el, onChange) {
  const btns = $$('button', el), thumb = $('.thumb', el);
  const api = {
    value: (btns.find(b => b.getAttribute('aria-pressed') === 'true') || btns[0]).dataset.v,
    place() {
      const b = btns.find(x => x.dataset.v === api.value);
      if (!b || !b.offsetWidth) return;
      thumb.style.left = b.offsetLeft + 'px'; thumb.style.width = b.offsetWidth + 'px';
    },
    set(v, silent, quiet) {
      if (v === api.value) return;
      api.value = v;
      btns.forEach(x => x.setAttribute('aria-pressed', String(x.dataset.v === v)));
      api.place();
      if (!silent) SFX.toggle();
      if (onChange && !quiet) onChange(v);
    }
  };
  btns.forEach(b => b.addEventListener('click', () => api.set(b.dataset.v)));
  api.place();
  return api;
}
function makeOpt(el, onChange) {
  el.addEventListener('change', () => { SFX.toggle(); onChange(el.value); });
  return { set(v) { el.value = v; }, place() {} };
}

/* ---------- sound: off until asked. Then the buttons click, the world hums and the vans beep ---------- */
const soundBtn = $('#soundBtn'), soundLbl = $('#soundLbl');
let mutedAll = false;   /* the radio asks for this; on a product page there is no mute-all switch, so it stays false */
const fxBtn = $('#fxBtn'), fxLbl = $('#fxLbl');
function soundUI() {
  const on = SFX.isOn(), amb = on && SFX.ambOn(), fx = on && SFX.fxOn();
  root.classList.toggle('sound-on', amb);
  soundBtn.setAttribute('aria-pressed', String(amb || fx));
  soundLbl.textContent = amb || fx ? 'Sound on' : 'Sound off';
  fxBtn.setAttribute('aria-pressed', String(fx));
  fxLbl.textContent = fx ? 'Clicks on' : 'Clicks off';
  soundBtn.title = soundLbl.textContent; fxBtn.title = fxLbl.textContent;
  const pa = document.getElementById('plAmb'), pf = document.getElementById('plFx');
  if (pa) pa.checked = amb; if (pf) pf.checked = fx;
}
/* two switches in the bar (6 Oct): the scene sound and the clicks, each on its own. Either one wakes the sound up; with both
   off it goes quiet altogether */
function soundPart(which, want) {   /* which: 'amb', 'fx', 'clock' (the shot clock's Beeps), or 'rest' (just settle) */
  const was = SFX.isOn();
  if (which === 'amb') SFX.setAmb(want); else if (which === 'fx') SFX.setFx(want); else if (which === 'clock') SFX.setClock(want);
  if (want && !was) {
    if (which !== 'amb') SFX.setAmb(false);
    if (which !== 'fx') SFX.setFx(false);
    const on = SFX.setOn(true);
    if (!on) { toast('Sound isn\'t available in this browser'); soundUI(); return; }
    SFX.scene(ambFor());
  }
  if (!want && !SFX.ambOn() && !SFX.fxOn()) SFX.setOn(false);
  SFX.toggle(); soundUI();
}
/* the one speaker button (8 Oct): the scene sound and the clicks together */
function soundAll(want) {
  if (want) {
    SFX.setAmb(true); SFX.setFx(true);
    if (!SFX.isOn()) { if (!SFX.setOn(true)) { toast('Sound isn\'t available in this browser'); soundUI(); return; } SFX.scene(ambFor()); }
  } else { SFX.setAmb(false); SFX.setFx(false); SFX.setOn(false); }
  SFX.toggle(); soundUI();
}
soundBtn.addEventListener('click', () => soundAll(!(SFX.isOn() && (SFX.ambOn() || SFX.fxOn()))));
fxBtn.addEventListener('click', () => soundPart('fx', !(SFX.isOn() && SFX.fxOn())));
/* the radio's own switches (8 Oct, Jos): scene sound and button sounds, each on its own, as on the home page */
{ const pa = document.getElementById('plAmb'), pf = document.getElementById('plFx');
  if (pa) pa.addEventListener('change', () => soundPart('amb', pa.checked));
  if (pf) pf.addEventListener('change', () => soundPart('fx', pf.checked)); }
function ambFor() { return P().kind === 'blend' ? P().amb : 'roast'; }

/* ---------- the buy boxes: three for the blends (each in its own world) and one for a single origin ---------- */
const buyState = { size: '250g', plan: FREQ.length ? 'sub' : 'one', grind: GRINDS[0], every: (FREQ.find(f => f.k === '2-week') || FREQ[0] || { k: '' }).k, qty: 1 };
const blendPrice = (b, size, plan) => priceOf(b, size, buyState.grind, plan, buyState.every);
function showPrice(o) {
  const size = buyState.size, plan = buyState.plan;
  o.priceN.textContent = '';
  const s = document.createElement('span'); s.textContent = money(blendPrice(o.b, size, plan)); o.priceN.appendChild(s);
  o.flip = !o.flip;
  o.priceN.classList.toggle('fa', o.flip); o.priceN.classList.toggle('fb', !o.flip);
  o.was.hidden = plan !== 'sub';
  o.was.textContent = money(blendPrice(o.b, size, 'one'));
  o.per.textContent = 'per ' + size + ' bag' + (plan === 'sub' ? ', ' + everyText(buyState.every) : '');
  o.el.classList.toggle('once', plan !== 'sub');
  bndPaint(o);
}
function syncBuy(key, v) {
  buyState[key] = v;
  buys.forEach(o => { o[key].set(v, true, true); showPrice(o); });
  paintExtras();
}
const buys = $$('.buy[data-buy]').filter(el => el.dataset.buy !== 'single').map(el => {
  const o = { el: el, b: +el.dataset.buy, priceN: $('.price-n', el), was: $('.price s', el), per: $('.price small', el), add: $('[data-add]', el), flip: false, t: 0 };
  const every = $('[data-opt="every"]', el);
  every.textContent = '';
  FREQ.forEach(f => { const op = document.createElement('option'); op.value = f.k; op.textContent = freqLabel(f); every.appendChild(op); });
  every.value = buyState.every;
  $('[data-seg="plan"] [data-v="sub"]', el).textContent = 'Subscribe, save ' + SUB_PCT + '%';
  o.size = makeSeg($('[data-seg="size"]', el), v => syncBuy('size', v));
  o.plan = makeSeg($('[data-seg="plan"]', el), v => syncBuy('plan', v));
  o.grind = makeOpt($('[data-opt="grind"]', el), v => syncBuy('grind', v));
  o.every = makeOpt(every, v => syncBuy('every', v));
  o.bnd = bndStrip(o, false, $('.buy-row', el) || o.add);
  showPrice(o);
  return o;
});
const soBuy = { el: $('.buy-single'), add: $('[data-add="single"]'), t: 0 };
/* 8 Oct, Jos: no bundle strip on single origins or decaf (the deals are for the blends only), so bndSo stays null */
function setQty(n) {
  buyState.qty = clamp(n, 1, 12);
  $$('[data-qty-n]').forEach(el => { el.textContent = buyState.qty; });
  paintBar();
}
document.addEventListener('click', e => {
  const q = e.target.closest('[data-qty]');
  if (q) { setQty(buyState.qty + (+q.dataset.qty)); SFX.tick(); }
});

/* what is about to go in the cart, for whichever page is showing */
function current() {
  const p = P();
  if (p.kind === 'blend') {
    const b = p.b, s = buyState;
    return { key: BLENDS[b].id + '|' + s.size + '|' + s.grind + '|' + s.plan + '|' + (s.plan === 'sub' ? s.every : ''), name: BLENDS[b].name, thumb: pic('bag-' + BLENDS[b].id + '-front'),
      line: s.size + ', ' + s.grind + ', ' + (s.plan === 'sub' ? everyText(s.every) + ', ' + SUB_PCT + '% off' : 'one-off'), short: s.size + (s.plan === 'sub' ? ', ' + everyText(s.every) : ', one-off'),
      price: priceOf(b, s.size, s.grind, s.plan, s.every), vid: variantOf(b, s.size, s.grind), plan: s.plan === 'sub' ? planOf(b, s.every) : 0, out: !!shopOf(b).out[variantOf(b, s.size, s.grind)] };
  }
  return { key: 'so|' + view, name: p.name, thumb: p.imgUrl || pic(p.img), line: '250g, Wholebean, one-off', short: '250g, wholebean', price: p.price, vid: p.vid, plan: 0, out: !!p.out };
}

/* ---------- cart ---------- */
const cartBtn = $('#cartBtn'), cartN = $('#cartN'), cartList = $('#cartList'), cartSum = $('#cartSum'), cartEl = $('#cart'), scrim = $('#scrim');
const cart = [];
/* on the store the drawer is the store's own cart (6 Oct): read when the page opens and whenever the drawer opens, and every
   add and every + or - goes straight to the store, one after another */
const OWN_BAGS = [['people everyday', 'bag-pe-front-s'], ['no sleep', 'bag-nsb-front-s'], ['hyperdrive', 'bag-hyd-front-s'], ['decaf', 'so-decaf-front-s'], ['colombia', 'so-colombia-front-s'], ['brazil', 'so-brazil-front-s'], ['peru', 'so-peru-front-s'], ['papua new guinea', 'so-png-front-s'], ['ethiopia', 'so-ethiopia-front-s'], ['mexico', 'so-mexico-front-s']];
let storeQ = Promise.resolve();
function storeLine(it) {
  const t = it.product_title || it.title || '', own = OWN_BAGS.find(o => t.toLowerCase().indexOf(o[0]) > -1);
  let img = it.image || '';
  if (img && !own) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  const sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
  const vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.split(' / ').join(', ') : '';
  const off = (it.line_level_discount_allocations || []).map(a => a.discount_application && a.discount_application.title).filter(Boolean)[0] || '';
  const deal = /one for a mate|pick and mix/i.test(off), bi = own ? OWN_BAGS.indexOf(own) : -1;
  return { store: true, key: it.key, qty: it.quantity, name: t, thumb: own ? pic(own[1]) : img, line: [vt, sp ? sp.name : (vt ? 'one-off' : ''), off].filter(Boolean).join(', '), price: (+it.final_price || 0) / 100, plan: !!sp,
    deal: deal, save: deal ? ((+it.original_line_price || 0) - (+it.final_line_price || 0)) / 100 : 0, one250: !sp && !!own && !/1kg/i.test(vt),
    b: bi > -1 && bi < 3 ? bi : -1, grind: GRINDS.find(g => vt.toLowerCase().indexOf(g.toLowerCase()) > -1) || null };
}
function storeTake(c) { if (!c || !c.items) return; cart.length = 0; c.items.forEach(it => cart.push(storeLine(it))); renderCart(); }
function storeSync() {
  return fetch(STORE + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
    .then(r => { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }).then(storeTake);
}
function storeDo(job) {
  storeQ = storeQ.then(job).catch(() => { SFX.error(); toast('The cart didn\'t update. Give it another go.'); return storeSync().catch(() => {}); });
  return storeQ;
}
function storeAdd(lines) {
  return storeDo(() => fetch(STORE + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: lines }) })
    .then(r => { if (!r.ok) throw new Error('add ' + r.status); }).then(storeSync));
}
/* 9 Oct (Jos): clear the whole cart; on the store through cart/clear.js, then the drawer re-reads the store's cart */
function storeClear() {
  return storeDo(() => fetch(STORE + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
    .then(r => { if (!r.ok) throw new Error('clear ' + r.status); return r.json(); }).then(storeTake));
}
(function () {
  const btn = document.getElementById('cartClear'); if (!btn) return;
  let tm = 0;
  const reset = () => { clearTimeout(tm); btn.removeAttribute('data-sure'); btn.textContent = 'Clear cart'; };
  btn.addEventListener('click', () => {
    if (!btn.hasAttribute('data-sure')) { btn.setAttribute('data-sure', ''); btn.textContent = 'Clear everything?'; tm = setTimeout(reset, 4000); return; }
    reset();
    const live = cart.some(it => it.store);
    cart.length = 0; renderCart();
    if (live) storeClear(); else toast('Cart cleared');
  });
  document.addEventListener('click', e => { if (btn.hasAttribute('data-sure') && !btn.contains(e.target)) reset(); });
})();
function storeSet(key, qty) {
  return storeDo(() => fetch(STORE + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
    .then(r => { if (!r.ok) throw new Error('change ' + r.status); return r.json(); }).then(storeTake));
}
/* how far off free delivery ($90) the cart is (8 Oct) */
function freeLine(total) {
  const box = $('#cartFree'); if (!box) return;
  box.hidden = !(total > 0);
  if (!(total > 0)) return;
  const left = Math.max(0, 90 - total);
  $('#cartFreeBar').style.width = Math.min(100, total / 90 * 100).toFixed(1) + '%';
  $('#cartFreeL').textContent = left > 0.004 ? '$' + left.toFixed(2) + ' away from free delivery. Another bag?' : 'Free delivery. Sorted.';
}
function renderCart() {
  cartList.textContent = '';
  let qty = 0, sum = 0;
  if (!cart.length) { const p = document.createElement('p'); p.className = 'cart-empty'; p.textContent = 'Nothing in here yet. Grab a bag.'; cartList.appendChild(p); }
  cart.forEach(it => {
    qty += it.qty; sum += it.price * it.qty;
    const row = document.createElement('div'); row.className = 'ci';
    const img = document.createElement('img'); img.alt = ''; if (it.thumb) img.src = it.thumb;
    const mid = document.createElement('div');
    const nm = document.createElement('b'); nm.textContent = it.name;
    const sm = document.createElement('small'); sm.textContent = it.line;
    const q = document.createElement('div'); q.className = 'qty';
    const minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'One less ' + it.name);
    const n = document.createElement('span'); n.textContent = it.qty;
    const plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'One more ' + it.name);
    minus.addEventListener('click', () => { it.qty--; if (it.qty < 1) cart.splice(cart.indexOf(it), 1); renderCart(); if (it.store) storeSet(it.key, it.qty); });
    plus.addEventListener('click', () => { it.qty++; renderCart(); if (it.store) storeSet(it.key, it.qty); });
    q.append(minus, n, plus); mid.append(nm, sm, q);
    const pr = document.createElement('span'); pr.className = 'ci-p'; pr.textContent = money(it.price * it.qty);
    row.append(img, mid, pr); cartList.appendChild(row);
  });
  if (!cart.some(it => it.store)) sum -= bndBest(bndUnits()).amt;   /* the concept works the deal out; on the store the lines already carry it */
  cartNudge();
  const clr = $('#cartClear'); if (clr) { clr.hidden = !cart.length; if (!cart.length) { clr.removeAttribute('data-sure'); clr.textContent = 'Clear cart'; } }
  cartN.textContent = qty;
  cartSum.textContent = money(sum);
  freeLine(sum);
  const subsEl = $('#cartSubs'); if (subsEl) subsEl.hidden = !cart.some(it => it.plan);
  cartBtn.setAttribute('aria-label', 'Open cart, ' + qty + (qty === 1 ? ' item' : ' items'));
}
function shopLines() { return cart.map(it => { const l = { id: it.vid, quantity: it.qty }; if (it.plan) l.selling_plan = it.plan; return l; }); }
function flyToCart(src, thumb) {
  const bump = () => { cartN.classList.remove('bump'); void cartN.offsetWidth; cartN.classList.add('bump'); };
  if (RM || !document.body.animate || !src) { bump(); return; }
  const from = src.getBoundingClientRect(), to = cartBtn.getBoundingClientRect();
  const x0 = from.left + from.width / 2 - 42, y0 = from.top + from.height / 2 - 62, x1 = to.left + to.width / 2 - 42, y1 = to.top + to.height / 2 - 62;
  const f = document.createElement('img'); f.className = 'flyer'; f.src = thumb; f.alt = '';
  document.body.appendChild(f);
  f.animate([
    { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(2.2) rotate(0deg)', opacity: 1 },
    { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 60) + 'px) scale(1.2) rotate(-18deg)', opacity: 1, offset: 0.55 },
    { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.2) rotate(30deg)', opacity: 0.6 }
  ], { duration: 780, easing: 'cubic-bezier(.5,0,.2,1)' }).onfinish = () => { f.remove(); bump(); };
}
/* ---------- bundle and save (8 Oct): One for a mate and Pick and mix ---------- */
const grindWord = g => g === 'Wholebean' ? 'wholebean' : String(g).replace(/^Ground for /, 'ground for ');
const all3Was = g => [0, 1, 2].reduce((t, b) => t + priceOf(b, '250g', g, 'one'), 0);
const all3Price = g => all3Was(g) - bndBest([0, 1, 2].map(b => priceOf(b, '250g', g, 'one'))).amt;
/* one: a one-off 250g bag (what the deals count); b: which blend (-1 for anything else); unit: one bag's price */
function bndOf(it) {
  /* 8 Oct, Jos: the deals are for the blends only, so single origins and decaf never count as bundle bags */
  if (it.store) return { one: !!it.one250 && it.b != null && it.b > -1, grind: it.grind || null, b: it.b == null ? -1 : it.b, unit: it.price };
  const k = it.key ? it.key.split('|') : null;
  if (k && k[0] === 'so') return { one: false, grind: null, b: -1, unit: it.price };
  if (k) { const kb = BLENDS.findIndex(x => x.id === k[0]); return { one: kb > -1 && kb < 3 && k[1] === '250g' && k[3] !== 'sub', grind: k[2] || null, b: kb, unit: it.price }; }
  return { one: it.size === '250g' && it.plan !== 'sub', grind: it.grind || null, b: it.b, unit: priceOf(it.b, '250g', it.grind, 'one') };
}
function bndUnits() { const u = []; cart.forEach(it => { const o = bndOf(it); if (o.one && !it.store) for (let i = 0; i < it.qty; i++) u.push(o.unit); }); return u; }
function bndFlash(from) { const b = from && from.querySelector && from.querySelector('b'); if (!b) return; const was = b.innerHTML; b.textContent = 'Added'; setTimeout(() => { b.innerHTML = was; }, 1500); }
function bndStrip(o, single, after) {
  const box = document.createElement('div'); box.className = 'bnd'; box.hidden = !single;
  box.innerHTML = '<p class="bnd-h">Bundle and save</p><div class="bnd-r">' +
    '<button type="button" class="bnd-b" data-bnd="mate">' + bndPics(o, 2) + '<b><i class="bl">Two bags, one for a mate</i><i class="bs">2 for a mate</i></b><span><em></em> <s></s></span></button>' +
    (single ? '' : '<button type="button" class="bnd-b" data-bnd="three">' + bndPics(o, 3) + '<b><i class="bl">Three bags, third one half price</i><i class="bs">3 bags</i></b><span><em></em> <s></s></span></button>') +
    '</div>' + (typeof CFG.shop === 'string' && CFG.pick === true ? '<a class="bnd-l" href="' + CFG.shop.replace(/\/*$/, '/') + PICK_PAGE + '">Or pick and mix any three blends. Third bag half price</a>' : '');   /* LIVE and STORE come later in the script */
  (after || o.add).insertAdjacentElement('afterend', box);
  box.addEventListener('click', e => {
    const btn = e.target.closest('[data-bnd]'); if (!btn) return;
    if (btn.dataset.bnd === 'mate') bndMate(o, btn); else bndThree(o, btn);
  });
  return box;
}
function bndPrices(box, one, g) {
  const m = box.querySelector('[data-bnd="mate"]'), a = box.querySelector('[data-bnd="three"]');
  if (m) { m.querySelector('em').textContent = money(2 * one * (1 - MATE)); m.querySelector('s').textContent = money(2 * one); m.setAttribute('aria-label', 'Add two bags, one for a mate, ' + money(2 * one * (1 - MATE)) + ' instead of ' + money(2 * one)); }
  if (a) { a.querySelector('em').textContent = money(2.5 * one); a.querySelector('s').textContent = money(3 * one); a.setAttribute('aria-label', 'Add three bags, the third one half price, ' + money(2.5 * one) + ' instead of ' + money(3 * one)); }
}
function bndPaint(o) {
  if (!o.bnd) return;
  const show = buyState.plan !== 'sub' && buyState.size === '250g';
  o.bnd.hidden = !show;
  if (show) bndPrices(o.bnd, priceOf(o.b, '250g', buyState.grind, 'one'), buyState.grind);
}
/* one nudge under the cart's lines */
function cartNudge() {
  if (!cart.length) return;
  const ls = cart.map(it => [it, bndOf(it)]), q = ls.reduce((n, x) => n + (x[1].one ? x[0].qty : 0), 0), store = cart.some(it => it.store);
  const gx = ls.find(x => x[1].grind), G = GRINDS.find(g => gx && g.toLowerCase() === String(gx[1].grind).toLowerCase()) || GRINDS[0];
  const box = document.createElement('div'); box.className = 'cart-nudge';
  const p = document.createElement('p'), btn = document.createElement('button'); btn.type = 'button'; btn.className = 'btn btn-sm';
  if (q === 1) {
    const L = ls.find(x => x[1].one)[0];
    p.innerHTML = '<b>One for a mate?</b> Add another bag and save 10% on both.'; btn.textContent = 'Add another';
    btn.addEventListener('click', () => { SFX.add(); L.qty++; renderCart(); if (L.store) storeSet(L.key, L.qty); toast('One for a mate: 10% off both bags'); });
    box.append(p, btn);
  } else if (q % 3 === 2) {
    const have = ls.filter(x => x[1].one).map(x => x[1].b), nb = [0, 1, 2].find(b => have.indexOf(b) < 0), b = nb == null ? 0 : nb;
    p.innerHTML = '<b>Make it three.</b> Add a bag of ' + BLENDS[b].name + ' and the third bag is half price.'; btn.textContent = 'Add it';
    btn.addEventListener('click', () => addOne(b, G, btn));
    box.append(p, btn);
  } else if (q >= 3) {
    const saved = store ? cart.reduce((t, it) => t + (it.store && it.deal ? it.save : 0), 0) : bndBest(bndUnits()).amt;
    if (!(saved > 0.004)) return;   /* on the store, only once the store has taken it off */
    p.innerHTML = '<b>Bundle and save.</b> You\'re saving ' + money(saved) + ' on your bags.'; box.classList.add('cn-ok');
    box.append(p);
  } else if (ls.some(x => x[1].b > -1)) {
    p.innerHTML = '<b>Try all three blends.</b> One of each, one-off, for ' + money(all3Price(G)) + '. The third bag is half price.'; btn.textContent = 'Add all three';
    btn.addEventListener('click', () => addAll3(G, btn));
    box.append(p, btn);
  } else return;
  cartList.appendChild(box);
}
/* 9 Oct (Jos): the deals on a blend's page are for that blend: two little bags, three little bags */
function bndPics(o, n) {
  if (o.b == null || o.b < 0 || !BLENDS[o.b]) return '';
  let h = '<span class="bnd-pics" aria-hidden="true">';
  for (let i = 0; i < n; i++) h += '<img src="' + pic('bag-' + BLENDS[o.b].id + '-front-s') + '" alt="" width="160" height="236">';
  return h + '</span>';
}
function bndThree(o, btn) {
  setQty(3); addToCart(o.add, btn);
  toast('Added 3 bags. The third one is half price');
}
function bndMate(o, btn) {
  setQty(2); addToCart(o.add, btn);
  toast('Added 2 bags. One for a mate: 10% off both');
}
function bagLine(b, g) {
  return { key: BLENDS[b].id + '|250g|' + g + '|one|', name: BLENDS[b].name, thumb: pic('bag-' + BLENDS[b].id + '-front'), line: '250g, ' + g + ', one-off',
    price: priceOf(b, '250g', g, 'one'), vid: variantOf(b, '250g', g), plan: 0 };
}
function addBag(b, g) { const l = bagLine(b, g), hit = cart.find(it => it.key === l.key); if (hit) hit.qty++; else cart.push(Object.assign(l, { qty: 1 })); }
function addOne(b, g, from) {
  addBag(b, g); renderCart();
  if (LIVE) storeAdd([{ id: variantOf(b, '250g', g), quantity: 1 }]);
  SFX.add(); flyToCart(from, pic('bag-' + BLENDS[b].id + '-front')); bndFlash(from);
  toast('Added ' + BLENDS[b].name + ', ' + grindWord(g) + '. Third bag half price');
}
function addAll3(g, from) {
  [0, 1, 2].forEach(b => addBag(b, g)); renderCart();
  if (LIVE) storeAdd([0, 1, 2].map(b => ({ id: variantOf(b, '250g', g), quantity: 1 })));
  SFX.add(); flyToCart(from, pic('bag-pe-front')); bndFlash(from);
  toast('Added all three blends, ' + grindWord(g) + '. Third bag half price');
}
function addToCart(btn, from) {
  const c = current();
  if (c.out) { SFX.error(); toast(c.name + ' in that size and grind is sold out right now'); return; }
  const hit = cart.find(it => it.key === c.key);
  if (hit) hit.qty += buyState.qty; else cart.push({ key: c.key, name: c.name, thumb: c.thumb, line: c.line, price: c.price, vid: c.vid, plan: c.plan, qty: buyState.qty });
  renderCart();
  if (LIVE) { const l = { id: c.vid, quantity: buyState.qty }; if (c.plan) l.selling_plan = c.plan; storeAdd([l]); }
  SFX.add(); flyToCart(from || btn, c.thumb);
  toast('Added ' + (buyState.qty > 1 ? buyState.qty + ' x ' : '') + c.name + ' to the cart');
  const was = btn.textContent;
  btn.textContent = 'Added';
  clearTimeout(btn._t); btn._t = setTimeout(() => { btn.textContent = was === 'Added' ? 'Add to cart' : was; }, 1500);
  setQty(1);
}
let opener = null;
function cartOpen(v) {
  cartEl.classList.toggle('open', v); cartEl.setAttribute('aria-hidden', String(!v)); scrim.classList.toggle('open', v);
  document.body.classList.toggle('lock', v);
  $('#main').inert = v; topEl.inert = v; ppBar.inert = v || !barOn;
  if (v) { opener = document.activeElement; SFX.whoosh(true); setTimeout(() => $('[data-close]', cartEl).focus({ preventScroll: true }), 60); }
  else { SFX.close(); if (opener && opener.focus) opener.focus({ preventScroll: true }); }
}
cartBtn.addEventListener('click', () => { cartOpen(true); if (LIVE) storeSync().catch(() => {}); });
scrim.addEventListener('click', () => cartOpen(false));
const checkoutBtn = $('#checkoutBtn'), LIVE = typeof CFG.shop === 'string', STORE = LIVE ? CFG.shop.replace(/\/*$/, '/') : '';
if (LIVE) {
  root.classList.add('live'); $('#cartFine').textContent = 'Flat rate shipping $9.95 Australia-wide. Free over $90.';
  storeSync().catch(() => {});   /* the drawer shows the store's cart, what was added elsewhere included (6 Oct) */
  window.addEventListener('pageshow', e => { if (e.persisted) storeSync().catch(() => {}); });
}
checkoutBtn.addEventListener('click', () => {
  SFX.toggle();
  if (!cart.length) { toast('Nothing in the cart yet'); return; }
  if (!LIVE) { toast('Concept page. Checkout isn\'t connected.'); return; }
  checkoutBtn.disabled = true; checkoutBtn.textContent = 'Taking you to checkout';
  storeQ.then(() => location.assign(STORE + 'checkout'));   /* everything is already in the store's cart: wait for the last add, then go */
});
window.addEventListener('pageshow', e => { if (e.persisted) { checkoutBtn.disabled = false; checkoutBtn.textContent = 'Checkout'; } });   /* back from checkout */

/* ---------- the bar that follows you down the page: the coffee, the price and the button, always in reach ---------- */
const ppBar = $('#ppBar');
let barOn = false;
function paintBar() {
  const c = current();
  $('#ppBarImg').src = c.thumb;
  $('#ppBarName').textContent = c.name;
  $('#ppBarSub').textContent = (buyState.qty > 1 ? buyState.qty + ' x ' : '') + c.short;
  $('#ppBarPrice').textContent = money(c.price * buyState.qty);
}
$('#ppBarAdd').addEventListener('click', e => addToCart(e.currentTarget, $('#ppBarImg')));
function barWatch() {
  /* out of the way only while the real button is on screen */
  const r = (P().kind === 'blend' ? buys[P().b].add : soBuy.add).getBoundingClientRect();
  const show = r.bottom < S.topH + 8 || r.top > S.vh - 8;
  if (show !== barOn) { barOn = show; ppBar.classList.toggle('on', show); ppBar.setAttribute('aria-hidden', String(!show)); ppBar.inert = !show; }
}

/* ---------- what's in the cup ---------- */
function paintCup() {
  const p = P(), notes = $('#cupNotes'), meta = $('#cupMeta');
  notes.textContent = ''; meta.textContent = '';
  const row = (k, v) => { const dt = document.createElement('dt'); dt.textContent = k; const dd = document.createElement('dd'); dd.textContent = v; meta.append(dt, dd); };
  p.notes.forEach((n, i) => {
    const f = document.createElement('figure'); f.className = 'cup-n'; f.style.setProperty('--i', i);
    const im = document.createElement('img'); im.src = pic(n[0]); im.alt = ''; im.loading = 'lazy';
    const c = document.createElement('figcaption'); c.textContent = n[1];
    f.append(im, c); notes.appendChild(f);
  });
  if (p.kind === 'blend') {
    p.facts.forEach(f => row(f[0], f[1]));
    $('#cupShout').textContent = p.shout;
    $('#cupDesc').textContent = '';
    $('#scRoast').hidden = false;
    setScale('scRoast', p.roast, 'Roast: ' + (p.roast < 67 ? 'medium' : p.roast < 85 ? 'medium dark' : 'dark'));
    setScale('scMilk', p.milk, p.milk > 55 ? 'Leans towards milk' : 'Good black or with milk');
    $('#scMilk').hidden = false;
  } else {
    if (p.region) row('Grown in', p.region + ', ' + p.country);
    if (p.varietal) row('Varietal', p.varietal);
    if (p.process) row('Process', p.process + (view === 'decaf' ? ' (Swiss Water Process)' : ''));
    if (p.elev) row('Elevation', p.elev);
    $('#cupShout').textContent = 'Roasted for espresso';
    $('#cupDesc').textContent = p.desc;
    $('#scRoast').hidden = !p.roast;
    if (p.roast) setScale('scRoast', (p.roast - 1) * 25, 'Roast: ' + ROASTS[p.roast].toLowerCase());
    $('#scMilk').hidden = true;
  }
}
function setScale(id, pct, label) { const el = document.getElementById(id); el.style.setProperty('--p', clamp(pct, 4, 96) + '%'); el.setAttribute('aria-label', label); }

/* ---------- subscription: the figures come from the same place the buy box gets them ---------- */
function paintSub() {
  const p = P(), sec = $('#sub');
  sec.hidden = p.kind !== 'blend' || !FREQ.length;
  if (sec.hidden) return;
  const b = p.b, k = buyState.every;
  $('#d250w').textContent = money(priceOf(b, '250g', GRINDS[0], 'one', k)).replace('.00', '');
  $('#d250').textContent = money(priceOf(b, '250g', GRINDS[0], 'sub', k)).replace('.00', '');
  $('#d1kw').textContent = money(priceOf(b, '1kg', GRINDS[0], 'one', k)).replace('.00', '');
  $('#d1k').textContent = money(priceOf(b, '1kg', GRINDS[0], 'sub', k)).replace('.00', '');
  $('#subBtn').textContent = 'Subscribe and save ' + SUB_PCT + '%';
  const first = FREQ[0], last = FREQ[FREQ.length - 1];
  $('#subFreq').textContent = FREQ.length > 1 ? 'Every ' + (first.n === 1 ? first.unit : first.n + ' ' + first.unit + 's') + ', or anything up to every ' + last.n + ' ' + last.unit + 's.' : everyText(first.k).replace(/^e/, 'E') + '.';
}
$('#subBtn').addEventListener('click', () => { syncBuy('plan', 'sub'); toBuy(); toast('Subscription is on. Pick your bag.'); });
function toBuy() {
  const box = P().kind === 'blend' ? buys[P().b].el : soBuy.el;
  const y = box.getBoundingClientRect().top + window.scrollY - S.topH - 24;
  window.scrollTo({ top: Math.max(0, y), behavior: RM ? 'auto' : 'smooth' });
}

/* ---------- brew smarter, not harder: our recipe for this coffee and this method, and the way in to the shot clock that
   runs it. Single origins and decaf have no recipe of their own, so they run on People Everyday's ---------- */
const brewSeg = makeSeg($('#brewSeg'), v => { brew.m = v; brew.cups = 1; paintBrew(); });
const brew = { m: 'esp', cups: 1 };
const lower = nice;
const brewKey = () => (P().kind === 'blend' ? BLENDS[P().b].id : 'pe');
function grindLabel() {
  const g = GRIND_FOR[brew.m], btn = $('#brewGrind');
  btn.hidden = !g || P().kind !== 'blend';
  if (g) btn.textContent = buyState.grind === g ? 'Your grind is set for this' : 'Set my grind for ' + (brew.m === 'aero' ? 'AeroPress' : BREW_METHOD[brew.m].toLowerCase());
}
function paintBrew() {
  const p = P(), blend = p.kind === 'blend';
  const id = brewKey(), d = RECIPES.B[id][brew.m], cups = d.hasCups ? brew.cups : 1;
  const dose = Math.round(d.dose * cups * 10) / 10, yld = Math.round(d.yield * cups);
  const lead = $('#brewLead'); lead.textContent = '';
  const nm = document.createElement('b'); nm.textContent = blend ? BLENDS[p.b].name : p.name;
  if (blend) lead.append('Our recipe for ', nm, ', method by method. Pick how you brew, then let the shot clock run it.');
  else lead.append(nm, ' runs on our People Everyday recipe. Pick how you brew, then let the shot clock run it.');
  const stats = $('#brewStats'); stats.textContent = '';
  [['Dose', dose + 'g'], [lower(d.yl), yld + 'g'], ['Temp', d.temp + '°C'], ['Ratio', '1:' + (brew.m === 'esp' ? (d.yield / d.dose).toFixed(1).replace(/\.0$/, '') : Math.round(d.yield / d.dose))], ['Grind', lower(d.grind)], ['Time', /-/.test(d.time) ? d.time + 's' : d.time]].forEach(s => {
    const dt = document.createElement('dt'); dt.textContent = s[0]; const dd = document.createElement('dd'); dd.textContent = s[1]; stats.append(dt, dd);
  });
  $('#brewCups').hidden = !d.hasCups; $('#brewCupsN').textContent = cups;
  const steps = $('#brewSteps'); steps.textContent = '';
  RECIPES.STEPS[id][brew.m].forEach(line => {
    const li = document.createElement('li');
    /* each step is plain text with the dose and yield dropped in; the store marks the numbers that matter */
    nice(line.replace(/%D/g, dose).replace(/%Y/g, yld).replace(/<span class="h">(.*?)<\/span>/g, '{{$1}}')).split(/(\{\{.*?\}\})/).forEach(part => {
      const m = /^\{\{(.*?)\}\}$/.exec(part);
      if (m) { const b = document.createElement('b'); b.textContent = m[1]; li.appendChild(b); }
      else if (part) li.appendChild(document.createTextNode(part));
    });
    steps.appendChild(li);
  });
  $('#brewTip').textContent = nice(blend ? RECIPES.TIPS[id][brew.m] : SINGLE_TIPS[brew.m]);
  $('#brewFix').textContent = nice(RECIPES.TROUBLE[brew.m]) + '.';
  $('#brewLaunchP').textContent = brew.m === 'esp' ? 'It times the shot, shows the window to stop in, and tells you what to change if you miss it.' : 'It runs this recipe one step at a time and calls every pour.';
  const open = $('#brewOpen'); open.dataset.brew = view; open.dataset.brewM = brew.m;
  $$('.p-brew').forEach(b => { if (b.id === 'soBrew') b.dataset.brew = view; });
  grindLabel();
}
document.addEventListener('click', e => { const c = e.target.closest('[data-cups]'); if (c) { brew.cups = clamp(brew.cups + (+c.dataset.cups), 1, 10); SFX.tick(); paintBrew(); } });
$('#brewGrind').addEventListener('click', () => {
  const g = GRIND_FOR[brew.m]; if (!g) return;
  syncBuy('grind', g); SFX.success(); toast('Grind set: ' + g.toLowerCase()); paintBrew();
});

/* ---------- testimonials: one card everywhere (the same markup tools/reviews.py writes) ---------- */
const RV_COFFEE = { pe: ['People Everyday', 'bag-pe-front-s'], nsb: ['No Sleep Till Brooklyn', 'bag-nsb-front-s'], hyd: ['Hyperdrive', 'bag-hyd-front-s'], peru: ['Peru', 'so-peru-front-s'], decaf: ['Decaf', 'so-decaf-front-s'] };
const RV_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.8l3.1 6.4 7 .9-5.1 4.9 1.3 7-6.3-3.4-6.3 3.4 1.3-7L1.9 9.1l7-.9z"/></svg>';
const RV_MARK = '<svg class="rv-mark" viewBox="0 0 64 48" aria-hidden="true"><path d="M5 44V27C5 13 12 5 26 3l2 8c-7 2-11 6-12 12h11v21zM36 44V27c0-14 7-22 21-24l2 8c-7 2-11 6-12 12h11v21z"/></svg>';
const RV_AV = ["#D2F55C", "#8CCDE3", "#C888F8", "#F27B20", "#FF69AE"];
function rvStars(n, cls) { return '<span class="rv-stars' + (cls ? ' ' + cls : '') + '" role="img" aria-label="' + n + ' out of 5 stars">' + [0, 1, 2, 3, 4].map(k => k < n ? RV_STAR : RV_STAR.replace('<svg ', '<svg class="off" ')).join('') + '</span>'; }
const RV_BG = { 'rv-sky': '#8CCDE3', 'rv-lime': '#D2F55C', 'rv-cream': '#F0F0EA', 'rv-purple': '#C888F8' };
function rvAv(i, bg) { for (let k = 0; k < RV_AV.length; k++) { const c = RV_AV[(i + k) % RV_AV.length]; if (c.toLowerCase() !== String(bg || '').toLowerCase()) return c; } return RV_AV[0]; }
function rvCard(r, i, tag, cls, bg) {
  const cf = RV_COFFEE[r[2]] || RV_COFFEE.pe, deckCard = tag === 'article';
  const c = document.createElement(tag || 'figure'); c.className = 'rv' + (cls ? ' ' + cls : '');
  if (!bg) (cls || '').split(' ').forEach(k => { if (RV_BG[k]) bg = RV_BG[k]; });
  if (bg) c.style.setProperty('--rb', bg);
  c.style.setProperty('--ra', rvAv(i, bg));
  const top = document.createElement('div'); top.className = 'rv-top'; top.innerHTML = rvStars(r[4] || 5) + RV_MARK;
  const q = document.createElement(deckCard ? 'q' : 'blockquote'); q.textContent = r[0];
  const who = document.createElement(deckCard ? 'footer' : 'figcaption'); who.className = 'rv-who';
  const av = document.createElement('span'); av.className = 'rv-av'; av.setAttribute('aria-hidden', 'true'); av.textContent = r[1].charAt(0);
  const id = document.createElement('span'); id.className = 'rv-id';
  const b = document.createElement('b'); b.textContent = r[1];
  const sm = document.createElement('small'); sm.textContent = cf[0] + ', ' + r[3];
  id.append(b, sm);
  const bag = document.createElement('img'); bag.className = 'rv-bag'; bag.alt = ''; bag.loading = 'lazy'; bag.width = 160; bag.height = 236; bag.src = pic(cf[1]);
  who.append(av, id, bag);
  c.append(top, q, who);
  return c;
}
function rvScore(st, what) { return '<b>' + st[0].toFixed(1) + '</b><span>' + rvStars(5, 'big') + '<small>out of 5, from ' + st[1] + ' reviews of ' + what + '</small></span>'; }

/* ---------- reviews, the other coffees, good to know ---------- */
function paintRevs() {
  const p = P(), box = $('#revs'), sec = $('#word'), sc = $('#revScore'), list = p.reviews || [], st = RV_STATS[view];
  sec.hidden = !list.length;
  box.textContent = ''; box.classList.toggle('one', list.length === 1);
  sc.hidden = !st;
  if (st) sc.innerHTML = rvScore(st, p.name || RV_COFFEE[view][0]);
  if (sec.hidden) return;
  list.forEach((r, i) => { const c = rvCard(r, i, 'figure', ['', 'rv-sky', 'rv-lime'][i % 3]); c.style.setProperty('--i', i); box.appendChild(c); });
}
function paintOthers() {
  const p = P(), blend = p.kind === 'blend';
  $('#othersH').textContent = blend ? 'Meet the others.' : 'Or go with a blend.';
  let n = 0;
  $$('#otherRow .pick-card').forEach(c => { const hide = blend && c.dataset.card === view; c.hidden = hide; if (!hide) n++; });
  $('#otherRow').classList.toggle('two', n === 2);
  $$('#soChips .so-chip').forEach(c => { c.hidden = c.dataset.view === view; const o = PP[c.dataset.view]; if (o) $('small', c).textContent = money(o.price); });
  $$('.pick-price[data-pp]').forEach(el => { el.textContent = money(priceOf(+el.dataset.pp, buyState.size, GRINDS[0], buyState.plan, buyState.every)); });
  $$('#otherRow .pick-size').forEach(el => { el.textContent = buyState.size + (buyState.plan === 'sub' ? ', on subscription' : ''); });
}
function paintFaq() {
  const p = P(), list = $('#faqList'), blend = p.kind === 'blend';
  const first = FREQ[0], last = FREQ[FREQ.length - 1];
  const qs = blend ? [
    ['Is there a lock-in?', 'No. No lock-in contract and no hassle.'],
    ['How often can it turn up?', FREQ.length ? 'You choose when you subscribe: ' + FREQ.map(f => everyText(f.k)).join(', ').replace(/, ([^,]*)$/, ' or $1') + '.' : ''],
    ['What do we save by subscribing?', SUB_PCT + '% off every bag, every delivery.'],
    ['What does shipping cost?', 'A flat $9.95 anywhere in Australia. Free when the order is $90 or more.'],
    ['When does it ship?', 'We roast daily and send it out the next business day with Australia Post. Most orders land in 1 to 3 days, though times can vary.'],
    ['Which grind do we pick?', 'Wholebean if you grind at home. Otherwise pick the one that matches how you brew: espresso, plunger or AeroPress. The recipes above show the grind for each.'],
    ['Where is it roasted?', 'In Port Kennedy, Western Australia, on Betty, our Probat. She has been cooking since 2017.']
  ] : [
    ['Is it wholebean or ground?', 'Wholebean, in a 250g bag.'],
    ['What is it roasted for?', 'Espresso. It says so on the bag.'],
    ['Can we subscribe to it?', 'Subscriptions are on our three blends, at ' + SUB_PCT + '% off every delivery. This one is a one-off.'],
    ['What does shipping cost?', 'A flat $9.95 anywhere in Australia. Free when the order is $90 or more.'],
    ['When does it ship?', 'We roast daily and send it out the next business day with Australia Post. Most orders land in 1 to 3 days, though times can vary.'],
    ['Where is it roasted?', 'In Port Kennedy, Western Australia, on Betty, our Probat. She has been cooking since 2017.']
  ];
  list.textContent = '';
  qs.filter(q => q[1]).forEach((q, i) => {
    const it = document.createElement('div'); it.className = 'faq-i' + (i === 0 ? ' open' : '');
    const b = document.createElement('button'); b.type = 'button'; b.className = 'faq-q'; b.setAttribute('aria-expanded', String(i === 0)); b.textContent = q[0];
    const x = document.createElement('span'); x.className = 'faq-x'; x.setAttribute('aria-hidden', 'true'); b.appendChild(x);
    const a = document.createElement('div'); a.className = 'faq-a'; const inner = document.createElement('div'); const para = document.createElement('p'); para.textContent = q[1]; inner.appendChild(para); a.appendChild(inner);
    b.addEventListener('click', () => { const open = !it.classList.contains('open'); it.classList.toggle('open', open); b.setAttribute('aria-expanded', String(open)); if (open) SFX.toggle(); else SFX.close(); });
    it.append(b, a); list.appendChild(it);
  });
}
function paintExtras() { paintBar(); paintSub(); paintOthers(); grindLabel(); }

/* ---------- the single origin page fills itself from the product ---------- */
const soPanel = $('.p-so');
function paintSingle() {
  const p = P();
  soPanel.dataset.col = p.col;
  $('#n-so').textContent = p.name;
  ['soGhost1', 'soGhost2', 'soGhost3', 'soGhost4'].forEach(id => { document.getElementById(id).textContent = p.short || p.name; });
  $('#soTag').textContent = p.tag;
  const line = (id, val) => { const dd = document.getElementById(id); dd.textContent = val; dd.hidden = !val; dd.previousElementSibling.hidden = !val; };
  line('soNotes', p.notes.map(n => n[1]).join(', ')); line('soVar', p.varietal); line('soProc', p.process); line('soElev', p.elev);
  $$('#soMeter i').forEach((i, k) => i.classList.toggle('f', k < p.roast));
  $('#soRoast').textContent = ROASTS[p.roast] || '';
  const rdd = $('#soMeter').parentNode; rdd.hidden = !p.roast; rdd.previousElementSibling.hidden = !p.roast;
  $('#soStr').setAttribute('aria-label', 'Single origin, 250g wholebean');
  const flip = $('#soFlip'), fr = $('#soFront'), bk = $('#soBack');
  flip.classList.remove('flipped'); flip.setAttribute('aria-pressed', 'false'); const fe0 = $('.flip', flip); if (fe0) fe0.classList.remove('back'); const fh0 = $('.flip-hint', flip); if (fh0) fh0.textContent = 'Flip it over';
  fr.src = p.imgUrl || pic(p.img); fr.alt = p.name + ' 250g bag, front';
  if (p.back) { bk.src = pic(p.back); bk.alt = p.name + ' 250g bag, back'; } else { bk.removeAttribute('src'); bk.alt = ''; }
  flip.disabled = !p.back; $('#soHint').hidden = !p.back;
  flip.setAttribute('aria-label', p.back ? 'Flip the ' + p.name + ' bag over' : p.name + ' 250g bag');
  $('#soPrice').textContent = money(p.price);
  if (bndSo) bndPrices(bndSo, p.price, GRINDS[0]);
  /* where it grows: the land along the bottom, what crosses the page, the flag, the stamp */
  if (p.col === 'decaf') soPanel.dataset.nav = 'dark'; else delete soPanel.dataset.nav;
  $$('#soStrip img').forEach(im => { im.src = pic(p.strip); });
  const fly = $('#soFlyer'), mov = $('#soMover');
  $('img', fly).src = pic(p.flyer); $('img', mov).src = pic(p.mover);
  mov.dataset.honk = p.toot[0]; mov.dataset.toot = p.toot[1];
  const moon = $('#soMoon'); if (p.col === 'decaf') moon.src = pic('so-moon'); else moon.removeAttribute('src');
  const stickers = p.notes.map(n => n[0]).concat(['so-cherries', 'so-sack', 'so-globe']).slice(0, 3);
  ['soN1', 'soN2', 'soN3'].forEach((id, i) => { document.getElementById(id).src = pic(stickers[i]); });
  /* each sticker's name under it (7 Oct); only as many stickers as the coffee has notes */
  ['soL1', 'soL2', 'soL3'].forEach((id, i) => { const lb = document.getElementById(id), n = p.notes[i]; lb.textContent = n ? n[1] : ''; lb.closest('.tz').hidden = !n; });
  $('#soCountry').textContent = p.country; $('#soRegion').textContent = p.region; $('#soElev2').textContent = p.elev;
  $('#soStamp').hidden = !p.country; $('.so-tag .so-flag').hidden = !p.country;
  $$('.p-so .p-tabs button').forEach(b => { if (b.dataset.view === view) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
  const tabRow = $('.p-so .p-tabs'), tabNow = tabRow && $('button[aria-current="true"]', tabRow);
  if (tabNow && tabRow.scrollWidth > tabRow.clientWidth + 1) tabRow.scrollLeft += tabNow.getBoundingClientRect().left - tabRow.getBoundingClientRect().left - (tabRow.clientWidth - tabNow.offsetWidth) / 2;
}

/* ---------- switching product pages. In the theme each of these is its own address; here one page plays all of them ---------- */
const panels = $$('#buy .panel');
function wake(el) { $$('img[data-src]', el).forEach(im => { const u = im.dataset.src, m = /^i\/([\w-]+)\.webp$/.exec(u); im.src = m ? pic(m[1]) : u; im.removeAttribute('data-src'); }); }   /* in the theme the address is already the store's own */
let shown = false;
function show(v, quiet) {
  if (!PP[v]) return;
  /* on the store another coffee is another address */
  if (LIVE_PP && shown) { if (v !== view) location.assign(pageUrl(v)); else window.scrollTo(0, 0); return; }
  shown = true;
  view = v;
  const p = P(), blend = p.kind === 'blend';
  root.dataset.page = v; root.dataset.kind = p.kind;
  panels.forEach(el => {
    const mine = blend ? el.dataset.b === String(p.b) : el === soPanel;
    el.hidden = !mine;
    el.classList.remove('pop');
    if (mine) { wake(el); requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('pop'))); }
  });
  if (!blend) paintSingle();
  $$('#pv [data-view]').forEach(b => { const on = b.dataset.view === v || (b.dataset.kind === 'single' && !blend && v !== 'decaf'); b.setAttribute('aria-pressed', String(on)); });
  setQty(1);
  brew.cups = 1;
  paintCup(); paintSub(); paintBrew(); paintRevs(); paintOthers(); paintFaq(); paintBar();
  buys.forEach(o => { o.size.place(); o.plan.place(); }); brewSeg.place();
  if (!LIVE_PP) document.title = (blend ? BLENDS[p.b].name : p.name) + ' | Brother of Mine Coffee Roasters';
  if (SFX.isOn()) SFX.scene(ambFor());
  if (!quiet) { window.scrollTo(0, 0); SFX.pass(); }
  measure();
}
document.addEventListener('click', e => {
  const t = e.target;
  const vb = t.closest('button[data-view]');
  if (vb) { show(vb.dataset.view); return; }
  const ad = t.closest('[data-add]');
  if (ad) { addToCart(ad, P().kind === 'blend' ? $('.bagflip', panels[P().b]) : $('#soFlip')); return; }
  const fl = t.closest('.bagflip');
  if (fl && !fl.disabled) { const on = fl.getAttribute('aria-pressed') !== 'true'; fl.setAttribute('aria-pressed', String(on)); fl.classList.toggle('flipped', on);
    const fe = $('.flip', fl); if (fe) fe.classList.toggle('back', on); const fh = $('.flip-hint', fl); if (fh) fh.textContent = on ? 'Flip it back' : 'Flip it over'; SFX.spin(0.6); return; }   /* 9 Oct: the turn itself, as the home page does it */
  if (t.closest('[data-close]')) { cartOpen(false); return; }
  const a = t.closest('a[href^="#"]');
  if (a && a.getAttribute('href').length > 1) { const el = document.getElementById(a.getAttribute('href').slice(1)); if (el) { e.preventDefault(); window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 2, behavior: RM ? 'auto' : 'smooth' }); } }
});
document.addEventListener('keydown', e => { if (e.key === 'Escape' && cartEl.classList.contains('open')) cartOpen(false); });
$('#newsForm').addEventListener('submit', e => {
  const box = $('#newsEmail'), v = box ? box.value.trim() : '';
  if (!/^\S+@\S+\.\S+$/.test(v)) { e.preventDefault(); SFX.error(); toast('That email doesn\'t look right. Check it and try again.'); return; }
  if (LIVE) return;                                    /* on the store this is the store's own sign-up form, and it takes it from here */
  e.preventDefault();
  SFX.success(); toast('Concept page. Nothing was sent.'); e.target.reset();
});

/* ---------- beep beep: what drives past says so, once the sound is on ---------- */
const TOOT = { van: 'beep beep', cab: 'beep beeep', bike: 'ring ring', rover: 'bip bip', plane: 'vrooom' };
const HONKERS = [['.pp-kombi', 'van'], ['.pp-truck', ''], ['.pp-cab', 'cab'], ['.sub-rider', 'bike'], ['.pp-rover', 'rover']]
  .map(h => { const el = $(h[0]); return el && { el: el, kind: h[1], x: null }; }).filter(Boolean);
let honkT = 0;
setInterval(() => {
  const ok = !document.hidden && SFX.isOn() && SFX.ambOn() && !document.body.classList.contains('lock'), now = performance.now(), line = S.vw * 0.3;
  HONKERS.forEach(h => {
    const r = ok ? h.el.getBoundingClientRect() : null;
    if (!r || !r.width || r.bottom < 60 || r.top > S.vh - 30) { h.x = null; return; }
    const cx = r.left + r.width / 2, was = h.x;
    h.x = cx;
    if (was === null || was >= line || cx < line || cx - was > S.vw * 0.4 || now - honkT < 2200) return;
    const kind = h.kind || h.el.dataset.honk;
    if (!kind) return;
    honkT = now;
    SFX.honk(kind, cx / S.vw * 2 - 1);
    const tag = document.createElement('b'); tag.className = 'toot'; tag.textContent = h.kind ? TOOT[h.kind] : h.el.dataset.toot; tag.setAttribute('aria-hidden', 'true');
    h.el.appendChild(tag); setTimeout(() => tag.remove(), 1500);
  });
}, 180);

/* ---------- layout, scroll and first paint ---------- */
function measure() {
  S.vw = window.innerWidth; S.vh = window.innerHeight; S.stacked = S.vw <= 980; S.mobile = S.vw <= 700;
  S.topH = topEl.getBoundingClientRect().height;   /* 9 Oct: the bar is zoomed on big screens, so its height on screen */
  root.style.setProperty('--top', S.topH + 'px');
  buys.forEach(o => { o.size.place(); o.plan.place(); }); brewSeg.place();
}
let navDark = null, ticking = false;
function onScroll() {
  ticking = false;
  barWatch();
  /* the menu takes a pink shadow over a dark page */
  const y = S.topH * 0.6;
  let dark = false;
  $$('[data-nav="dark"], .p-hyd').forEach(el => { if (el.hidden) return; const r = el.getBoundingClientRect(); if (r.top <= y && r.bottom > y) dark = true; });
  if (dark !== navDark) { navDark = dark; navEl.classList.toggle('dark', dark); }
}
window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
window.addEventListener('resize', () => { measure(); onScroll(); });
if (window.IntersectionObserver) {
  const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('.cup, .psub, .brew, .pword, .others, .pfaq').forEach(el => io.observe(el));
} else $$('.sec').forEach(el => el.classList.add('in'));
if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

/* which page to open on: a bare name after the address (#hyd, #peru), otherwise People Everyday */
const ask = (location.hash || '').replace(/^#/, '').toLowerCase();
let first = PP[ask] ? ask : 'pe';
if (LIVE_PP && CFG.product) first = Object.keys(PP).find(k => PP[k].handle === CFG.product.handle) || first;
renderCart(); soundUI(); measure();
show(first, true);
onScroll();
window.__pp = { show: show, PP: PP, state: buyState, cart: cart, lines: shopLines, current: current, brew: brew, S: S, SFX: SFX, view: () => view };

/* ---------- the music player: our own songs ---------- */
/* on the store, a chat bubble from another app sits bottom right. Measure it so the radio can step clear of it (see .live .player) */
if (typeof CFG.shop === 'string') {
  const clearChat = () => {
    const c = document.getElementById('chat-button'), r = c && c.getBoundingClientRect();
    root.style.setProperty('--chat', r && r.width && r.bottom > innerHeight - 160 && r.right > innerWidth - 200 ? Math.min(108, Math.round(innerWidth - r.left + 8)) + 'px' : '0px');   /* its frame can be wider than the bubble, so never step further than the bubble itself */
  };
  setInterval(clearChat, 1200); addEventListener('resize', clearChat);
}
const TRACKS = [
  ['Brother of Mine', 'brother-of-mine', 252],
  ['I Got You', 'i-got-you', 246],
  ['Windows Down', 'windows-down', 238],
  ['Little Wins', 'little-wins', 234],
  ['Good Morning', 'good-morning', 240],
  ['Morning People', 'morning-people', 164],
  ['First Sip', 'first-sip', 191],
  ['The Hustle', 'the-hustle', 160],
  ['Long Way Round', 'long-way-round', 250],
  ['Kitchen Table', 'kitchen-table', 242],
  ['Let It Go Cold', 'let-it-go-cold', 262],
  ['Funk in the Cup', 'funk-in-the-cup', 239]
];
const Music = (() => {
  const player = $('#player'), mini = $('#plMini'), card = $('#plCard'), list = $('#plList');
  const miniT = $('#plMiniT'), miniS = $('#plMiniS'), miniP = $('#plMiniP'), title = $('#plTitle'), state = $('#plState');
  const bar = $('#plBar'), fill = $('#plFill'), now = $('#plNow'), dur = $('#plDur'), playBtn = $('#plPlay'), quick = $('#plQuick'), vol = $('#plVol');
  const el = new Audio();
  el.preload = 'none'; el.volume = 0.8;   /* the songs are mastered 3 dB down as well, so the scene and the buttons still read over them */
  let at = 0, loaded = -1, playing = false, failed = false;
  /* the radio carries on from page to page: which song, how far in, how loud, and whether it was playing */
  const KEY = 'cflRadio', DAYKEY = 'cflRadioLast', TODAY = new Date().toDateString();
  let was = null, parkT = 0, wantT = 0, leaving = false, shownAt = -1, keptAt = 0;
  try { was = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) {}
  if (!was || typeof was.i !== 'number' || !TRACKS[was.i]) was = null;
  function keep(force) {
    if (leaving && !force) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ i: at, t: Math.floor(loaded === at ? Math.max(el.currentTime || 0, wantT) : parkT), on: playing, v: +vol.value, got: loaded > -1 || parkT > 0 || !!(was && was.got) })); } catch (err) {}
  }
  const mmss = s => { s = Math.max(0, Math.round(s || 0)); return ((s / 60) | 0) + ':' + String(s % 60).padStart(2, '0'); };
  const rows = TRACKS.map((t, i) => {
    const li = document.createElement('li'), b = document.createElement('button');
    b.type = 'button';
    [String(i + 1), t[0], mmss(t[2])].forEach(x => { const s = document.createElement('span'); s.textContent = x; b.appendChild(s); });
    b.addEventListener('click', () => { pick(i); });
    li.appendChild(b); list.appendChild(li);
    return b;
  });
  function paint() {
    const t = TRACKS[at];
    title.textContent = t[0];
    dur.textContent = mmss(isFinite(el.duration) && loaded === at ? el.duration : t[2]);
    rows.forEach((b, i) => { if (i === at) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    if (shownAt !== at) { shownAt = at; follow(); }
    player.classList.toggle('playing', playing);
    playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    quick.setAttribute('aria-label', playing ? 'Pause our music' : 'Play our music');
    state.textContent = failed ? 'That song didn\'t load' : playing ? 'Now playing' : 'The soundtrack';
    miniT.textContent = 'BOM Radio';
    miniS.textContent = failed ? 'Didn\'t load. Try another' : playing ? t[0] : loaded > -1 || parkT ? 'Paused: ' + t[0] : 'Our music. Your morning.';
    if (miniP) miniP.textContent = failed ? 'Didn\'t load' : playing || loaded > -1 || parkT ? t[0] : 'Our music';   /* the phone's one line: the song (8 Oct, Jos) */
    mini.setAttribute('aria-label', 'BOM Radio' + (playing ? ', now playing ' + t[0] : '') + '. ' + (card.hidden ? 'Open the controls' : 'Close the controls'));
  }
  /* the list follows the song: skip to track five and it comes into view */
  function follow(centre) {
    if (card.hidden) return;
    const b = rows[at], lr = list.getBoundingClientRect(), br = b.getBoundingClientRect();
    if (centre || br.top < lr.top + 1 || br.bottom > lr.bottom - 1) list.scrollTop += (br.top - lr.top) - (lr.height - br.height) / 2;
  }
  /* A stream can drop part-way and make the browser start the file again. So each song is fetched whole into memory
     and played from there; the next one is fetched in the background while this one plays. */
  const held = {}, direct = i => AUD + TRACKS[i][1] + '.mp3';
  let swapping = false, wantPlay = false, noBlob = false, lastTime = 0;
  function fetchTrack(i) {
    i = (i + TRACKS.length) % TRACKS.length;
    if (noBlob || !window.fetch || !window.URL || !URL.createObjectURL) return Promise.resolve(null);
    if (held[i]) return held[i].p;
    const rec = held[i] = { url: null, p: null };
    rec.p = fetch(direct(i))
      .then(r => {
        if (!r.ok) throw new Error('song');
        const want = +r.headers.get('content-length') || 0;
        return r.blob().then(b => { if (want && b.size < want * 0.97) throw new Error('short'); return b; });   /* a cut-off download never gets played */
      })
      .then(b => { rec.url = URL.createObjectURL(b); return rec.url; })
      .catch(() => { delete held[i]; return null; });
    return rec.p;
  }
  function tidy() {   /* keep this song and the next in memory, let the rest go */
    const next = (at + 1) % TRACKS.length;
    Object.keys(held).forEach(k => {
      const i = +k;
      if (i !== at && i !== next && held[i].url) { try { URL.revokeObjectURL(held[i].url); } catch (err) {} delete held[i]; }
    });
  }
  function resumeAt(t) {   /* after changing where the song comes from: back to the same second, and keep playing if we were */
    const on = () => {
      el.removeEventListener('loadedmetadata', on);
      try { if (t > 0.3) el.currentTime = t; } catch (err) {}
      const done = () => { swapping = false; };
      if (wantPlay) { const p = el.play(); if (p && p.then) p.then(done, done); else done(); } else done();
    };
    el.addEventListener('loadedmetadata', on);
  }
  function swapIn(url, i) {   /* the whole song has arrived: carry on from memory */
    if (noBlob || loaded !== i || el.src === url) return;
    const t = Math.max(el.currentTime || 0, wantT);   /* if the stream couldn't jump to where the last page left off, the full copy can */
    swapping = true;
    el.src = url;
    resumeAt(t);
  }
  function load(i) {
    at = (i + TRACKS.length) % TRACKS.length;
    if (loaded !== at) {
      loaded = at; failed = false; lastTime = 0;
      const me = at, rec = held[me];
      if (rec && rec.url && !noBlob) el.src = rec.url;
      else { el.src = direct(me); fetchTrack(me).then(url => { if (url) swapIn(url, me); }); }   /* start straight away, switch to the full copy when it lands */
      fill.style.width = '0%'; now.textContent = '0:00';
      wantT = 0;
      if (parkT > 0) { const t = parkT; parkT = 0; wantT = t; resumeAt(t); }   /* this is the song from the last page: back to where it was */
      tidy();
      if (!matchMedia('(pointer: coarse)').matches) setTimeout(() => { if (loaded === me) fetchTrack(me + 1); }, 4000);   /* phones keep just the one song in memory (13 Oct) */
    }
  }
  function play() {
    load(at);
    wantPlay = true;
    const p = el.play();
    if (p && p.catch) p.catch(() => { if (!el.error && !swapping) { playing = false; SFX.musicState(false); paint(); } });
  }
  function pause() { wantPlay = false; el.pause(); }
  function toggle() { if (playing) pause(); else play(); }
  function pick(i) { if ((i + TRACKS.length) % TRACKS.length !== at) parkT = 0; load(i); play(); paint(); }
  function open(v) {
    card.hidden = !v;
    mini.setAttribute('aria-expanded', String(v));
    paint();
    if (v) requestAnimationFrame(() => follow(true));
  }
  /* a song was playing on the last page: pick it up as soon as the browser lets us (straight away, or on the first tap) */
  function resume() {
    if (!was || !was.on || playing) return false;
    const go = () => { document.removeEventListener('pointerdown', go, true); document.removeEventListener('keydown', go, true); if (!playing) play(); };
    load(at); wantPlay = true;
    const p = el.play();
    if (p && p.catch) p.catch(() => { if (playing) return; wantPlay = false; document.addEventListener('pointerdown', go, true); document.addEventListener('keydown', go, true); });
    return true;
  }
  el.addEventListener('play', () => { playing = true; failed = false; if (el.muted) { el.muted = false; mutedAll = false; } SFX.musicState(true); paint(); soundUI(); keep(); try { localStorage.setItem(DAYKEY, JSON.stringify({ d: TODAY, i: at })); } catch (err) {} });
  el.addEventListener('pause', () => { if (swapping) return; playing = false; SFX.musicState(false); paint(); soundUI(); keep(); });
  window.addEventListener('pagehide', () => { keep(true); leaving = true; });
  window.addEventListener('pageshow', () => { leaving = false; });
  el.addEventListener('ended', () => { if (swapping) return; pick(at + 1); });
  function fail() { playing = false; wantPlay = false; failed = true; SFX.musicState(false); paint(); toast('That song didn\'t load. Try another one.'); }
  el.addEventListener('error', () => {
    if (loaded < 0) return;
    const me = loaded, t = lastTime;
    if (/^blob:/.test(el.src)) {
      if (noBlob) { swapping = false; fail(); return; }
      noBlob = true;   /* this browser won't play from memory: go back to streaming and stay there */
      swapping = true; el.src = direct(me); resumeAt(t);
      return;
    }
    swapping = false;
    if (noBlob) { fail(); return; }
    /* the stream fell over: wait for the full copy and carry on from there */
    fetchTrack(me).then(url => {
      if (loaded !== me) return;
      if (!url) { fail(); return; }
      swapping = true; el.src = url; resumeAt(t);
    });
  });
  el.addEventListener('loadedmetadata', paint);
  el.addEventListener('timeupdate', () => {
    const d = isFinite(el.duration) && el.duration ? el.duration : TRACKS[at][2];
    const p = clamp(el.currentTime / d, 0, 1);
    fill.style.width = (p * 100).toFixed(2) + '%';
    now.textContent = mmss(el.currentTime);
    if (!swapping && el.currentTime > 0) lastTime = el.currentTime;
    if (wantT && el.currentTime >= wantT - 1) wantT = 0;
    if (Math.abs(el.currentTime - keptAt) > 2) { keptAt = el.currentTime; keep(); }
    bar.setAttribute('aria-valuenow', Math.round(p * 100));
  });
  function seek(e) {
    const r = bar.getBoundingClientRect(), p = clamp((e.clientX - r.left) / r.width, 0, 1);
    if (loaded !== at) load(at);
    const d = isFinite(el.duration) && el.duration ? el.duration : 0;
    if (d) { wantT = 0; el.currentTime = p * d; }
  }
  let seeking = false;
  bar.addEventListener('pointerdown', e => { seeking = true; try { bar.setPointerCapture(e.pointerId); } catch (err) {} seek(e); });
  bar.addEventListener('pointermove', e => { if (seeking) seek(e); });
  bar.addEventListener('pointerup', () => { seeking = false; });
  bar.addEventListener('pointercancel', () => { seeking = false; });
  bar.addEventListener('keydown', e => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    if (isFinite(el.duration)) el.currentTime = clamp(el.currentTime + (e.key === 'ArrowRight' ? 10 : -10), 0, el.duration - 0.2);
  });
  mini.addEventListener('click', () => { open(card.hidden); });
  /* tap the record and it scratches: the song really does drag back and catch up */
  const rec = $('#plRec');
  let scrT = [];
  try { el.preservesPitch = false; el.mozPreservesPitch = false; el.webkitPreservesPitch = false; } catch (err) {}
  function scratch() {
    rec.classList.remove('scr'); void rec.offsetWidth; rec.classList.add('scr');
    SFX.critter('scratch2');
    scrT.forEach(clearTimeout); scrT = [];
    if (!playing) return;
    try { el.currentTime = Math.max(0, el.currentTime - 0.4); } catch (err) {}
    [[0, 0.45], [110, 2.1], [220, 0.5], [330, 1.7], [440, 1]].forEach(v => scrT.push(setTimeout(() => { try { el.playbackRate = v[1]; } catch (err) {} }, v[0])));
  }
  rec.addEventListener('click', scratch);
  quick.addEventListener('click', toggle);
  $('#plSkip').addEventListener('click', () => pick(loaded < 0 ? 0 : at + 1));
  const volPaint = () => { vol.style.setProperty('--v', vol.value + '%'); };
  let duckT = 0;
  vol.addEventListener('input', () => { clearTimeout(duckT); el.volume = vol.value / 100; volPaint(); keep(); });
  /* step the song back for a moment so a horn or a crowd can be heard over it */
  function duck(ms, to) { clearTimeout(duckT); try { el.volume = (vol.value / 100) * (to == null ? 0.3 : to); } catch (err) {} duckT = setTimeout(() => { try { el.volume = vol.value / 100; } catch (err) {} }, ms || 1600); }
  if (was) {
    at = was.i; parkT = was.got ? Math.max(0, +was.t || 0) : 0;
    if (was.v >= 0 && was.v <= 100) { vol.value = was.v; el.volume = was.v / 100; }
  } else {
    /* a new visit (6 Oct, Jos): the very first one opens on Brother of Mine. Come back another day and the radio moves on
       to the song after the last one you played; later the same day, it picks up that song again */
    let last = null;
    try { last = JSON.parse(localStorage.getItem(DAYKEY) || 'null'); } catch (err) {}
    if (last && typeof last.i === 'number' && TRACKS[last.i]) at = last.d === TODAY ? last.i : (last.i + 1) % TRACKS.length;
  }
  volPaint();
  $('#plClose').addEventListener('click', () => { open(false); mini.focus({ preventScroll: true }); });
  playBtn.addEventListener('click', toggle);
  $('#plPrev').addEventListener('click', () => { if (el.currentTime > 4) { el.currentTime = 0; } else pick(at - 1); });
  $('#plNext').addEventListener('click', () => pick(at + 1));
  paint();
  return { play: play, pause: pause, toggle: toggle, open: open, scratch: scratch, duck: duck, warm: () => { fetchTrack(at); }, isPlaying: () => playing, resume: resume, wasPlaying: () => !!(was && was.on), el: el };
})();

/* ---------- the menu: everything on the site, one tap away, the same on a desktop and a phone.
   On the site it is one of the overlays. On a product page it looks after itself. ---------- */
const Menu = (() => {
  const el = $('#menu');
  if (!el) return null;
  const MAIN = typeof openOv === 'function';
  let opener3 = null;
  function shown(v) {
    if (MAIN) { if (v) openOv('menu'); else if (S.overlay === 'menu') closeOv(); return; }
    if (el.classList.contains('open') === v) return;
    el.classList.toggle('open', v); el.setAttribute('aria-hidden', String(!v));
    document.body.classList.toggle('lock', v);
    if (v) document.body.dataset.ov = 'menu'; else delete document.body.dataset.ov;
    ['#main', '#top'].forEach(q => { const x = $(q); if (x) x.inert = v; });
    if (v) { opener3 = document.activeElement; SFX.whoosh(true); setTimeout(() => $('[data-close]', el).focus({ preventScroll: true }), 60); }
    else { SFX.close(); if (opener3 && opener3.focus) opener3.focus({ preventScroll: true }); }
  }
  if (MAIN) OV.menu = el;
  else {
    document.addEventListener('click', e => { const b = e.target.closest('[data-open="menu"]'); if (b) { e.preventDefault(); shown(true); } });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && el.classList.contains('open')) shown(false); });
  }
  /* the magnifier in the bar opens the menu with the cursor already in the search box */
  let wantFind = false;
  document.addEventListener('click', e => { if (e.target.closest('[data-find]')) wantFind = true; }, true);
  new MutationObserver(() => {
    const open = el.classList.contains('open'), q = $('#mnQ');
    if (open && wantFind && q) setTimeout(() => q.focus({ preventScroll: true }), 160);
    wantFind = false;
  }).observe(el, { attributes: true, attributeFilter: ['class'] });
  /* pick anything and the menu gets out of the way first, so the page underneath can move */
  el.addEventListener('click', e => {
    const t = e.target.closest('a,button');
    if (!t) return;
    if (t.id === 'mnSound') { const sb = $('#soundBtn'); if (sb) sb.click(); return; }
    if (t.id === 'mnFx') { const fb = $('#fxBtn'); if (fb) fb.click(); return; }
    if (t.closest('[data-close]')) { if (!MAIN) shown(false); return; }
    if (MAIN && t.dataset.open) return;               /* another overlay: it takes over by itself */
    if (MAIN) { if (S.overlay === 'menu') closeOv(true); } else shown(false);
  }, true);
  /* the sound switch in here mirrors the one in the bar (which a phone has no room for) */
  const sb = $('#soundBtn'), ms = $('#mnSound'), ml = $('#mnSoundL');
  if (sb && ms) {
    const sync = () => { const on = sb.getAttribute('aria-pressed') === 'true'; ms.setAttribute('aria-pressed', String(on)); ml.textContent = on ? 'Sound on' : 'Sound off'; };
    new MutationObserver(sync).observe(sb, { attributes: true, attributeFilter: ['aria-pressed'] });
    sync();
  }
  const fb = $('#fxBtn'), mf = $('#mnFx'), mfl = $('#mnFxL');
  if (fb && mf) {
    const syncFx = () => { const on = fb.getAttribute('aria-pressed') === 'true'; mf.setAttribute('aria-pressed', String(on)); mfl.textContent = on ? 'Clicks on' : 'Clicks off'; };
    new MutationObserver(syncFx).observe(fb, { attributes: true, attributeFilter: ['aria-pressed'] });
    syncFx();
  }
  return { open: () => shown(true), close: () => shown(false) };
})();

/* ---------- the shot clock: a brew timer that runs our own recipes and calls every step.
   Pick the coffee and how you're brewing it; the recipe comes from the store's blend pages (RECIPES). Espresso gets a clock
   with a target window. Plunger, V60 and AeroPress get the timed stages: the coach calls each one, the kettle swings in when
   it's time to pour and the scale shows what yours should read. Single origins and decaf run on the People Everyday recipe.
   The same tool sits on the site and on the product pages, so it finds out which of the two it is in (MAIN). ---------- */
const Brew = (() => {
  const el = $('#tm');
  if (!el) return null;
  const NSV = 'http://www.w3.org/2000/svg', MAIN = typeof openOv === 'function';
  const R = RECIPES;
  const METH = { esp: { art: 'bw-esp', prep: 3 }, plg: { art: 'bw-plg', prep: 2 }, v60: { art: 'bw-v60', prep: 1 }, aero: { art: 'bw-aero', prep: 1 } };
  const SINGLES = [['peru', 'Peru', 'peru-chanchamayo-washed', 'so-peru-front'], ['colombia', 'Colombia', 'colombia-popayan-reserve-washed', 'so-colombia-front'], ['brazil', 'Brazil', 'brazil-mogiana-natural-espresso-250g', 'so-brazil-front'], ['png', 'PNG', 'papua-new-guinea-okapa-washed', 'so-png-front'], ['ethiopia', 'Ethiopia', 'ethiopia-yirgacheffe-natural-espresso', 'so-ethiopia-front'], ['mexico', 'Mexico', 'mexico-chiapas-washed', 'so-mexico-front'], ['decaf', 'Decaf', 'colombia-popayan-decaf', 'so-decaf-front']]
    .filter(s => !(typeof PP === 'object' && PP[s[0]] && PP[s[0]].gone));   /* 9 Oct: not one the store is not selling */
  const COFFEES = BLENDS.map((b, i) => ({ key: b.id, name: b.name, short: ['Everyday', 'Brooklyn', 'Hyperdrive'][i], recipe: b.id, bag: 'bag-' + b.id + '-front', b: i, handle: SHOP[b.id].handle }))
    .concat(SINGLES.map(s => ({ key: s[0], name: s[0] === 'decaf' ? 'Colombia Decaf' : s[0] === 'png' ? 'Papua New Guinea' : s[1], short: s[1], recipe: 'pe', bag: s[3], b: -1, handle: s[2] })));
  const STORE_ROOT = typeof CFG.shop === 'string' ? CFG.shop.replace(/\/*$/, '/') : 'https://brotherofmine.com.au/';
  /* run: 0 waiting, 1 running, 2 paused, 3 full time */
  const st = { c: 'pe', m: 'esp', cups: 1, dose: 0, yld: 0, ratio: 0, touched: false, run: 0, ms: 0, t0: 0, stage: -1, count: -1, zone: 'pre', act: 'idle', voice: false, built: false, list: null, hinted: false, face: 'recipe', soundBefore: false, beeped: false };
  const inEl = $('#tmIn'), stage = $('#tmStage'), goBtn = $('#tmGo'), rsBtn = $('#tmReset'), clock = $('#tmClock'), led = $('#tmLed');
  const nowEl = $('#tmNow'), subEl = $('#tmSub'), nextEl = $('#tmNext'), nextT = $('#tmNextT'), nextIn = $('#tmNextIn');
  let coach = null;
  const fill = $('#tmFill'), zone = $('#tmZone'), ticks = $('#tmTicks'), playsEl = $('#tmPlays'), done = $('#tmDone');
  const shoutEl = $('#tmShout'), soundTgl = $('#tmSound'), voiceTgl = $('#tmVoice');
  const coffee = () => COFFEES.find(x => x.key === st.c) || COFFEES[0];
  const base = () => R.B[coffee().recipe][st.m];
  const num1 = v => (Math.round(v * 10) / 10 % 1 === 0 ? String(Math.round(v)) : (Math.round(v * 10) / 10).toFixed(1));
  const ratioText = () => '1:' + (st.m === 'esp' ? (st.yld / st.dose).toFixed(1).replace(/\.0$/, '') : Math.round(st.yld / st.dose));
  const loud = () => SFX.isOn() && SFX.clockOn();
  const mk = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };

  /* ---- lit readouts, built the way the scoreboard's are ---- */
  const LSEG = { a: '14,6 46,6 40,14 20,14', b: '48,8 48,46 44,50 40,44 40,16', c: '48,92 48,54 44,50 40,56 40,84', d: '14,94 46,94 40,86 20,86', e: '12,92 12,54 16,50 20,56 20,84', f: '12,8 12,46 16,50 20,44 20,16', g: '18,50 22,46 38,46 42,50 38,54 22,54' };
  const LDIG = ['abcdef', 'bc', 'abged', 'abgcd', 'fgbc', 'afgcd', 'afgedc', 'abc', 'abcdefg', 'abcdfg'];
  function ledDigit(svg, x, s) {
    const g = document.createElementNS(NSV, 'g'), d = { was: null };
    g.setAttribute('transform', 'translate(' + (x + 2) + ',' + (100 * (1 - s)) + ') scale(' + s + ') skewX(-5)');
    Object.keys(LSEG).forEach(k => { const p = document.createElementNS(NSV, 'polygon'); p.setAttribute('points', LSEG[k]); g.appendChild(p); d[k] = p; });
    svg.appendChild(g);
    return d;
  }
  function ledDot(svg, x, y, r) { const c = document.createElementNS(NSV, 'circle'); c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('r', r); svg.appendChild(c); return c; }
  function ledSet(d, ch) {
    if (d.was === ch) return;
    d.was = ch;
    const lit = ch == null || ch === ' ' ? '' : LDIG[+ch];
    Object.keys(LSEG).forEach(k => d[k].classList.toggle('on', lit.indexOf(k) > -1));
  }
  const T = { m: ledDigit(led, 0, 1), s1: ledDigit(led, 88, 1), s2: ledDigit(led, 152, 1), t: ledDigit(led, 228, 0.6) };
  [ledDot(led, 76, 32, 6), ledDot(led, 76, 68, 6), ledDot(led, 222, 90, 4.5)].forEach(c => c.classList.add('on'));
  const scaleLed = $('#tmScaleLed'), SC = [0, 64, 128, 192].map(x => ledDigit(scaleLed, x, 1));
  let lastSec = -1;
  function paintClock(s) {
    s = Math.min(s, 599.9);
    const whole = Math.floor(s), m = Math.floor(whole / 60), sec = whole % 60;
    ledSet(T.m, String(m)); ledSet(T.s1, String(Math.floor(sec / 10))); ledSet(T.s2, String(sec % 10)); ledSet(T.t, String(Math.floor(s * 10) % 10));
    if (whole !== lastSec) { lastSec = whole; led.setAttribute('aria-label', 'Brew time ' + m + (m === 1 ? ' minute ' : ' minutes ') + sec + (sec === 1 ? ' second' : ' seconds')); }
  }
  function paintScale(v) {
    const str = String(Math.max(0, Math.min(9999, Math.round(v))));
    SC.forEach((d, i) => ledSet(d, str[i - (4 - str.length)]));
  }

  /* ---- the recipe: ours to start with, and three numbers you can nudge the way the store's tool lets you ---- */
  function recipeReset() { const d = base(); st.cups = 1; st.ratio = d.ratio; st.dose = d.dose; st.yld = d.yield; st.touched = false; }
  function adjust(what, dir) {
    const d = base();
    if (what === 'dose') { st.dose = clamp(st.dose + dir * d.ds, 1, 150); st.yld = Math.round(st.dose * st.ratio * 10) / 10; }
    else if (what === 'yield') { st.yld = clamp(st.yld + dir * d.ys, 1, 3000); st.dose = Math.round(st.yld / st.ratio * 10) / 10; }
    else if (what === 'ratio') { st.ratio = clamp(Math.round((st.ratio + dir * d.rs) * 100) / 100, 0.5, 25); st.yld = Math.round(st.dose * st.ratio * 10) / 10; }
    else if (what === 'cups') { if (!d.hasCups) return; st.cups = clamp(st.cups + dir, 1, 10); st.dose = Math.round(d.dose * st.cups * 10) / 10; st.yld = Math.round(st.dose * st.ratio * 10) / 10; }
    st.touched = st.cups !== 1 || Math.abs(st.dose - d.dose) > 0.01 || Math.abs(st.yld - d.yield) > 0.5 || Math.abs(st.ratio - d.ratio) > 0.001;
    SFX.tick(); paintRecipe(); paintPlays(); paintHow(); paintIdle();
  }
  /* the timed stages for this coffee and method, with every weight scaled to the water you're actually using */
  function buildList() {
    const d = base(), G = R.G[coffee().recipe] && R.G[coffee().recipe][st.m];
    if (!G) return null;
    const k = st.yld / d.yield;
    let poured = 0, flip = false;
    return G.map(g => {
      const end = /^DONE/.test(g[1]);
      const title = g[1].replace(/(\d+)G\b/g, (m, n) => Math.round(+n * k) + 'G');
      const sub = /^\d+G AT \d+°C$/.test(g[3]) ? Math.round(st.yld) + 'G AT ' + d.temp + '°C' : g[3];
      const grams = /(\d+)G\b/.exec(g[1]);
      const act = end ? 'done' : /FLIP/.test(g[1]) ? 'flip' : /PLUNGE|PRESS/.test(g[1]) ? 'press' : /^POUR GENTLY/.test(g[1]) ? 'serve' : /POUR|BLOOM/.test(g[1]) ? 'pour' : /SWIRL|STIR/.test(g[1]) ? 'swirl' : /LID/.test(g[1]) ? 'lid' : 'wait';
      const p = { t: g[0], title: nice(title), sub: nice(sub), act: act, end: end, from: poured, target: poured, flipped: flip };
      if (act === 'pour') { p.target = grams ? Math.round(+grams[1] * k) : Math.round(st.yld); poured = p.target; }
      if (act === 'flip') { flip = true; p.flipped = true; }
      p.stir = /STIR/.test(g[1]);
      return p;
    });
  }
  /* a recipe line with its numbers marked */
  function rich(parent, line) {
    nice(line.replace(/%D/g, num1(st.dose)).replace(/%Y/g, Math.round(st.yld)).replace(/<span class="h">(.*?)<\/span>/g, '{{$1}}')).split(/(\{\{.*?\}\})/).forEach(part => {
      const m = /^\{\{(.*)\}\}$/.exec(part);
      if (m) parent.appendChild(mk('em', '', m[1])); else if (part) parent.appendChild(document.createTextNode(part));
    });
  }
  function paintRecipe() {
    const d = base(), c = coffee();
    $('#tmFor').textContent = c.name + ', ' + (st.m === 'aero' ? 'AeroPress' : BREW_METHOD[st.m] === 'V60' ? 'V60' : BREW_METHOD[st.m].toLowerCase());
    const adj = $('#tmAdj'); adj.textContent = '';
    [['dose', 'Dose', num1(st.dose) + 'g'], ['yield', d.yl === 'WATER' ? 'Water' : 'Yield', Math.round(st.yld) + 'g'], ['ratio', 'Ratio', ratioText()]].forEach(a => {
      const row = mk('div'), dt = mk('dt', '', a[1]), dd = mk('dd');
      const minus = mk('button', '', '−'), val = mk('b', '', a[2]), plus = mk('button', '', '+');
      minus.type = plus.type = 'button'; minus.dataset.tmAdj = a[0]; minus.dataset.d = '-1'; plus.dataset.tmAdj = a[0]; plus.dataset.d = '1';
      minus.setAttribute('aria-label', 'Less ' + a[1].toLowerCase()); plus.setAttribute('aria-label', 'More ' + a[1].toLowerCase());
      dd.append(minus, val, plus); row.append(dt, dd); adj.appendChild(row);
    });
    const fx = $('#tmFixed'); fx.textContent = '';
    [['Temp', d.temp + '°C'], ['Grind', nice(d.grind)], ['Time', /-/.test(d.time) ? d.time + 's' : d.time]].forEach(f => { const row = mk('div'); row.append(mk('dt', '', f[0]), mk('dd', '', f[1])); fx.appendChild(row); });
    $('#tmCups').hidden = !d.hasCups; $('#tmCupsN').textContent = st.cups;
    $('#tmBack').hidden = !st.touched;
    $('#tmSo').hidden = c.b > -1;
    const prep = $('#tmPrep'); prep.textContent = '';
    R.STEPS[c.recipe][st.m].slice(0, METH[st.m].prep).forEach(line => { const li = mk('li'); rich(li, line); prep.appendChild(li); });
  }
  function paintPlays() {
    const d = base(), c = coffee();
    st.list = buildList();
    playsEl.textContent = ''; ticks.textContent = '';
    if (st.list) {
      const total = st.list[st.list.length - 1].t;
      st.list.forEach((p, i) => {
        const li = mk('li'); li.append(mk('b', '', mmss(p.t)));
        const sp = mk('span', '', p.end ? 'Full time' : p.title); sp.appendChild(mk('small', '', p.sub)); li.appendChild(sp);
        playsEl.appendChild(li);
        if (i && !p.end) { const tk = mk('i'); tk.style.left = (p.t / total * 100) + '%'; ticks.appendChild(tk); }
      });
      $('#tmTotal').textContent = mmss(total) + ' start to finish';
      $('#tmTgt').textContent = 'Full time at ' + mmss(total);
    } else {
      R.STEPS[c.recipe][st.m].slice(METH[st.m].prep).forEach((line, i) => { const li = mk('li', 'plain'); li.append(mk('b', '', String(i + 1))); const sp = mk('span'); rich(sp, line); li.appendChild(sp); playsEl.appendChild(li); });
      $('#tmTotal').textContent = 'Stop at ' + Math.round(st.yld) + 'g';
      $('#tmTgt').textContent = 'Target ' + d.tMin + ' to ' + d.tMax + ' seconds';
      const span = d.tMax + 10;
      zone.style.left = (d.tMin / span * 100) + '%'; zone.style.width = ((d.tMax - d.tMin) / span * 100) + '%';
    }
    $('#tmTip').textContent = nice(c.b > -1 ? R.TIPS[c.recipe][st.m] : SINGLE_TIPS[st.m]);
    $('#tmFix').textContent = nice(R.TROUBLE[st.m]) + '.';
  }
  /* the back of the recipe card: what you need and how the method goes, with this coffee's own times dropped in */
  function paintHow() {
    const h = HOWTO[st.m];
    if (!h) return;
    const name = st.m === 'aero' ? 'AeroPress' : st.m === 'v60' ? 'V60' : BREW_METHOD[st.m].toLowerCase();
    const L = st.list || [], at = L.find(p => p.act === 'press' || p.act === 'flip'), first = L.find(p => p.act === 'pour');
    const fill = t => t.replace(/\{t\}/g, at ? mmss(at.t) : 'the call').replace(/\{g\}/g, first ? first.target : 30);
    $('#tmHowFor').textContent = st.m === 'aero' ? 'AeroPress' : BREW_METHOD[st.m];
    $('#tmHowLine').textContent = h.line;
    const need = $('#tmNeed'); need.textContent = '';
    h.need.forEach(n => need.appendChild(mk('li', '', n)));
    need.appendChild(mk('li', 'g', 'Grind: ' + h.grind));
    const ol = $('#tmHow'); ol.textContent = '';
    h.steps.forEach(x => { const li = mk('li'); li.append(mk('b', '', x[0] + '. '), document.createTextNode(fill(x[1]))); ol.appendChild(li); });
    const fx = $('#tmHowFix'); fx.textContent = ''; fx.append(mk('b', '', 'If it\'s not right'), document.createTextNode(h.fix));
    $('#tmHowBtn').textContent = 'New to ' + name + '? See how to brew it';
  }
  const card = $('#tmCard'), faceA = $('#tmFaceA'), faceB = $('#tmFaceB');
  function face(which, focus) {
    if (st.face === which) return;
    st.face = which;
    const swap = () => {
      faceA.hidden = which !== 'recipe'; faceB.hidden = which !== 'how';
      card.dataset.face = which; $('#tmFlip').setAttribute('aria-expanded', String(which === 'how'));
      if (focus) (which === 'how' ? $('#tmFlipBack') : $('#tmFlip')).focus({ preventScroll: true });
    };
    if (RM) { swap(); return; }
    card.classList.remove('turning'); void card.offsetWidth; card.classList.add('turning');
    setTimeout(swap, 180); setTimeout(() => card.classList.remove('turning'), 400);
    SFX.spin(0.5);
  }
  /* a song steps back for a moment so a call can be heard over it */
  const dip = () => { try { if (Music.isPlaying()) Music.duck(1500); } catch (err) {} };
  /* everything that shows which coffee and method are picked */
  function paintPick() {
    const c = coffee();
    el.dataset.c = c.key; el.dataset.m = st.m;
    $$('[data-tm-c]', el).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tmC === st.c)));
    $$('[data-tm-m]', el).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tmM === st.m)));
    $('#tmBrewerImg').src = pic(METH[st.m].art);
    $('#tmBag').src = pic(c.bag);
    const notes = $('#tmNotes'); notes.textContent = '';
    (CUP_NOTES[c.key] || []).forEach((n, i) => {
      const f = mk('div', 'tm-note'); f.style.setProperty('--i', i);
      const im = mk('img'); im.src = pic(n[0]); im.alt = '';
      f.append(im, mk('span', '', n[1])); notes.appendChild(f);
    });
  }

  /* ---- the coach's call, the word on the bench, a voice if asked ---- */
  function call(now, sub, bump) {
    if (nowEl.textContent !== now) { nowEl.textContent = now; if (bump) { nowEl.classList.remove('in'); void nowEl.offsetWidth; nowEl.classList.add('in'); coach.classList.remove('tm-hop'); void coach.offsetWidth; coach.classList.add('tm-hop'); } }
    subEl.textContent = sub || '';
  }
  const DOODLE = { down: ['M34 6C38 24 37 42 35 58', 'M20 44l15 16 14-17'], swirl: ['M52 36A18 18 0 1 1 36 16', 'M27 8l10 8-9 9'], flip: ['M12 50C8 14 58 10 58 44', 'M47 36l11 12 8-14'] };
  function shout(kind, word) {
    const d = DOODLE[kind] || ['', ''];
    $('#tmShA').setAttribute('d', d[0]); $('#tmShB').setAttribute('d', d[1]);
    $('.doodle', shoutEl).style.display = kind ? '' : 'none';
    $('#tmShW').textContent = word || '';
    shoutEl.classList.remove('on');
    if (word) { void shoutEl.offsetWidth; shoutEl.classList.add('on'); }
  }
  function say(text) {
    if (!st.voice || !window.speechSynthesis) return;
    try {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(String(text).replace(/(\d+)g\b/g, '$1 grams').replace(/°C/g, ' degrees').replace(/(\d+):(\d+)/g, '$1 $2'));
      u.lang = 'en-AU'; u.rate = 1.02; window.speechSynthesis.speak(u);
    } catch (err) {}
  }
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (err) {} }
  function setAct(a) { if (st.act !== a) { st.act = a; el.dataset.act = a; } }
  function confetti() {
    const box = $('#tmConf'), cols = ['#FF69AE', '#D2F55C', '#C888F8', '#8CCDE3', '#F27B20', '#ffffff'];
    box.textContent = '';
    if (RM) return;
    for (let i = 0; i < 30; i++) {
      const a = Math.random() * Math.PI * 2, r = 120 + Math.random() * 240, n = mk('i');
      n.style.setProperty('--x', Math.round(Math.cos(a) * r) + 'px'); n.style.setProperty('--y', Math.round(Math.sin(a) * r - 80) + 'px');
      n.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg'); n.style.setProperty('--c', cols[i % cols.length]);
      n.style.animationDelay = (Math.random() * 0.12) + 's';
      box.appendChild(n);
    }
    setTimeout(() => { box.textContent = ''; }, 1700);
  }

  /* ---- the clock ---- */
  let raf = 0, bg = 0, lock = null;
  function wake(v) {
    try {
      if (v && navigator.wakeLock && !lock) navigator.wakeLock.request('screen').then(l => { lock = l; if (st.run !== 1) wake(false); }, () => {});
      else if (!v && lock) { lock.release().catch(() => {}); lock = null; }
    } catch (err) {}
  }
  function setState() {
    el.dataset.state = ['idle', 'run', 'paused', 'done'][st.run];
    goBtn.textContent = st.run === 1 ? (st.list ? 'Pause' : 'Stop the shot') : st.run === 2 ? 'Carry on' : st.run === 3 ? 'Go again' : 'Start the clock';
    rsBtn.disabled = st.run === 1 || (st.run === 0 && st.ms === 0);
    $$('.tm-picks button:not(.tm-howlink), .tm-recipe button:not(.tm-flip)', el).forEach(b => { if (st.run === 1) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });   /* no swapping coffee mid-brew */
    el.classList.toggle('steamy', st.run === 3 || (st.run === 1 && /^(wait|swirl|lid|press|serve)$/.test(st.act)));
  }
  function paintIdle() {
    /* nothing running: the clock at zero, the scale ready, the first call waiting */
    const d = base();
    paintClock(0); lastSec = -1;
    fill.style.width = '0%';
    clock.dataset.zone = 'pre'; st.zone = 'pre';
    setAct('idle'); el.classList.remove('flipped');
    stage.style.setProperty('--fill', '0');
    shout('', '');
    nextEl.hidden = true;
    $$('li', playsEl).forEach(li => { li.classList.remove('on', 'past'); });
    if (st.list) {
      $('#tmScaleK').textContent = 'Scale should read';
      paintScale(0);
      call('Press start', 'First up: ' + st.list[0].title.replace(/^./, ch => ch.toLowerCase()) + '.');
    } else {
      $('#tmScaleK').textContent = 'Stop the shot at';
      paintScale(st.yld);
      call('Press start', 'Start the clock as the pump goes on.');
    }
    setState();
  }
  function reset() {
    cancelAnimationFrame(raf); clearInterval(bg); wake(false);
    st.run = 0; st.ms = 0; st.stage = -1; st.count = -1;
    hideDone();
    paintIdle();
  }
  function enter(i) {
    const p = st.list[i], first = st.stage === -1;
    st.stage = i; st.count = -1;
    $$('li', playsEl).forEach((li, k) => { li.classList.toggle('on', k === i); li.classList.toggle('past', k < i); });
    el.classList.toggle('flipped', p.flipped);
    if (p.end) { finish(); return; }
    call(p.title, p.sub, true);
    if (!first) { SFX.clock(() => SFX.beep(true)); buzz([12, 40, 12]); dip(); }
    say(p.title + '. ' + p.sub);
  }
  const WORD = { press: ['down', 'slow and steady'], flip: ['flip', 'flip it'], lid: ['down', 'lid on'], serve: ['', 'pour gently'] };
  function frame() {
    if (st.run !== 1) return;
    const ms = performance.now() - st.t0, s = ms / 1000, d = base();
    st.ms = ms;
    paintClock(s);
    if (st.list) {
      const L = st.list, total = L[L.length - 1].t;
      let i = 0;
      for (let k = L.length - 1; k >= 0; k--) if (s >= L[k].t) { i = k; break; }
      if (i !== st.stage) { enter(i); if (st.run !== 1) return; }
      const p = L[i], nx = L[i + 1], left = nx ? nx.t - s : 0;
      let act = p.act, reading = p.target;
      if (p.act === 'pour') {
        const win = clamp((nx ? nx.t - p.t : 12) * 0.66, 5, 20), k = clamp((s - p.t) / win, 0, 1);
        reading = lerp(p.from, p.target, ease(k));
        if (k >= 1) act = p.stir ? 'swirl' : 'wait';
      }
      if (act !== st.act) {
        setAct(act);
        const w = act === 'swirl' ? ['swirl', p.stir ? 'stir' : 'swirl'] : act === 'wait' ? ['', /draw/i.test(p.title) ? 'let it drip' : /settle/i.test(p.title) ? 'let it settle' : 'hands off'] : WORD[act] || ['', ''];
        shout(w[0], w[1]);
        setState();
      }
      paintScale(reading);
      fill.style.width = Math.min(100, s / total * 100) + '%';
      if (nx) {
        nextEl.hidden = false;
        const t = nx.end ? 'Full time in' : 'Next: ' + nx.title.replace(/^./, ch => ch.toLowerCase()) + ' in';
        if (nextT.textContent !== t) nextT.textContent = t;
        const c = Math.ceil(left), txt = mmss(c);
        if (nextIn.textContent !== txt) nextIn.textContent = txt;
        nextEl.classList.toggle('soon', left <= 3.05);
        /* three, two, one */
        if (c <= 3 && c >= 1 && c !== st.count) { st.count = c; SFX.clock(SFX.count); }
      }
    } else {
      const span = d.tMax + 10, z = s < d.tMin ? 'pre' : s <= d.tMax ? 'in' : 'over';
      fill.style.width = Math.min(100, s / span * 100) + '%';
      stage.style.setProperty('--fill', clamp((s - 4) / (d.tMin - 4), 0, 1).toFixed(3));
      if (z !== st.zone) {
        st.zone = z; clock.dataset.zone = z;
        if (z === 'in') { call('In the window', 'Stop when the scale reads ' + Math.round(st.yld) + 'g.', true); SFX.clock(() => SFX.beep(true)); buzz(20); dip(); say('In the window'); }
        else if (z === 'over') { call('Running long', 'Stop the shot.', true); SFX.clock(() => SFX.beep(false)); buzz([20, 60, 20]); dip(); say('Running long. Stop the shot.'); }
      }
      const c = Math.ceil(d.tMin - s);
      if (z === 'pre' && c <= 3 && c >= 1 && c !== st.count) { st.count = c; SFX.clock(SFX.count); }
    }
  }
  function loop() { frame(); if (st.run === 1) raf = requestAnimationFrame(loop); }
  function start() {
    if (st.run === 1) return;
    if (st.run === 3) reset();
    const fresh = st.ms === 0;
    st.run = 1; st.t0 = performance.now() - st.ms;
    if (fresh) {
      if (loud()) SFX.clock(SFX.whistle); buzz(18);
      if (!st.list) { call('Stop at ' + Math.round(st.yld) + 'g', 'Aim for ' + base().tMin + ' to ' + base().tMax + ' seconds.', true); setAct('pull'); say('Stop at ' + Math.round(st.yld) + ' grams'); }
      if (!loud() && !st.hinted) { st.hinted = true; toast('Turn on Beeps to hear every call'); }
    } else { SFX.toggle(); if (!st.list) setAct('pull'); }
    setState(); wake(true);
    cancelAnimationFrame(raf); clearInterval(bg);
    loop();
    bg = setInterval(frame, 250);   /* keeps the calls coming when the screen isn't being drawn */
  }
  function pause() {
    if (st.run !== 1) return;
    st.ms = performance.now() - st.t0; st.run = 2;
    cancelAnimationFrame(raf); clearInterval(bg); wake(false);
    setAct('idle'); shout('', '');
    setState(); SFX.toggle();
  }
  function finish() {
    const d = base(), s = st.ms / 1000;
    st.run = 3;
    cancelAnimationFrame(raf); clearInterval(bg); wake(false);
    setAct('done'); shout('', ''); nextEl.hidden = true;
    let verdict, ok = true;
    if (st.list) { fill.style.width = '100%'; verdict = 'That\'s the recipe, start to finish.'; call('Full time', 'Pour it and drink it.', true); }
    else if (s < d.tMin) { ok = false; verdict = 'Too quick. Grind finer next time.'; call('Too quick', 'Grind finer.', true); }
    else if (s > d.tMax) { ok = false; verdict = 'That ran long. Grind coarser next time.'; call('Ran long', 'Grind coarser.', true); }
    else { verdict = 'Right in the window.'; call('Nice shot', 'Right in the window.', true); }
    if (ok) { if (loud()) SFX.clock(SFX.buzzer); setTimeout(() => SFX.success(), 500); confetti(); } else SFX.error();
    dip();
    buzz([30, 60, 30, 60, 60]); say(ok ? 'Full time. ' + verdict : verdict);
    setState();
    $('#tmDoneK').textContent = st.list ? 'Full time' : ok ? 'Nice shot' : 'Not quite';
    $('#tmDoneT').textContent = st.list ? mmss(s) : (Math.floor(s * 10) / 10).toFixed(1) + 's';
    $('#tmDoneV').textContent = verdict;
    paintTaste();
    setTimeout(() => { if (st.run === 3) showDone(); }, RM ? 200 : 1300);
  }
  /* what went wrong, in the recipe's own words: "sour = grind finer" becomes a button and an answer */
  function paintTaste() {
    const c = coffee(), box = $('#tmTaste'), ans = $('#tmTasteA');
    box.textContent = ''; ans.textContent = '';
    const opts = [['Spot on', 'That\'s the one. Same again tomorrow.']].concat(R.TROUBLE[st.m].split('|').map(x => { const p = x.split('='); return [nice(p[0].trim()), 'Next time: ' + nice(p[1].trim()).replace(/^./, ch => ch.toLowerCase()) + '.']; }));
    opts.forEach(o => {
      const b = mk('button', '', o[0]); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', () => { $$('button', box).forEach(x => x.setAttribute('aria-pressed', String(x === b))); ans.textContent = o[1]; SFX.toggle(); });
      box.appendChild(b);
    });
    const cup = $('#tmCupN'), notes = CUP_NOTES[c.key] || [];
    cup.textContent = '';
    notes.forEach(n => { const f = mk('figure'); const im = mk('img'); im.src = pic(n[0]); im.alt = ''; f.append(im, mk('figcaption', '', n[1])); cup.appendChild(f); });
    $('#tmCup').hidden = !notes.length;
    const shop = $('#tmShop');
    shop.textContent = 'Get more ' + c.short.replace('Everyday', 'People Everyday').replace('Brooklyn', 'No Sleep').replace(/^Decaf$/, 'decaf');
    shop.href = STORE_ROOT + 'products/' + c.handle + (c.b < 0 && CFG.view ? '?view=' + CFG.view : '');
    if (STORE_ROOT.indexOf('http') === 0) { shop.target = '_blank'; shop.rel = 'noopener'; }
  }
  function showDone() { done.classList.add('on'); done.setAttribute('aria-hidden', 'false'); inEl.inert = true; setTimeout(() => { const b = $('#tmAgain'); if (done.classList.contains('on')) b.focus({ preventScroll: true }); }, 80); }
  function hideDone() { done.classList.remove('on'); done.setAttribute('aria-hidden', 'true'); inEl.inert = false; }

  /* ---- built the first time it opens, so none of its pictures load before they're wanted ---- */
  function build() {
    if (st.built) return;
    st.built = true;
    const chip = (c, box) => { const b = mk('button', 'tm-chip'); b.type = 'button'; b.dataset.tmC = c.key; b.setAttribute('aria-pressed', 'false'); const im = mk('img'); im.src = pic(c.bag); im.alt = ''; const tg = mk('span', 'tm-tag'); tg.textContent = c.short; b.append(im, tg); box.appendChild(b); };
    COFFEES.forEach(c => chip(c, c.b > -1 ? $('#tmBlends') : $('#tmSingles')));
    Object.keys(METH).forEach(m => { const b = mk('button', 'tm-meth'); b.type = 'button'; b.dataset.tmM = m; b.setAttribute('aria-pressed', 'false'); const im = mk('img'); im.src = pic(METH[m].art); im.alt = ''; const tg = mk('span', 'tm-tag'); tg.textContent = BREW_METHOD[m]; b.append(im, tg); $('#tmMeth').appendChild(b); });
    /* the pictures on the bench are made here, so nothing asks for them until the clock is opened */
    const im = (cls, id, name) => { const n = mk('img', cls); n.id = id; n.alt = ''; if (name) n.src = pic(name); return n; };
    stage.insertBefore(im('tm-bag', 'tmBag'), $('#tmNotes'));
    stage.insertBefore(im('tm-mug', 'tmMug', 'bw-mug'), $('#tmBrewer'));
    $('#tmBrewer').prepend(im('', 'tmBrewerImg'));
    stage.insertBefore(im('tm-kettle', 'tmKettle', 'bw-kettle'), $('.tm-scale', stage));
    coach = im('tm-coach', 'tmCoach', 'bw-coach'); $('.tm-call', el).prepend(coach);
    $('.tm-done-card', el).prepend(im('tm-done-art', 'tmDoneArt', 'bw-coach'));
    voiceTgl.hidden = !('speechSynthesis' in window && 'SpeechSynthesisUtterance' in window);
  }
  /* phones get the clock in two steps: what and how first, then the bench (desktop has room for both at once) */
  function sum() {
    const c = coffee(), mb = $('[data-tm-m="' + st.m + '"]', el);
    const a = $('#tmSumBag'), b = $('#tmSumMeth');
    if (a) a.src = pic(c.bag);
    if (b) b.src = pic(METH[st.m].art);
    $('#tmSumC').textContent = c.name;
    $('#tmSumM').textContent = (mb ? mb.textContent.trim() : '') + ', our recipe';
  }
  function step(s, focus) {
    el.dataset.step = s;
    sum();
    inEl.scrollTop = 0;
    if (focus) { const f = s === 'pick' ? $('[data-tm-c][aria-pressed="true"]', el) : goBtn; if (f) f.focus({ preventScroll: true }); }
  }
  function pick(c, m) {
    if (st.run === 1) return;
    if (c && COFFEES.some(x => x.key === c)) st.c = c;
    if (m && METH[m]) st.m = m;
    recipeReset();
    st.run = 0; st.ms = 0; st.stage = -1; st.count = -1;
    hideDone();
    paintPick(); paintRecipe(); paintPlays(); paintHow(); paintIdle(); sum();
    try { localStorage.setItem('cfl-brew', st.c + ',' + st.m); } catch (err) {}
  }
  /* the clock's own Beeps switch (6 Oct): no longer the Clicks switch in the bar */
  const syncSound = () => soundTgl.setAttribute('aria-pressed', String(loud()));

  /* ---- opening and closing: on the site it's one of the overlays; on a product page it looks after itself ---- */
  let opener2 = null;
  function shown(v) {
    if (MAIN) { if (v) openOv('brew'); else if (S.overlay === 'brew') closeOv(); return; }
    el.classList.toggle('open', v); el.setAttribute('aria-hidden', String(!v));
    document.body.classList.toggle('lock', v);
    if (v) document.body.dataset.ov = 'brew'; else delete document.body.dataset.ov;
    ['#main', '#top'].forEach(q => { const x = $(q); if (x) x.inert = v; });
    const bar = $('#ppBar'); if (bar) bar.inert = v || !bar.classList.contains('on');
    if (v) { opener2 = document.activeElement; SFX.whoosh(true); setTimeout(() => $('[data-close]', el).focus({ preventScroll: true }), 60); }
    else { SFX.close(); if (opener2 && opener2.focus) opener2.focus({ preventScroll: true }); }
  }
  function open(o) {
    o = o || {};
    build();
    let c = o.c, m = o.m;
    if (!c || !m) { try { const was = (localStorage.getItem('cfl-brew') || '').split(','); c = c || was[0]; m = m || was[1]; } catch (err) {} }
    if (st.run === 1 || st.run === 2) { /* a brew is on the go: leave it be */ }
    else pick(c || st.c, m || st.m);
    syncSound();
    step(st.run === 1 || st.run === 2 ? 'brew' : 'pick');   /* a brew on the go opens on the bench; otherwise start with the picks */
    shown(true);
    inEl.scrollTop = 0;
  }
  function close() { shown(false); }
  if (MAIN) OV.brew = el;
  /* however it closes (the cross, Escape, another overlay opening), a running clock stops where it is */
  let wasOpen = false;
  new MutationObserver(() => {
    const open = el.classList.contains('open');
    if (open === wasOpen) return;
    wasOpen = open;
    SFX.hush(open);            /* the waves, the street and the rest wait outside: in here it's the beeps and the voice */
    if (open) { syncSound(); return; }
    if (st.run === 1) pause();
    wake(false);
    try { if (window.speechSynthesis) window.speechSynthesis.cancel(); } catch (err) {}
    if (SFX.isOn() && !SFX.ambOn() && !SFX.fxOn()) soundPart('rest', false);   /* the sound only came on for the beeps: it goes quiet with the clock */
  }).observe(el, { attributes: true, attributeFilter: ['class'] });

  el.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-close]')) { e.stopPropagation(); close(); return; }
    if (t.closest('#tmLets')) { SFX.toggle(); step('brew', true); return; }
    if (t.closest('#tmChange')) { if (st.run === 1) return; SFX.toggle(); step('pick', true); return; }
    const cb = t.closest('[data-tm-c]'); if (cb) { if (cb.dataset.tmC !== st.c) { SFX.toggle(); pick(cb.dataset.tmC, null); } return; }
    const mb = t.closest('[data-tm-m]'); if (mb) { if (mb.dataset.tmM !== st.m) { SFX.toggle(); pick(null, mb.dataset.tmM); } return; }
    const ad = t.closest('[data-tm-adj]'); if (ad) { if (st.run === 0) adjust(ad.dataset.tmAdj, +ad.dataset.d); return; }
    const cu = t.closest('[data-tm-cups]'); if (cu) { if (st.run === 0) adjust('cups', +cu.dataset.tmCups); return; }
  });
  $('#tmBack').addEventListener('click', () => { if (st.run === 1) return; SFX.toggle(); pick(null, null); });
  goBtn.addEventListener('click', () => { if (st.run === 1) { if (st.list) pause(); else finish(); } else start(); });
  rsBtn.addEventListener('click', () => { SFX.toggle(); reset(); });
  $('#tmAgain').addEventListener('click', () => { SFX.toggle(); reset(); goBtn.focus({ preventScroll: true }); });
  $('#tmBench').addEventListener('click', () => { SFX.close(); hideDone(); rsBtn.focus({ preventScroll: true }); });
  $('#tmShop').addEventListener('click', e => {
    const c = coffee();
    if (MAIN && c.b > -1) { e.preventDefault(); reset(); close(); go('blends', c.b); }
    else if (!MAIN && typeof show === 'function') { e.preventDefault(); reset(); close(); show(c.key); window.scrollTo(0, 0); }
  });
  soundTgl.addEventListener('click', () => { soundPart('clock', !loud()); syncSound(); if (loud()) SFX.clock(SFX.count); });
  $('#tmFlip').addEventListener('click', () => face('how', true));
  $('#tmFlipBack').addEventListener('click', () => face('recipe', true));
  $('#tmHowBtn').addEventListener('click', () => { face('how'); setTimeout(() => card.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }), RM ? 0 : 200); });
  voiceTgl.addEventListener('click', () => { st.voice = !st.voice; voiceTgl.setAttribute('aria-pressed', String(st.voice)); SFX.toggle(); if (st.voice) say('Calling the plays'); else { try { window.speechSynthesis.cancel(); } catch (err) {} } });
  document.addEventListener('keydown', e => {
    if (!el.classList.contains('open')) return;
    if (e.key === 'Escape' && !MAIN) { close(); return; }
    /* space starts and stops the clock from anywhere on the bench */
    if (e.key === ' ' && !done.classList.contains('on') && !/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) { e.preventDefault(); goBtn.click(); }
  });
  /* anything on the page marked data-brew opens it, on that coffee if it names one */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-brew]');
    if (!b) return;
    e.preventDefault();
    open({ c: b.dataset.brew || undefined, m: b.dataset.brewM || undefined });
  });
  /* the clock in the section that introduces it: it runs a thirty second shot over and over while it's on screen */
  const demo = $('#brewitLed');
  if (demo) {
    const D = { m: ledDigit(demo, 0, 1), s1: ledDigit(demo, 88, 1), s2: ledDigit(demo, 152, 1), t: ledDigit(demo, 228, 0.6) };
    [ledDot(demo, 76, 32, 6), ledDot(demo, 76, 68, 6), ledDot(demo, 222, 90, 4.5)].forEach(c => c.classList.add('on'));
    const show = s => { const w = Math.floor(s); ledSet(D.m, '0'); ledSet(D.s1, String(Math.floor(w / 10))); ledSet(D.s2, String(w % 10)); ledSet(D.t, String(Math.floor(s * 10) % 10)); };
    let dt = 0, d0 = 0;
    show(28.4);
    if (!RM && 'IntersectionObserver' in window) new IntersectionObserver(en => {
      clearInterval(dt);
      if (en[0].isIntersecting) { d0 = performance.now(); dt = setInterval(() => { const s = ((performance.now() - d0) / 1000) % 33; show(Math.min(s, 30)); }, 100); }
    }, { threshold: 0.2 }).observe(demo);
  }
  /* a link straight to it */
  if (/^#brew\b/.test(location.hash)) { let n = 0; const wait = setInterval(() => { if (!MAIN || S.entered) { clearInterval(wait); setTimeout(() => open(), 700); } else if (++n > 600) clearInterval(wait); }, 200); }
  return { open: open, close: close, pick: pick, start: start, pause: pause, reset: reset, st: st, frame: frame, COFFEES: COFFEES };
})();
if (window.__cfl) window.__cfl.Brew = Brew;
if (window.__pp) window.__pp.Brew = Brew;

/* ---------- last on a product page: the radio carries on from the page before, and the scene's pieces can be poked ---------- */
Music.resume();
document.addEventListener('click', e => {
  const t = e.target.closest('.tap');
  if (!t) return;
  const target = t.classList.contains('el') ? $('.el-in', t) || t : t;
  target.classList.remove('poked'); void target.offsetWidth; target.classList.add('poked');
  setTimeout(() => target.classList.remove('poked'), 650);
  SFX.critter(t.dataset.crit);
  const r = t.getBoundingClientRect();
  burst(r.left + r.width / 2, r.top + r.height / 2, 5);
});
if (window.__pp) { window.__pp.Music = Music; window.__pp.Menu = Menu; }

})();

/* 9 Oct (Jos): on a wide screen (1500x801 up) the tasting stickers sit beside "Brew it right", at the foot of the words, not
   under the bag; narrower screens keep them under the bag. The page is marked html.tzw while they are moved. */
const tzWide = matchMedia('(min-width:1500px) and (min-height:801px)');
function placeTastes() {
  const wide = tzWide.matches;
  document.documentElement.classList.toggle('tzw', wide);
  document.querySelectorAll('.panel').forEach(p => {
    const tz = p.querySelector('.tastes'), bag = p.querySelector('.p-bag'), copy = p.querySelector('.p-copy');
    if (!tz || !bag || !copy) return;
    if (wide) {
      let row = copy.querySelector('.p-foot');
      if (!row) { const brew = copy.querySelector('.p-brew'); if (!brew) return; row = document.createElement('div'); row.className = 'p-foot'; brew.after(row); row.appendChild(brew); }
      if (tz.parentNode !== row) row.appendChild(tz);
    } else if (tz.parentNode !== bag) bag.appendChild(tz);
  });
}
placeTastes(); tzWide.addEventListener('change', placeTastes);
